/* eslint-disable max-lines */
export const stars = [
  { name: 'Sirius', ra: 6.752481, dec: -16.716116, vmag: -1.44 },
  { name: 'Canopus', ra: 6.399195, dec: -52.69566, vmag: -0.63 },
  { name: 'Rigil Kentaurus', ra: 14.660765, dec: -60.833976, vmag: -0.01 },
  { name: 'Vega', ra: 18.61564, dec: 38.783692, vmag: 0.03 },
  { name: 'Capella', ra: 5.27815, dec: 45.997991, vmag: 0.08 },
  { name: 'Arcturus', ra: 14.26103, dec: 19.18241, vmag: 0.16 },
  { name: 'Rigel', ra: 5.242298, dec: -8.20164, vmag: 0.28 },
  { name: 'Procyon', ra: 7.655033, dec: 5.224993, vmag: 0.4 },
  { name: 'Achernar', ra: 1.628556, dec: -57.236757, vmag: 0.54 },
  { name: 'Betelgeuse', ra: 5.919529, dec: 7.407063, vmag: 0.57 },
  { name: 'Hadar', ra: 14.063729, dec: -60.373039, vmag: 0.64 },
  { name: 'Altair', ra: 19.846388, dec: 8.868322, vmag: 0.93 },
  { name: 'Aldebaran', ra: 4.598677, dec: 16.509301, vmag: 0.99 },
  { name: 'Spica', ra: 13.419883, dec: -11.161322, vmag: 1.06 },
  { name: 'Antares', ra: 16.490128, dec: -26.432002, vmag: 1.07 },
  { name: 'Pollux', ra: 7.755277, dec: 28.026199, vmag: 1.22 },
  { name: 'Fomalhaut', ra: 22.960838, dec: -29.622236, vmag: 1.23 },
  { name: 'Acrux', ra: 12.443311, dec: -63.099092, vmag: 1.28 },
  { name: 'Mimosa', ra: 12.795359, dec: -59.688764, vmag: 1.31 },
  { name: 'Deneb', ra: 20.690532, dec: 45.280338, vmag: 1.33 },
  { name: 'α-Cen', ra: 14.660346, dec: -60.8383, vmag: 1.35 },
  { name: 'Regulus', ra: 10.139532, dec: 11.967207, vmag: 1.41 },
  { name: 'Adhara', ra: 6.977097, dec: -28.972084, vmag: 1.53 },
  { name: 'Castor', ra: 7.576634, dec: 31.888276, vmag: 1.58 },
  { name: 'Shaula', ra: 17.560145, dec: -37.103821, vmag: 1.63 },
  { name: 'Gacrux', ra: 12.519429, dec: -57.113212, vmag: 1.65 },
  { name: 'Bellatrix', ra: 5.418851, dec: 6.349702, vmag: 1.66 },
  { name: 'Miaplacidus', ra: 9.220041, dec: -69.717208, vmag: 1.67 },
  { name: 'Elnath', ra: 5.438198, dec: 28.60745, vmag: 1.68 },
  { name: 'Alnilam', ra: 5.603559, dec: -1.20192, vmag: 1.72 },
  { name: 'Alioth', ra: 12.900472, dec: 55.959821, vmag: 1.76 },
  { name: 'Alnair', ra: 22.137209, dec: -46.960975, vmag: 1.77 },
  { name: 'Mirfak', ra: 3.405378, dec: 49.86118, vmag: 1.81 },
  { name: 'Kaus Australis', ra: 18.402868, dec: -34.384616, vmag: 1.81 },
  { name: 'γ²-Vel', ra: 8.158876, dec: -47.336588, vmag: 1.82 },
  { name: 'Dubhe', ra: 11.062155, dec: 61.751033, vmag: 1.82 },
  { name: 'Wezen', ra: 7.139857, dec: -26.3932, vmag: 1.84 },
  { name: 'Alkaid', ra: 13.792354, dec: 49.313265, vmag: 1.86 },
  { name: 'Sargas', ra: 17.62198, dec: -42.997824, vmag: 1.86 },
  { name: 'Atria', ra: 16.811077, dec: -69.027715, vmag: 1.9 },
  { name: 'Alnitak', ra: 5.679313, dec: -1.942572, vmag: 1.9 },
  { name: 'Menkalinan', ra: 5.992149, dec: 44.947433, vmag: 1.9 },
  { name: 'Peacock', ra: 20.427459, dec: -56.73509, vmag: 1.92 },
  { name: 'Alhena', ra: 6.628528, dec: 16.399252, vmag: 1.93 },
  { name: 'δ-Vel', ra: 8.745059, dec: -54.708821, vmag: 1.94 },
  { name: 'Avior', ra: 8.375236, dec: -59.509483, vmag: 1.95 },
  { name: 'Mirzam', ra: 6.378329, dec: -17.955918, vmag: 1.96 },
  { name: 'Alphard', ra: 9.45979, dec: -8.658603, vmag: 1.98 },
  { name: 'Polaris', ra: 2.52975, dec: 89.264109, vmag: 2 },
  { name: 'Hamal', ra: 2.119555, dec: 23.462423, vmag: 2.02 },
  { name: 'Menkent', ra: 14.111395, dec: -36.369954, vmag: 2.05 },
  { name: 'Diphda', ra: 0.72649, dec: -17.986605, vmag: 2.05 },
  { name: 'Alpheratz', ra: 0.139791, dec: 29.090432, vmag: 2.06 },
  { name: 'Saiph', ra: 5.795941, dec: -9.669605, vmag: 2.06 },
  { name: 'Kochab', ra: 14.845105, dec: 74.155505, vmag: 2.06 },
  { name: 'Nunki', ra: 18.92109, dec: -26.296722, vmag: 2.07 },
  { name: 'Mirach', ra: 1.162194, dec: 35.620558, vmag: 2.07 },
  { name: 'Rasalhague', ra: 17.582241, dec: 12.560035, vmag: 2.09 },
  { name: 'Algol', ra: 3.136148, dec: 40.955648, vmag: 2.11 },
  { name: 'β-Gru', ra: 22.711115, dec: -46.884577, vmag: 2.12 },
  { name: 'Denebola', ra: 11.817663, dec: 14.57206, vmag: 2.13 },
  { name: 'Almach', ra: 2.064984, dec: 42.329725, vmag: 2.17 },
  { name: 'γ-Cas', ra: 0.945143, dec: 60.71674, vmag: 2.18 },
  { name: 'Suhail', ra: 9.133268, dec: -43.432589, vmag: 2.2 },
  { name: 'Sadr', ra: 20.370473, dec: 40.256679, vmag: 2.2 },
  { name: 'Naos', ra: 8.059737, dec: -40.003148, vmag: 2.22 },
  { name: 'Mizar', ra: 13.398747, dec: 54.925362, vmag: 2.22 },
  { name: 'Alphecca', ra: 15.578128, dec: 26.714693, vmag: 2.22 },
  { name: 'Mintaka', ra: 5.533445, dec: -0.299092, vmag: 2.23 },
  { name: 'Algieba', ra: 10.332873, dec: 19.841489, vmag: 2.23 },
  { name: 'Eltanin', ra: 17.943437, dec: 51.488895, vmag: 2.23 },
  { name: 'Schedar', ra: 0.675116, dec: 56.537331, vmag: 2.25 },
  { name: 'Aspidiske', ra: 9.284838, dec: -59.275229, vmag: 2.25 },
  { name: 'ε-Sco', ra: 16.83608, dec: -34.293232, vmag: 2.27 },
  { name: 'Caph', ra: 0.152887, dec: 59.14978, vmag: 2.28 },
  { name: 'ε-Cen', ra: 13.664796, dec: -53.466394, vmag: 2.28 },
  { name: 'α-Lup', ra: 14.698823, dec: -47.3882, vmag: 2.29 },
  { name: 'Dschubba', ra: 16.005557, dec: -22.62171, vmag: 2.3 },
  { name: 'η-Cen', ra: 14.591786, dec: -42.157824, vmag: 2.34 },
  { name: 'Merak', ra: 11.030677, dec: 56.382427, vmag: 2.35 },
  { name: 'Ankaa', ra: 0.438056, dec: -42.305981, vmag: 2.38 },
  { name: 'κ-Sco', ra: 17.708132, dec: -39.029983, vmag: 2.39 },
  { name: 'Enif', ra: 21.736433, dec: 9.875011, vmag: 2.39 },
  { name: 'Phecda', ra: 11.897168, dec: 53.69476, vmag: 2.39 },
  { name: 'Sabik', ra: 17.172968, dec: -15.72491, vmag: 2.43 },
  { name: 'Aludra', ra: 7.401584, dec: -29.303104, vmag: 2.46 },
  { name: 'ε-Cyg', ra: 20.770178, dec: 33.970256, vmag: 2.46 },
  { name: 'Alderamin', ra: 21.30963, dec: 62.585573, vmag: 2.47 },
  { name: 'Scheat', ra: 23.062901, dec: 28.082789, vmag: 2.48 },
  { name: 'κ-Vel', ra: 9.368562, dec: -55.010668, vmag: 2.48 },
  { name: 'Markab', ra: 23.079348, dec: 15.205264, vmag: 2.49 },
  { name: 'δ-Cen', ra: 12.13931, dec: -50.722425, vmag: 2.52 },
  { name: 'ζ-Cen', ra: 13.925667, dec: -47.288375, vmag: 2.53 },
  { name: 'Menkar', ra: 3.037992, dec: 4.089734, vmag: 2.54 },
  { name: 'Zosma', ra: 11.235138, dec: 20.523717, vmag: 2.56 },
  { name: 'ζ-Oph', ra: 16.619316, dec: -10.56709, vmag: 2.58 },
  { name: 'Arneb', ra: 5.545504, dec: -17.822289, vmag: 2.59 },
  { name: 'Gienah', ra: 12.263437, dec: -17.541929, vmag: 2.59 },
  { name: 'Zubeneschamali', ra: 15.283449, dec: -9.382917, vmag: 2.61 },
  { name: 'Ascella', ra: 19.043532, dec: -29.880105, vmag: 2.61 },
  { name: 'Acrab', ra: 16.09062, dec: -19.805453, vmag: 2.62 },
  { name: 'β-Lup', ra: 14.975537, dec: -43.13396, vmag: 2.62 },
  { name: 'Unukalhai', ra: 15.737798, dec: 6.425627, vmag: 2.63 },
  { name: 'α-Mus', ra: 12.619739, dec: -69.135564, vmag: 2.64 },
  { name: 'Lesath', ra: 17.512732, dec: -37.295811, vmag: 2.64 },
  { name: 'θ-Aur', ra: 5.995351, dec: 37.212585, vmag: 2.65 },
  { name: 'Sheratan', ra: 1.910668, dec: 20.808035, vmag: 2.66 },
  { name: 'Phact', ra: 5.660817, dec: -34.074108, vmag: 2.66 },
  { name: 'β-Crv', ra: 12.573121, dec: -23.396759, vmag: 2.66 },
  { name: 'ι-Aur', ra: 4.949894, dec: 33.16609, vmag: 2.66 },
  { name: 'Kaus Media', ra: 18.3499, dec: -29.828103, vmag: 2.68 },
  { name: 'Ruchbah', ra: 1.430216, dec: 60.235283, vmag: 2.68 },
  { name: 'Muphrid', ra: 13.911411, dec: 18.397717, vmag: 2.68 },
  { name: 'π-Pup', ra: 7.285711, dec: -37.09747, vmag: 2.69 },
  { name: 'Tarazed', ra: 19.770994, dec: 10.613261, vmag: 2.69 },
  { name: 'μ-Vel', ra: 10.779488, dec: -49.420255, vmag: 2.72 },
  { name: 'ι-Cen', ra: 13.343296, dec: -36.712295, vmag: 2.72 },
  { name: 'Zubenelgenubi', ra: 14.847977, dec: -16.041778, vmag: 2.73 },
  { name: 'Yed Prior', ra: 16.239094, dec: -3.694323, vmag: 2.73 },
  { name: 'η-Dra', ra: 16.39986, dec: 61.514213, vmag: 2.73 },
  { name: 'δ-Cru', ra: 12.252427, dec: -58.748928, vmag: 2.74 },
  { name: 'θ-Car', ra: 10.715949, dec: -64.39445, vmag: 2.74 },
  { name: 'Porrima', ra: 12.694345, dec: -1.449375, vmag: 2.74 },
  { name: 'Cebalrai', ra: 17.724543, dec: 4.567303, vmag: 2.75 },
  { name: 'τ-Sco', ra: 16.598043, dec: -28.216016, vmag: 2.78 },
  { name: 'ι-Ori', ra: 5.590551, dec: -5.909901, vmag: 2.78 },
  { name: 'Kornephoros', ra: 16.503668, dec: 21.489613, vmag: 2.78 },
  { name: 'Cursa', ra: 5.130829, dec: -5.086446, vmag: 2.79 },
  { name: 'β-Hyi', ra: 0.427916, dec: -77.254247, vmag: 2.79 },
  { name: 'Rastaban', ra: 17.507213, dec: 52.301387, vmag: 2.8 },
  { name: 'α-Ara', ra: 17.530695, dec: -49.876145, vmag: 2.8 },
  { name: 'β-Ara', ra: 17.421665, dec: -55.529884, vmag: 2.81 },
  { name: 'Kaus Borealis', ra: 18.466179, dec: -25.4217, vmag: 2.81 },
  { name: 'γ-Cen', ra: 12.691971, dec: -48.959888, vmag: 2.81 },
  { name: 'Vindemiatrix', ra: 13.036278, dec: 10.95915, vmag: 2.82 },
  { name: 'Tureis', ra: 8.125737, dec: -24.304324, vmag: 2.83 },
  { name: 'Algenib', ra: 0.220598, dec: 15.183596, vmag: 2.84 },
  { name: 'Nihal', ra: 5.470756, dec: -20.759441, vmag: 2.84 },
  { name: 'β-TrA', ra: 15.919083, dec: -63.430727, vmag: 2.84 },
  { name: 'γ-TrA', ra: 15.315181, dec: -68.679545, vmag: 2.85 },
  { name: 'α-Tuc', ra: 22.308371, dec: -60.259587, vmag: 2.85 },
  { name: 'ζ-Per', ra: 3.9022, dec: 31.883635, vmag: 2.85 },
  { name: 'ζ-Her', ra: 16.688113, dec: 31.602726, vmag: 2.85 },
  { name: 'δ-Cap', ra: 21.784011, dec: -16.127286, vmag: 2.85 },
  { name: 'α-Hyi', ra: 1.979451, dec: -61.569859, vmag: 2.86 },
  { name: 'O²-CMa', ra: 7.050409, dec: -23.833291, vmag: 3.01 },
  { name: 'Alcyone', ra: 3.79141, dec: 24.105137, vmag: 2.88 },
  { name: 'α-Gem', ra: 7.576827, dec: 31.89052, vmag: 2.88 },
  { name: 'Gomeisa', ra: 7.452512, dec: 8.289315, vmag: 2.89 },
  { name: 'Cor Caroli', ra: 12.933807, dec: 38.31838, vmag: 2.89 },
  { name: 'π-Sco', ra: 15.980865, dec: -26.114105, vmag: 2.89 },
  { name: 'Sadalsuud', ra: 21.525982, dec: -5.571172, vmag: 2.89 },
  { name: 'μ-Gem', ra: 6.382673, dec: 22.513586, vmag: 2.9 },
  { name: 'π-Sgr', ra: 19.162731, dec: -21.023615, vmag: 2.9 },
  { name: 'σ-Sco', ra: 16.353143, dec: -25.592796, vmag: 2.9 },
  { name: 'ε-Per', ra: 3.96423, dec: 40.010215, vmag: 2.91 },
  { name: 'δ-Cyg', ra: 19.749574, dec: 45.13081, vmag: 2.91 },
  { name: 'τ-Pup', ra: 6.832266, dec: -50.61456, vmag: 2.92 },
  { name: 'Matar', ra: 22.716704, dec: 30.221245, vmag: 2.93 },
  { name: 'Sadalmelik', ra: 22.096399, dec: -0.319851, vmag: 2.93 },
  { name: 'γ-Per', ra: 3.079942, dec: 53.50644, vmag: 2.94 },
  { name: 'ζ-Aql', ra: 19.090169, dec: 13.863478, vmag: 2.95 },
  { name: 'Zaurak', ra: 3.967157, dec: -13.508515, vmag: 2.96 },
  { name: 'Alnasl', ra: 18.096803, dec: -30.424091, vmag: 2.96 },
  { name: 'ε-Leo', ra: 9.764188, dec: 23.774255, vmag: 2.96 },
  { name: 'Algorab', ra: 12.497739, dec: -16.515432, vmag: 2.97 },
  { name: 'γ-Lup', ra: 15.585681, dec: -41.166757, vmag: 2.97 },
  { name: 'γ-Gru', ra: 21.898808, dec: -37.364852, vmag: 2.98 },
  { name: 'Mebsuta', ra: 6.732202, dec: 25.131124, vmag: 2.99 },
  { name: 'ψ-UMa', ra: 11.161062, dec: 44.498487, vmag: 2.99 },
  { name: 'υ-Car', ra: 9.785036, dec: -65.072007, vmag: 3 },
  { name: 'ζ-Tau', ra: 5.627413, dec: 21.142549, vmag: 3 },
  { name: 'γ-Hya', ra: 13.315359, dec: -23.171512, vmag: 3 },
  { name: 'μ¹-Sco', ra: 16.864509, dec: -38.04738, vmag: 3 },
  { name: 'β-Tri', ra: 2.159058, dec: 34.987297, vmag: 3 },
  { name: 'ι¹-Sco', ra: 17.793078, dec: -40.126997, vmag: 3 },
  { name: 'ε-Crv', ra: 12.168746, dec: -22.619766, vmag: 3.01 },
  { name: 'δ-Per', ra: 3.715416, dec: 47.787551, vmag: 3.02 },
  { name: 'Furud', ra: 6.338553, dec: -30.063367, vmag: 3.02 },
  { name: 'ε-Aur', ra: 5.032815, dec: 43.823308, vmag: 3.03 },
  { name: 'Pherkad', ra: 15.345483, dec: 71.834016, vmag: 3.03 },
  { name: 'Seginus', ra: 14.534636, dec: 38.308253, vmag: 3.04 },
  { name: 'Tania Australis', ra: 10.372155, dec: 41.499516, vmag: 3.04 },
  { name: 'Altais', ra: 19.209225, dec: 67.661541, vmag: 3.06 },
  { name: 'Albireo', ra: 19.512023, dec: 27.959681, vmag: 3.07 },
  { name: 'Dabih', ra: 20.350187, dec: -14.781367, vmag: 3.07 },
  { name: 'β-Mus', ra: 12.771346, dec: -68.108119, vmag: 3.08 },
  { name: 'λ-Cen', ra: 11.596363, dec: -63.019841, vmag: 3.1 },
  { name: 'κ-Cen', ra: 14.986025, dec: -42.104194, vmag: 3.1 },
  { name: 'α-Ind', ra: 20.626116, dec: -47.291502, vmag: 3.1 },
  { name: 'ζ-Ara', ra: 16.977006, dec: -55.990141, vmag: 3.1 },
  { name: 'ζ-Hya', ra: 8.92323, dec: 5.945563, vmag: 3.1 },
  { name: 'Sarin', ra: 17.250531, dec: 24.839204, vmag: 3.11 },
  { name: 'Wazn', ra: 5.849329, dec: -35.768309, vmag: 3.11 },
  { name: 'ν-Hya', ra: 10.827079, dec: -16.193648, vmag: 3.11 },
  { name: 'α-Lyn', ra: 9.350925, dec: 34.392562, vmag: 3.12 },
  { name: 'η-Sgr', ra: 18.293793, dec: -36.761686, vmag: 3.13 },
  { name: 'φ-Sgr', ra: 18.76094, dec: -26.990778, vmag: 3.13 },
  { name: 'π-Her', ra: 17.250788, dec: 36.809162, vmag: 3.14 },
  { name: 'Talitha', ra: 8.986828, dec: 48.041826, vmag: 3.14 },
  { name: 'ν-Pup', ra: 6.629353, dec: -43.195934, vmag: 3.15 },
  { name: 'α-Cir', ra: 14.708492, dec: -64.975138, vmag: 3.16 },
  { name: 'η-Aur', ra: 5.10858, dec: 41.234474, vmag: 3.17 },
  { name: 'ε-Lep', ra: 5.091018, dec: -22.371032, vmag: 3.17 },
  { name: 'δ-Lup', ra: 15.356201, dec: -40.647518, vmag: 3.18 },
  { name: 'π³-Ori', ra: 4.830669, dec: 6.961276, vmag: 3.18 },
  { name: 'θ-UMa', ra: 9.547715, dec: 51.6773, vmag: 3.18 },
  { name: 'ζ-Dra', ra: 17.146448, dec: 65.714683, vmag: 3.18 },
  { name: 'κ-Oph', ra: 16.961139, dec: 9.375033, vmag: 3.19 },
  { name: 'ζ-Cyg', ra: 21.215607, dec: 30.226916, vmag: 3.2 },
  { name: 'Errai', ra: 23.65582, dec: 77.632276, vmag: 3.21 },
  { name: 'Acamar', ra: 2.971023, dec: -40.304672, vmag: 3.22 },
  { name: 'Sulafat', ra: 18.982395, dec: 32.689557, vmag: 3.22 },
  { name: 'Alfirk', ra: 21.477662, dec: 70.560716, vmag: 3.23 },
  { name: 'η-Ser', ra: 18.355167, dec: -2.898825, vmag: 3.24 },
  { name: 'α-Pic', ra: 6.803194, dec: -61.941391, vmag: 3.24 },
  { name: 'Yed Posterior', ra: 16.305358, dec: -4.692511, vmag: 3.24 },
  { name: 'π-Hya', ra: 14.106193, dec: -26.682361, vmag: 3.25 },
  { name: 'θ-Aql', ra: 20.188413, dec: -0.821461, vmag: 3.25 },
  { name: 'σ-Pup', ra: 7.487179, dec: -43.301432, vmag: 3.25 },
  { name: 'α-Dor', ra: 4.566598, dec: -55.044975, vmag: 3.26 },
  { name: 'θ-Oph', ra: 17.366827, dec: -24.999545, vmag: 3.26 },
  { name: 'γ-Hyi', ra: 3.787295, dec: -74.238962, vmag: 3.26 },
  { name: 'δ-And', ra: 0.655462, dec: 30.861024, vmag: 3.27 },
  { name: 'Skat', ra: 22.910837, dec: -15.82082, vmag: 3.27 },
  { name: 'ω-Car', ra: 10.228961, dec: -70.037903, vmag: 3.28 },
  { name: 'σ-Lib', ra: 15.067839, dec: -25.281965, vmag: 3.28 },
  { name: 'μ-Lep', ra: 5.215528, dec: -16.205468, vmag: 3.29 },
  { name: 'Edasich', ra: 15.415494, dec: 58.966065, vmag: 3.3 },
  { name: 'Propus', ra: 6.247961, dec: 22.506799, vmag: 3.3 },
  { name: 'Megrez', ra: 12.257086, dec: 57.032617, vmag: 3.3 },
  { name: 'τ-Sgr', ra: 19.11567, dec: -27.670423, vmag: 3.3 },
  { name: 'Chertan', ra: 11.237335, dec: 15.42957, vmag: 3.3 },
  { name: 'ν-Oph', ra: 17.983775, dec: -9.773632, vmag: 3.32 },
  { name: 'η-Sco', ra: 17.202552, dec: -43.239189, vmag: 3.32 },
  { name: 'γ-Ara', ra: 17.423239, dec: -56.377727, vmag: 3.32 },
  { name: 'ξ-Pup', ra: 7.821571, dec: -24.859786, vmag: 3.32 },
  { name: 'α-Ret', ra: 4.240404, dec: -62.473858, vmag: 3.33 },
  { name: 'ξ-Gem', ra: 6.754824, dec: 12.895591, vmag: 3.33 },
  { name: 'Rasalgethi', ra: 17.244127, dec: 14.390333, vmag: 3.34 },
  { name: 'ζ-Cep', ra: 22.180908, dec: 58.201261, vmag: 3.34 },
  { name: 'ε-Cas', ra: 1.906584, dec: 63.670101, vmag: 3.35 },
  { name: 'ε-Lup', ra: 15.378021, dec: -44.689622, vmag: 3.35 },
  { name: 'δ-Aql', ra: 19.424972, dec: 3.114775, vmag: 3.36 },
  { name: 'Muscida', ra: 8.504431, dec: 60.718169, vmag: 3.36 },
  { name: 'β-Phe', ra: 1.101407, dec: -46.718414, vmag: 3.37 },
  { name: 'ν-Cen', ra: 13.825078, dec: -41.687709, vmag: 3.37 },
  { name: 'ρ-Per', ra: 3.08627, dec: 38.840274, vmag: 3.37 },
  { name: 'ζ-Vir', ra: 13.57822, dec: -0.59582, vmag: 3.38 },
  { name: 'θ²-Tau', ra: 4.477705, dec: 15.870883, vmag: 3.39 },
  { name: 'η-Lup', ra: 16.002036, dec: -38.396706, vmag: 3.39 },
  { name: 'η-Ori', ra: 5.407949, dec: -2.397146, vmag: 3.39 },
  { name: 'λ-Tau', ra: 4.011338, dec: 12.490347, vmag: 3.4 },
  { name: 'ζ-Lup', ra: 15.20476, dec: -52.099247, vmag: 3.4 },
  { name: 'Mothallah', ra: 1.884696, dec: 29.578829, vmag: 3.41 },
  { name: 'μ-Her', ra: 17.774319, dec: 27.720676, vmag: 3.41 },
  { name: 'β-Pav', ra: 20.749314, dec: -66.203212, vmag: 3.41 },
  { name: 'δ-Vir', ra: 12.926725, dec: 3.39747, vmag: 3.41 },
  { name: 'η-Cep', ra: 20.754811, dec: 61.838782, vmag: 3.42 },
  { name: 'ε-Hya', ra: 8.779587, dec: 6.418809, vmag: 3.42 },
  { name: 'Homam', ra: 22.691033, dec: 10.831364, vmag: 3.42 },
  { name: 'χ-Car', ra: 7.946313, dec: -52.98236, vmag: 3.42 },
  { name: 'μ-Cen', ra: 13.826943, dec: -42.473732, vmag: 3.43 },
  { name: 'Adhafera', ra: 10.278171, dec: 23.417311, vmag: 3.44 },
  { name: 'Tania Borealis', ra: 10.284952, dec: 42.914365, vmag: 3.44 },
  { name: 'λ-Aql', ra: 19.10415, dec: -4.882554, vmag: 3.44 },
  { name: 'γ-Phe', ra: 1.472759, dec: -43.318234, vmag: 3.44 },
  { name: 'η-Cet', ra: 1.143164, dec: -10.182264, vmag: 3.45 },
  { name: 'α-Tel', ra: 18.449561, dec: -45.968459, vmag: 3.45 },
  { name: 'η-Cas', ra: 0.81826, dec: 57.815187, vmag: 3.46 },
  { name: 'δ-Boo', ra: 15.258376, dec: 33.314833, vmag: 3.46 },
  { name: 'σ-CMa', ra: 7.028652, dec: -27.93483, vmag: 3.47 },
  { name: 'ε-Gru', ra: 22.809239, dec: -51.316864, vmag: 3.47 },
  { name: 'Nekkar', ra: 15.032436, dec: 40.390566, vmag: 3.48 },
  { name: 'η-Her', ra: 16.714933, dec: 38.922254, vmag: 3.48 },
  { name: 'Alula Borealis', ra: 11.307983, dec: 33.094306, vmag: 3.48 },
  { name: 'τ-Cet', ra: 1.734479, dec: -15.93748, vmag: 3.49 },
  { name: 'γ-Sge', ra: 19.979285, dec: 19.492148, vmag: 3.5 },
  { name: 'ι-Cep', ra: 22.82802, dec: 66.200408, vmag: 3.5 },
  { name: 'Sadalbari', ra: 22.833385, dec: 24.601579, vmag: 3.51 },
  { name: 'φ-Vel', ra: 9.947708, dec: -54.56779, vmag: 3.51 },
  { name: 'ξ²-Sgr', ra: 18.962167, dec: -21.106654, vmag: 3.51 },
  { name: 'Subra', ra: 9.685843, dec: 9.892308, vmag: 3.51 },
  { name: 'ι-Lup', ra: 14.323396, dec: -46.058093, vmag: 3.52 },
  { name: 'η-Leo', ra: 10.122209, dec: 16.762664, vmag: 3.52 },
  { name: 'β-Cnc', ra: 8.275256, dec: 9.185545, vmag: 3.52 },
  { name: 'δ-Eri', ra: 3.720806, dec: -9.763395, vmag: 3.53 },
  { name: 'ξ-Ser', ra: 17.626445, dec: -15.398557, vmag: 3.53 },
  { name: 'Meissa', ra: 5.585633, dec: 9.934158, vmag: 3.53 },
  { name: 'μ²-Sco', ra: 16.872263, dec: -38.017536, vmag: 3.53 },
  { name: 'Ain', ra: 4.476943, dec: 19.180431, vmag: 3.53 },
  { name: 'φ-Eri', ra: 2.275154, dec: -51.512165, vmag: 3.53 },
  { name: 'κ-CMa', ra: 6.830683, dec: -32.508478, vmag: 3.53 },
  { name: 'Biham', ra: 22.169996, dec: 6.197865, vmag: 3.53 },
  { name: 'ξ-Hya', ra: 11.550038, dec: -31.857625, vmag: 3.53 },
  { name: 'δ-Pav', ra: 20.145157, dec: -66.182068, vmag: 3.54 },
  { name: 'Wasat', ra: 7.335383, dec: 21.98232, vmag: 3.54 },
  { name: 'ι-Cet', ra: 0.323799, dec: -8.823921, vmag: 3.55 },
  { name: 'ζ-Lep', ra: 5.782595, dec: -14.82195, vmag: 3.55 },
  { name: 'μ-Ser', ra: 15.827002, dec: -3.430208, vmag: 3.55 },
  { name: 'υ⁴-Eri', ra: 4.298237, dec: -33.798348, vmag: 3.56 },
  { name: 'λ-Gem', ra: 7.30155, dec: 16.540383, vmag: 3.56 },
  { name: 'φ¹-Lup', ra: 15.36344, dec: -36.261376, vmag: 3.56 },
  { name: 'κ-Gem', ra: 7.740793, dec: 24.397993, vmag: 3.56 },
  { name: 'τ-Ori', ra: 5.293442, dec: -6.844409, vmag: 3.57 },
  { name: 'ρ-Boo', ra: 14.5305, dec: 30.371437, vmag: 3.57 },
  { name: 'γ-Cet', ra: 2.721678, dec: 3.235818, vmag: 3.57 },
  { name: 'δ-Crt', ra: 11.322347, dec: -14.778541, vmag: 3.57 },
  { name: 'χ-Dra', ra: 18.350736, dec: 72.732843, vmag: 3.57 },
  { name: 'δ-Ara', ra: 17.518318, dec: -60.683848, vmag: 3.57 },
  { name: 'κ-UMa', ra: 9.060427, dec: 47.156525, vmag: 3.58 },
  { name: 'Algedi', ra: 20.300904, dec: -12.544852, vmag: 3.58 },
  { name: '51-And', ra: 1.633205, dec: 48.628213, vmag: 3.58 },
  { name: 'ε-Cru', ra: 12.356031, dec: -60.401147, vmag: 3.58 },
  { name: 'C-Ari', ra: 2.833063, dec: 27.260507, vmag: 3.59 },
  { name: 'η-Pav', ra: 17.762221, dec: -64.723871, vmag: 3.59 },
  { name: 'θ-Gem', ra: 6.879816, dec: 33.961254, vmag: 3.59 },
  { name: 'Zavijava', ra: 11.844922, dec: 1.764718, vmag: 3.59 },
  { name: 'γ-Lep', ra: 5.741057, dec: -22.448382, vmag: 3.6 },
  { name: 'υ-Lib', ra: 15.61707, dec: -28.135079, vmag: 3.6 },
  { name: 'λ-Hya', ra: 10.176467, dec: -12.354083, vmag: 3.6 },
  { name: 'Atlas', ra: 3.819373, dec: 24.053415, vmag: 3.61 },
  { name: 'θ-Cet', ra: 1.40039, dec: -8.183257, vmag: 3.61 },
  { name: 'δ-Mus', ra: 13.037759, dec: -71.548855, vmag: 3.61 },
  { name: 'η-Psc', ra: 1.524725, dec: 15.345823, vmag: 3.61 },
  { name: 'O-Tau', ra: 3.413554, dec: 9.02887, vmag: 3.61 },
  { name: 'ζ²-Sco', ra: 16.909731, dec: -42.361313, vmag: 3.62 },
  { name: 'λ-Mus', ra: 11.760141, dec: -66.728763, vmag: 3.62 },
  { name: 'Sheliak', ra: 18.834665, dec: 33.362667, vmag: 3.63 },
  { name: 'ψ-Vel', ra: 9.511674, dec: -40.466769, vmag: 3.63 },
  { name: 'Rotanev', ra: 20.625816, dec: 14.595087, vmag: 3.63 },
  { name: 'O-And', ra: 23.032017, dec: 42.325979, vmag: 3.64 },
  { name: 'Nusakan', ra: 15.463818, dec: 29.105703, vmag: 3.64 },
  { name: 'β-Ind', ra: 20.913498, dec: -58.454155, vmag: 3.64 },
  { name: 'β-Ser', ra: 15.769793, dec: 15.421826, vmag: 3.64 },
  { name: 'θ-Ara', ra: 18.11052, dec: -50.091477, vmag: 3.64 },
  { name: 'γ-Tau', ra: 4.329889, dec: 15.627642, vmag: 3.65 },
  { name: 'α-Pyx', ra: 8.726539, dec: -33.186385, vmag: 3.65 },
  { name: 'H-UMa', ra: 9.525453, dec: 63.061861, vmag: 3.65 },
  { name: 'Thuban', ra: 14.073165, dec: 64.37585, vmag: 3.65 },
  { name: 'π⁴-Ori', ra: 4.853434, dec: 5.605104, vmag: 3.65 },
  { name: 'τ-Lib', ra: 15.64427, dec: -29.777754, vmag: 3.66 },
  { name: 'ζ-Cas', ra: 0.616188, dec: 53.896909, vmag: 3.68 },
  { name: 'γ-Vir', ra: 12.694171, dec: -1.449235, vmag: 3.68 },
  { name: 'Nashira', ra: 21.668181, dec: -16.662308, vmag: 3.68 },
  { name: 'C²-Aqr', ra: 23.157443, dec: -21.17241, vmag: 3.68 },
  { name: 'χ-UMa', ra: 11.767515, dec: 47.779406, vmag: 3.69 },
  { name: 'ξ-Her', ra: 17.962744, dec: 29.24788, vmag: 3.7 },
  { name: 'ε-Ser', ra: 15.846935, dec: 4.47773, vmag: 3.7 },
  { name: 'γ-Psc', ra: 23.286094, dec: 3.282289, vmag: 3.7 },
  { name: 'ξ-Cyg', ra: 21.082184, dec: 43.927852, vmag: 3.7 },
  { name: 'Electra', ra: 3.747927, dec: 24.113339, vmag: 3.71 },
  { name: 'π⁵-Ori', ra: 4.904193, dec: 2.440672, vmag: 3.71 },
  { name: 'χ-Eri', ra: 1.932564, dec: -51.608896, vmag: 3.71 },
  { name: '109-Vir', ra: 14.770812, dec: 1.892885, vmag: 3.72 },
  { name: 'Alshain', ra: 19.921887, dec: 6.406763, vmag: 3.72 },
  { name: 'η-Lep', ra: 5.940082, dec: -14.1677, vmag: 3.72 },
  { name: '72-Oph', ra: 18.122496, dec: 9.563847, vmag: 3.72 },
  { name: 'Ran', ra: 3.548848, dec: -9.458262, vmag: 3.72 },
  { name: 'δ-Aur', ra: 5.992111, dec: 54.284656, vmag: 3.73 },
  { name: 'Grumium', ra: 17.892134, dec: 56.872643, vmag: 3.73 },
  { name: 'Grumium', ra: 17.892134, dec: 56.872643, vmag: 3.73 },
  { name: 'ξ-Tau', ra: 3.45282, dec: 9.73268, vmag: 3.73 },
  { name: 'Baten Kaitos', ra: 1.857676, dec: -10.335038, vmag: 3.73 },
  { name: 'γ-Oph', ra: 17.798211, dec: 2.707276, vmag: 3.73 },
  { name: 'τ-Cyg', ra: 21.246517, dec: 38.045317, vmag: 3.74 },
  { name: 'γ-Her', ra: 16.365338, dec: 19.15313, vmag: 3.74 },
  { name: 'ν-Oct', ra: 21.691253, dec: -77.390046, vmag: 3.74 },
  { name: 'τ⁴-Eri', ra: 3.325278, dec: -21.757864, vmag: 3.74 },
  { name: 'ζ-Cap', ra: 21.444452, dec: -22.411332, vmag: 3.75 },
  { name: 'λ-Aqr', ra: 22.87691, dec: -7.579599, vmag: 3.75 },
  { name: 'γ²-Vol', ra: 7.145788, dec: -70.498932, vmag: 3.75 },
  { name: 'O-Sgr', ra: 19.07805, dec: -21.741496, vmag: 3.75 },
  { name: 'Albali', ra: 20.794598, dec: -9.495776, vmag: 3.76 },
  { name: 'δ-Tau', ra: 4.382247, dec: 17.542514, vmag: 3.76 },
  { name: 'ι-Cyg', ra: 19.495098, dec: 51.729779, vmag: 3.76 },
  { name: 'η-Per', ra: 2.844945, dec: 55.895496, vmag: 3.76 },
  { name: 'η-Ara', ra: 16.82976, dec: -59.041378, vmag: 3.76 },
  { name: 'β-Vol', ra: 8.428951, dec: -66.13689, vmag: 3.77 },
  { name: 'ζ-Aur', ra: 5.041301, dec: 41.075837, vmag: 3.77 },
  { name: 'ι-Peg', ra: 22.116847, dec: 25.345112, vmag: 3.77 },
  { name: 'ν-Per', ra: 3.753232, dec: 42.578549, vmag: 3.77 },
  { name: 'δ-Lep', ra: 5.855357, dec: -20.879089, vmag: 3.78 },
  { name: 'ι-Her', ra: 17.657747, dec: 46.006332, vmag: 3.78 },
  { name: 'υ-UMa', ra: 9.849867, dec: 59.038735, vmag: 3.78 },
  { name: 'Sualocin', ra: 20.660635, dec: 15.912072, vmag: 3.78 },
  { name: 'α-Lac', ra: 22.521515, dec: 50.282491, vmag: 3.78 },
  { name: 'ι-Gem', ra: 7.428779, dec: 27.79808, vmag: 3.78 },
  { name: 'κ-Cyg', ra: 19.28504, dec: 53.368459, vmag: 3.79 },
  { name: 'κ-Per', ra: 3.158258, dec: 44.857544, vmag: 3.79 },
  { name: 'φ-Cen', ra: 13.971186, dec: -42.100753, vmag: 3.79 },
  { name: '46-LMi', ra: 10.888526, dec: 34.214871, vmag: 3.79 },
  { name: 'σ-Ori', ra: 5.645769, dec: -2.600069, vmag: 3.8 },
  { name: 'V695 Cyg', ra: 20.227196, dec: 46.741329, vmag: 3.8 },
  { name: 'υ²-Eri', ra: 4.592512, dec: -30.562341, vmag: 3.81 },
  { name: 'α-Aps', ra: 14.797701, dec: -79.044751, vmag: 3.81 },
  { name: 'λ-Dra', ra: 11.523407, dec: 69.331076, vmag: 3.81 },
  { name: 'δ-Sge', ra: 19.789795, dec: 18.534286, vmag: 3.82 },
  { name: 'γ-Mus', ra: 12.541134, dec: -72.132988, vmag: 3.82 },
  { name: 'ρ-Leo', ra: 10.546853, dec: 9.306586, vmag: 3.82 },
  { name: 'β-Dor', ra: 5.560421, dec: -62.489825, vmag: 3.82 },
  { name: 'μ-Hya', ra: 10.434842, dec: -16.83629, vmag: 3.82 },
  { name: 'O-Her', ra: 18.125708, dec: 28.762488, vmag: 3.83 },
  { name: 'υ¹-Cen', ra: 13.977987, dec: -44.803584, vmag: 3.83 },
  { name: 'θ¹-Tau', ra: 4.476248, dec: 15.962181, vmag: 3.84 },
  { name: 'κ¹-Lup', ra: 15.198918, dec: -48.737819, vmag: 3.84 },
  { name: 'β-Ret', ra: 3.736593, dec: -64.806903, vmag: 3.84 },
  { name: 'μ-Sgr', ra: 18.229392, dec: -21.058834, vmag: 3.84 },
  { name: 'θ-Her', ra: 17.93755, dec: 37.250539, vmag: 3.84 },
  { name: 'δ-Col', ra: 6.368564, dec: -33.4364, vmag: 3.84 },
  { name: 'τ-Cen', ra: 12.628394, dec: -48.541304, vmag: 3.84 },
  { name: 'δ-TrA', ra: 16.257297, dec: -63.685682, vmag: 3.85 },
  { name: 'α-Sct', ra: 18.586785, dec: -8.244073, vmag: 3.85 },
  { name: 'O¹-CMa', ra: 6.902209, dec: -24.184211, vmag: 3.85 },
  { name: 'γ-CrB', ra: 15.712381, dec: 26.295637, vmag: 3.85 },
  { name: 'γ-Ser', ra: 15.940882, dec: 15.661617, vmag: 3.85 },
  { name: 'Sadachbia', ra: 22.360938, dec: -1.387331, vmag: 3.85 },
  { name: '109-Her', ra: 18.394967, dec: 21.769752, vmag: 3.85 },
  { name: 'α-Hor', ra: 4.233363, dec: -42.294368, vmag: 3.85 },
  { name: 'ρ-Sco', ra: 15.948077, dec: -29.214073, vmag: 3.85 },
  { name: 'β-Pic', ra: 5.788079, dec: -51.066514, vmag: 3.85 },
  { name: 'Maia', ra: 3.763779, dec: 24.367748, vmag: 3.86 },
  { name: 'θ-Hya', ra: 9.239405, dec: 2.31428, vmag: 3.86 },
  { name: 'ζ-UMa', ra: 13.398996, dec: 54.920471, vmag: 3.86 },
  { name: 'γ-Aps', ra: 16.557609, dec: -78.897148, vmag: 3.86 },
  { name: 'λ-And', ra: 23.626056, dec: 46.458152, vmag: 3.86 },
  { name: 'ε-Col', ra: 5.520209, dec: -35.470519, vmag: 3.86 },
  { name: 'τ-Her', ra: 16.329011, dec: 46.313366, vmag: 3.87 },
  { name: 'μ-And', ra: 0.945885, dec: 38.499345, vmag: 3.87 },
  { name: 'μ-Vir', ra: 14.717673, dec: -5.658207, vmag: 3.87 },
  { name: 'Zaniah', ra: 12.331766, dec: -0.666803, vmag: 3.87 },
  { name: 'Rasalas', ra: 9.879398, dec: 26.006951, vmag: 3.88 },
  { name: 'σ-Cen', ra: 12.467331, dec: -50.230635, vmag: 3.88 },
  { name: 'ν-Tau', ra: 4.052606, dec: 5.989305, vmag: 3.88 },
  { name: 'ε-Phe', ra: 0.156836, dec: -45.747426, vmag: 3.88 },
  { name: 'ι-Gru', ra: 23.17264, dec: -45.246711, vmag: 3.88 },
  { name: 'π-Cen', ra: 11.350117, dec: -54.491019, vmag: 3.89 },
  { name: 'κ-Dra', ra: 12.558058, dec: 69.788238, vmag: 3.89 },
  { name: 'ι-Hya', ra: 9.664267, dec: -1.14281, vmag: 3.89 },
  { name: 'ε-Her', ra: 17.004827, dec: 30.926405, vmag: 3.9 },
  { name: 'Azha', ra: 2.940458, dec: -8.898144, vmag: 3.9 },
  { name: 'η-Cyg', ra: 19.938438, dec: 35.083424, vmag: 3.9 },
  { name: 'L-Eri', ra: 4.63634, dec: -14.30402, vmag: 3.9 },
  { name: 'Atik', ra: 3.738648, dec: 32.288248, vmag: 3.91 },
  { name: 'ρ¹-Sgr', ra: 19.361211, dec: -17.847197, vmag: 3.91 },
  { name: 'α-For', ra: 3.201249, dec: -28.987618, vmag: 3.92 },
  { name: 'γ-Lib', ra: 15.592105, dec: -14.789537, vmag: 3.92 },
  { name: 'ν-Eri', ra: 4.605317, dec: -3.352459, vmag: 3.93 },
  { name: '38-Lyn', ra: 9.314069, dec: 36.802597, vmag: 3.93 },
  { name: 'ν-Cyg', ra: 20.952893, dec: 41.167136, vmag: 3.93 },
  { name: 'α-Mon', ra: 7.687454, dec: -9.551131, vmag: 3.93 },
  { name: 'ρ-Cen', ra: 12.194202, dec: -52.36846, vmag: 3.93 },
  { name: 'Asellus Australis', ra: 8.74475, dec: 18.154309, vmag: 3.93 },
  { name: 'κ-Phe', ra: 0.436716, dec: -43.679829, vmag: 3.94 },
  { name: 'η-Col', ra: 5.985778, dec: -42.815135, vmag: 3.94 },
  { name: 'Rukbat', ra: 19.398103, dec: -40.61594, vmag: 3.94 },
  { name: 'ε-Pav', ra: 20.009845, dec: -72.910504, vmag: 3.94 },
  { name: 'τ-Per', ra: 2.904295, dec: 52.762479, vmag: 3.94 },
  { name: 'δ-Phe', ra: 1.520851, dec: -49.072702, vmag: 3.94 },
  { name: 'Kitalpha', ra: 21.263731, dec: 5.247845, vmag: 3.94 },
  { name: 'χ-Lup', ra: 15.849316, dec: -33.627165, vmag: 3.94 },
  { name: 'Arkab Prior', ra: 19.377303, dec: -44.458965, vmag: 3.94 },
  { name: '50-Cas', ra: 2.057268, dec: 72.421294, vmag: 3.95 },
  { name: 'ω¹-Sco', ra: 16.113452, dec: -20.669192, vmag: 3.95 },
  { name: 'ζ-Vol', ra: 7.697004, dec: -72.606098, vmag: 3.95 },
  { name: 'μ¹-Cru', ra: 12.9099, dec: -57.177924, vmag: 3.96 },
  { name: 'Mekbuda', ra: 7.068481, dec: 20.570297, vmag: 3.96 },
  { name: 'ν²-CMa', ra: 6.611399, dec: -19.255879, vmag: 3.96 },
  { name: '67-Oph', ra: 18.010754, dec: 2.931568, vmag: 3.96 },
  { name: 'λ-Peg', ra: 22.775521, dec: 23.565654, vmag: 3.96 },
  { name: 'B¹-Aqr', ra: 23.382842, dec: -20.10058, vmag: 3.96 },
  { name: 'β-Pyx', ra: 8.668373, dec: -35.308352, vmag: 3.96 },
  { name: 'D-Eri', ra: 4.400613, dec: -34.016846, vmag: 3.96 },
  { name: 'η-Aql', ra: 19.874547, dec: 1.005661, vmag: 3.97 },
  { name: 'ν-Aur', ra: 5.858166, dec: 39.14848, vmag: 3.97 },
  { name: 'δ¹-Gru', ra: 22.487825, dec: -43.495565, vmag: 3.97 },
  { name: 'δ-Vol', ra: 7.280508, dec: -67.957152, vmag: 3.97 },
  { name: 'γ-Mon', ra: 6.247592, dec: -6.274776, vmag: 3.98 },
  { name: 'L-Pup', ra: 7.73013, dec: -28.954826, vmag: 3.98 },
  { name: 'Alcor', ra: 13.420413, dec: 54.987958, vmag: 3.99 },
  { name: 'ρ-Cyg', ra: 21.56635, dec: 45.591837, vmag: 3.99 },
  { name: 'γ-Tuc', ra: 23.290498, dec: -58.235734, vmag: 3.99 },
  { name: 'α-Vol', ra: 9.040777, dec: -66.396076, vmag: 4 },
  { name: 'γ-Tri', ra: 2.288573, dec: 33.847194, vmag: 4 },
  { name: 'υ-Cet', ra: 2.000084, dec: -21.077831, vmag: 4 },
  { name: 'V1488 Cyg', ra: 20.257867, dec: 47.714208, vmag: 4 },
  { name: 'θ-Dra', ra: 16.031532, dec: 58.565251, vmag: 4 },
  { name: '41-Cyg', ra: 20.489926, dec: 30.368555, vmag: 4 },
  { name: 'ζ-Phe', ra: 1.139742, dec: -55.24576, vmag: 4.01 },
  { name: 'γ²-Nor', ra: 16.330687, dec: -50.155508, vmag: 4.01 },
  { name: 'ζ-Pav', ra: 18.71726, dec: -71.428113, vmag: 4.01 },
  { name: 'MX Per', ra: 4.144357, dec: 47.712513, vmag: 4.01 },
  { name: 'I-Aql', ra: 19.028008, dec: -5.739115, vmag: 4.02 },
  { name: 'ε-Aql', ra: 18.993711, dec: 15.068298, vmag: 4.02 },
  { name: 'ι-Leo', ra: 11.398736, dec: 10.529509, vmag: 4.02 },
  { name: 'μ-Eri', ra: 4.758375, dec: -3.254657, vmag: 4.02 },
  { name: 'ω-CMa', ra: 7.246849, dec: -26.772667, vmag: 4.02 },
  { name: 'ω-Psc', ra: 23.988525, dec: 6.863321, vmag: 4.02 },
  { name: 'φ-Per', ra: 1.727675, dec: 50.688732, vmag: 4.02 },
  { name: 'γ-Pyx', ra: 8.842204, dec: -27.709844, vmag: 4.02 },
  { name: 'ρ-Lup', ra: 14.631454, dec: -49.425828, vmag: 4.02 },
  { name: 'μ-Cep', ra: 21.725127, dec: 58.780046, vmag: 4.02 },
  { name: 'ι-Cnc', ra: 8.778284, dec: 28.759898, vmag: 4.02 },
  { name: 'ζ-Cru', ra: 12.307298, dec: -64.003071, vmag: 4.03 },
  { name: 'Menkib', ra: 3.98275, dec: 35.791033, vmag: 4.03 },
  { name: 'ψ-Cen', ra: 14.342623, dec: -37.885295, vmag: 4.03 },
  { name: 'β-Cam', ra: 5.05697, dec: 60.442245, vmag: 4.03 },
  { name: 'Beid', ra: 4.197761, dec: -6.837581, vmag: 4.03 },
  { name: 'σ-Leo', ra: 11.352276, dec: 6.029322, vmag: 4.04 },
  { name: 'λ-Lup', ra: 15.147394, dec: -45.279857, vmag: 4.04 },
  { name: 'Alchiba', ra: 12.140225, dec: -24.728875, vmag: 4.04 },
  { name: 'ε-Del', ra: 20.553547, dec: 11.303263, vmag: 4.04 },
  { name: 'η-Aqr', ra: 22.589272, dec: -0.117498, vmag: 4.04 },
  { name: 'τ²-Aqr', ra: 22.826528, dec: -13.592632, vmag: 4.04 },
  { name: 'υ-Boo', ra: 13.824623, dec: 15.797905, vmag: 4.05 },
  { name: 'ν-Vir', ra: 11.764322, dec: 6.529376, vmag: 4.05 },
  { name: 'ι-Per', ra: 3.151005, dec: 49.613278, vmag: 4.05 },
  { name: 'θ-Boo', ra: 14.419967, dec: 51.850744, vmag: 4.05 },
  { name: 'α-Cha', ra: 8.308703, dec: -76.919722, vmag: 4.06 },
  { name: 'υ-Gem', ra: 7.598708, dec: 26.895741, vmag: 4.06 },
  { name: 'ε¹-Ara', ra: 16.993069, dec: -53.160438, vmag: 4.06 },
  { name: 'δ-Cet', ra: 2.658044, dec: 0.328511, vmag: 4.07 },
  { name: 'β-Cir', ra: 15.291917, dec: -58.801208, vmag: 4.07 },
  { name: 'δ-Hyi', ra: 2.362498, dec: -68.659418, vmag: 4.07 },
  { name: 'O²-Ori', ra: 4.939521, dec: 13.514466, vmag: 4.08 },
  { name: 'θ-CMa', ra: 6.903167, dec: -12.038628, vmag: 4.08 },
  { name: 'Alkes', ra: 10.996244, dec: -18.298783, vmag: 4.08 },
  { name: 'γ-Crt', ra: 11.414702, dec: -17.68401, vmag: 4.08 },
  { name: 'Syrma', ra: 14.266908, dec: -6.000547, vmag: 4.08 },
  { name: 'θ-Cap', ra: 21.099118, dec: -17.232861, vmag: 4.08 },
  { name: '1-Peg', ra: 21.36811, dec: 19.804508, vmag: 4.08 },
  { name: 'φ²-Ori', ra: 5.615108, dec: 9.290673, vmag: 4.09 },
  { name: 'α-CrA', ra: 19.157869, dec: -37.904474, vmag: 4.09 },
  { name: 'Muliphein', ra: 7.062637, dec: -15.633286, vmag: 4.09 },
  { name: 'ζ-And', ra: 0.788981, dec: 24.267178, vmag: 4.09 },
  { name: 'τ³-Eri', ra: 3.039863, dec: -23.624472, vmag: 4.09 },
  { name: 'ε-Hyi', ra: 2.659799, dec: -68.266946, vmag: 4.09 },
  { name: 'κ-Ser', ra: 15.812327, dec: 18.141564, vmag: 4.1 },
  { name: 'Titawin', ra: 1.613299, dec: 41.405459, vmag: 4.1 },
  { name: 'ζ¹-Aqr', ra: 22.480531, dec: -0.019972, vmag: 4.1 },
  { name: 'β-CrA', ra: 19.167154, dec: -39.340796, vmag: 4.1 },
  { name: 'α-Psc', ra: 2.034117, dec: 2.763759, vmag: 4.1 },
  { name: 'γ-Cha', ra: 10.591166, dec: -78.607786, vmag: 4.11 },
  { name: 'O-Vir', ra: 12.086817, dec: 8.732985, vmag: 4.11 },
  { name: 'θ-Per', ra: 2.736634, dec: 49.228448, vmag: 4.11 },
  { name: 'ω-Cap', ra: 20.863692, dec: -26.919133, vmag: 4.11 },
  { name: 'ε-TrA', ra: 15.612, dec: -66.317037, vmag: 4.11 },
  { name: 'ν-Gem', ra: 6.482719, dec: 20.212133, vmag: 4.11 },
  { name: 'υ¹-Hya', ra: 9.85797, dec: -14.846603, vmag: 4.11 },
  { name: 'ζ-Tel', ra: 18.480505, dec: -49.070588, vmag: 4.11 },
  { name: 'ι-Sgr', ra: 19.921026, dec: -41.868288, vmag: 4.12 },
  { name: 'ζ-Gru', ra: 23.014677, dec: -52.754137, vmag: 4.12 },
  { name: 'ι-Eri', ra: 2.677781, dec: -39.855375, vmag: 4.12 },
  { name: '1-Lac', ra: 22.26616, dec: 37.748737, vmag: 4.12 },
  { name: 'δ-Cep', ra: 22.486183, dec: 58.415198, vmag: 4.13 },
  { name: 'ι-Psc', ra: 23.665844, dec: 5.626292, vmag: 4.13 },
  { name: 'F-Tau', ra: 3.514549, dec: 12.936678, vmag: 4.13 },
  { name: 'ν-Sco', ra: 16.199926, dec: -19.460708, vmag: 4.13 },
  { name: 'δ-Hya', ra: 8.627602, dec: 5.703782, vmag: 4.13 },
  { name: 'P-Oph', ra: 18.090913, dec: 2.500099, vmag: 4.13 },
  { name: 'κ-And', ra: 23.673469, dec: 44.333932, vmag: 4.13 },
  { name: 'θ-Lib', ra: 15.897093, dec: -16.729293, vmag: 4.13 },
  { name: 'β-Oct', ra: 22.767692, dec: -81.381615, vmag: 4.13 },
  { name: 'μ-Ori', ra: 6.039722, dec: 9.647276, vmag: 4.14 },
  { name: 'δ-Mon', ra: 7.197739, dec: -0.492764, vmag: 4.14 },
  { name: 'E-Ori', ra: 5.399119, dec: -7.808065, vmag: 4.14 },
  { name: 'μ-Per', ra: 4.248295, dec: 48.409331, vmag: 4.14 },
  { name: 'ε-CrB', ra: 15.959794, dec: 26.87788, vmag: 4.14 },
  { name: 'Marfik', ra: 16.515229, dec: 1.983923, vmag: 4.14 },
  { name: 'η-Cru', ra: 12.114687, dec: -64.61373, vmag: 4.14 },
  { name: 'κ-Peg', ra: 21.744092, dec: 25.645036, vmag: 4.14 },
  { name: 'δ-Ser', ra: 15.580041, dec: 10.538867, vmag: 4.15 },
  { name: 'ψ-Cap', ra: 20.76826, dec: -25.270898, vmag: 4.15 },
  { name: 'θ-CrB', ra: 15.548829, dec: 31.359133, vmag: 4.16 },
  { name: 'Merope', ra: 3.772104, dec: 23.948358, vmag: 4.16 },
  { name: 'B-Oph', ra: 17.439504, dec: -24.175309, vmag: 4.16 },
  { name: 'δ²-Gru', ra: 22.495955, dec: -43.749224, vmag: 4.17 },
  { name: 'Ancha', ra: 22.280565, dec: -7.78329, vmag: 4.17 },
  { name: 'ρ-Gem', ra: 7.485195, dec: 31.78455, vmag: 4.17 },
  { name: 'ε-PsA', ra: 22.677594, dec: -27.043617, vmag: 4.17 },
  { name: 'λ-Boo', ra: 14.273074, dec: 46.088305, vmag: 4.17 },
  { name: 'ε-Mus', ra: 12.292917, dec: -67.960736, vmag: 4.18 },
  { name: '1-Gem', ra: 6.068671, dec: 23.263341, vmag: 4.18 },
  { name: 'ε-Cep', ra: 22.250544, dec: 57.043587, vmag: 4.18 },
  { name: 'κ-Vir', ra: 14.214929, dec: -10.273702, vmag: 4.18 },
  { name: 'θ-Lup', ra: 16.109874, dec: -36.802288, vmag: 4.19 },
  { name: 'κ-Cas', ra: 0.549997, dec: 62.931783, vmag: 4.19 },
  { name: 'J-Pup', ra: 7.94765, dec: -22.880119, vmag: 4.19 },
  { name: 'σ-Her', ra: 16.568384, dec: 42.437041, vmag: 4.19 },
  { name: '110-Her', ra: 18.761035, dec: 20.546308, vmag: 4.2 },
  { name: 'κ-Tau', ra: 4.422822, dec: 22.293874, vmag: 4.2 },
  { name: 'ξ-Peg', ra: 22.778216, dec: 12.172888, vmag: 4.2 },
  { name: 'R Lyr', ra: 18.922249, dec: 43.946088, vmag: 4.21 },
  { name: 'β-LMi', ra: 10.464727, dec: 36.707212, vmag: 4.21 },
  { name: 'θ-Cep', ra: 20.493015, dec: 62.994105, vmag: 4.21 },
  { name: 'δ-PsA', ra: 22.932472, dec: -32.539628, vmag: 4.22 },
  { name: 'φ-Dra', ra: 18.345955, dec: 71.337814, vmag: 4.22 },
  { name: '16-Per', ra: 2.843063, dec: 38.318644, vmag: 4.22 },
  { name: 'ε-UMi', ra: 16.766159, dec: 82.037262, vmag: 4.22 },
  { name: 'λ-Pav', ra: 18.870288, dec: -62.187593, vmag: 4.22 },
  { name: 'κ-Eri', ra: 2.449755, dec: -47.70384, vmag: 4.22 },
  { name: 'β-Cha', ra: 12.305812, dec: -79.31224, vmag: 4.22 },
  { name: 'φ-Her', ra: 16.146162, dec: 44.934906, vmag: 4.22 },
  { name: '52-Cyg', ra: 20.761043, dec: 30.719715, vmag: 4.22 },
  { name: 'β-Sct', ra: 18.786242, dec: -4.747867, vmag: 4.23 },
  { name: 'τ⁶-Eri', ra: 3.780804, dec: -23.249723, vmag: 4.23 },
  { name: 'π-Cet', ra: 2.735375, dec: -13.858696, vmag: 4.23 },
  { name: 'λ-Eri', ra: 5.15244, dec: -8.754081, vmag: 4.23 },
  { name: 'γ-Pav', ra: 21.440705, dec: -65.366198, vmag: 4.23 },
  { name: 'ζ-Tuc', ra: 0.334142, dec: -64.874791, vmag: 4.23 },
  { name: 'O-Ser', ra: 17.690243, dec: -12.875307, vmag: 4.23 },
  { name: 'α¹-Cap', ra: 20.29413, dec: -12.508212, vmag: 4.23 },
  { name: 'β-Aps', ra: 16.718126, dec: -77.517435, vmag: 4.23 },
  { name: 'I-Cen', ra: 13.761471, dec: -33.043721, vmag: 4.24 },
  { name: 'φ-Aqr', ra: 23.238711, dec: -6.049003, vmag: 4.24 },
  { name: 'σ-Cyg', ra: 21.290265, dec: 39.394681, vmag: 4.24 },
  { name: 'τ-Vir', ra: 14.027443, dec: 1.544532, vmag: 4.24 },
  { name: 'β-Com', ra: 13.197904, dec: 27.878183, vmag: 4.25 },
  { name: '31-Lyn', ra: 8.380588, dec: 43.188131, vmag: 4.25 },
  { name: 'ψ¹-Aqr', ra: 23.264859, dec: -9.087737, vmag: 4.25 },
  { name: 'ξ²-Cen', ra: 13.11518, dec: -49.906246, vmag: 4.25 },
  { name: '5-UMi', ra: 14.458758, dec: 75.695993, vmag: 4.25 },
  { name: 'E-Per', ra: 4.611508, dec: 41.264808, vmag: 4.25 },
  { name: 'γ²-Del', ra: 20.77764, dec: 16.124296, vmag: 4.25 },
  { name: 'π²-Cyg', ra: 21.779891, dec: 49.30957, vmag: 4.25 },
  { name: 'τ-Tau', ra: 4.704084, dec: 22.956926, vmag: 4.25 },
  { name: 'Chara', ra: 12.562411, dec: 41.35748, vmag: 4.25 },
  { name: 'σ-Gem', ra: 7.721867, dec: 28.88351, vmag: 4.25 },
  { name: 'Acubens', ra: 8.974784, dec: 11.857701, vmag: 4.25 },
  { name: 'γ-Dor', ra: 4.267097, dec: -51.486648, vmag: 4.26 },
  { name: 'D-Tau', ra: 4.594239, dec: 10.16079, vmag: 4.26 },
  { name: 'V776 Tau', ra: 4.424828, dec: 17.92791, vmag: 4.26 },
  { name: 'χ-Oph', ra: 16.450399, dec: -18.456251, vmag: 4.26 },
  { name: 'λ-Lep', ra: 5.326257, dec: -13.176788, vmag: 4.26 },
  { name: 'ε-Psc', ra: 1.049058, dec: 7.890135, vmag: 4.26 },
  { name: 'C¹-Tau', ra: 4.635961, dec: 12.510838, vmag: 4.26 },
  { name: 'λ-Per', ra: 4.109735, dec: 50.351262, vmag: 4.26 },
  { name: 'ξ²-Cet', ra: 2.469317, dec: 8.460054, vmag: 4.26 },
  { name: 'α-Ant', ra: 10.45253, dec: -31.067779, vmag: 4.27 },
  { name: 'η-Hya', ra: 8.72041, dec: 3.398662, vmag: 4.27 },
  { name: 'ι-Aqr', ra: 22.107286, dec: -13.869679, vmag: 4.27 },
  { name: 'O-Psc', ra: 1.756564, dec: 9.157736, vmag: 4.27 },
  { name: 'τ⁵-Eri', ra: 3.563132, dec: -21.632883, vmag: 4.27 },
  { name: 'V806 Cen', ra: 13.824091, dec: -34.450776, vmag: 4.27 },
  { name: 'μ-Tau', ra: 4.258905, dec: 8.892357, vmag: 4.27 },
  { name: 'ι-And', ra: 23.63561, dec: 43.268073, vmag: 4.27 },
  { name: '33-Cyg', ra: 20.223288, dec: 56.567722, vmag: 4.28 },
  { name: 'μ-Cet', ra: 2.749039, dec: 10.114146, vmag: 4.28 },
  { name: 'υ-Tau', ra: 4.438461, dec: 22.813583, vmag: 4.28 },
  { name: 'β-PsA', ra: 22.52509, dec: -32.346073, vmag: 4.28 },
  { name: 'D-Oph', ra: 17.455909, dec: -29.867033, vmag: 4.28 },
  { name: 'Arkab Posterior', ra: 19.386976, dec: -44.799778, vmag: 4.28 },
  { name: 'π-Peg', ra: 22.166457, dec: 33.178224, vmag: 4.28 },
  { name: 'θ-Psc', ra: 23.466138, dec: 6.378992, vmag: 4.28 },
  { name: 'φ-Oph', ra: 16.518991, dec: -16.612733, vmag: 4.28 },
  { name: 'Taygeta', ra: 3.75347, dec: 24.467278, vmag: 4.28 },
  { name: 'ι-Cap', ra: 21.370776, dec: -16.834542, vmag: 4.28 },
  { name: 'β¹-Tuc', ra: 0.525725, dec: -62.958218, vmag: 4.29 },
  { name: 'α-Scl', ra: 0.976766, dec: -29.357449, vmag: 4.29 },
  { name: 'φ-And', ra: 1.158368, dec: 47.241792, vmag: 4.29 },
  { name: 'ζ-UMi', ra: 15.734299, dec: 77.794493, vmag: 4.29 },
  { name: '10-Tau', ra: 3.614551, dec: 0.401662, vmag: 4.3 },
  { name: 'δ²-Lyr', ra: 18.908412, dec: 36.898613, vmag: 4.3 },
  { name: 'ψ-Per', ra: 3.608159, dec: 48.192634, vmag: 4.3 },
  { name: 'η-Crv', ra: 12.53451, dec: -16.196007, vmag: 4.3 },
  { name: 'O-Lup', ra: 14.860641, dec: -43.575359, vmag: 4.3 },
  { name: 'Alkalurops', ra: 15.408181, dec: 37.377167, vmag: 4.3 },
  { name: 'λ-Leo', ra: 9.528675, dec: 22.967971, vmag: 4.31 },
  { name: 'α-Cam', ra: 4.900836, dec: 66.342678, vmag: 4.31 },
  { name: 'ν-Cep', ra: 21.75748, dec: 61.120806, vmag: 4.31 },
  { name: 'D-Hya', ra: 8.772927, dec: -13.54772, vmag: 4.31 },
  { name: 'υ-Leo', ra: 11.615814, dec: -0.823749, vmag: 4.31 },
  { name: 'L-Aql', ra: 20.638967, dec: -1.105121, vmag: 4.31 },
  { name: 'δ-Oct', ra: 14.448801, dec: -83.667884, vmag: 4.31 },
  { name: 'ω²-Sco', ra: 16.123424, dec: -20.868764, vmag: 4.32 },
  { name: 'ξ-Sco', ra: 16.072774, dec: -11.374611, vmag: 4.32 },
  { name: 'ζ¹-Lyr', ra: 18.746209, dec: 37.605115, vmag: 4.32 },
  { name: 'κ-Lyr', ra: 18.331031, dec: 36.064547, vmag: 4.32 },
  { name: 'θ¹-Cru', ra: 12.050447, dec: -63.31293, vmag: 4.32 },
  { name: 'ν-Ser', ra: 17.347128, dec: -12.846875, vmag: 4.32 },
  { name: 'ι-PsA', ra: 21.749113, dec: -33.025781, vmag: 4.33 },
  { name: 'γ-CMi', ra: 7.469387, dec: 8.92553, vmag: 4.33 },
  { name: 'κ-Aur', ra: 6.256304, dec: 29.498076, vmag: 4.33 },
  { name: 'χ-Cen', ra: 14.10077, dec: -41.179633, vmag: 4.33 },
  { name: 'ξ¹-CMa', ra: 6.530935, dec: -23.418422, vmag: 4.33 },
  { name: 'A-Oph', ra: 17.255836, dec: -26.602829, vmag: 4.33 },
  { name: 'π-And', ra: 0.61468, dec: 33.719344, vmag: 4.33 },
  { name: 'δ-Dor', ra: 5.746223, dec: -65.735526, vmag: 4.33 },
  { name: '9-Peg', ra: 21.74186, dec: 17.350017, vmag: 4.33 },
  { name: 'σ-Oph', ra: 17.441911, dec: 4.14036, vmag: 4.33 },
  { name: 'ρ-Hya', ra: 8.807214, dec: 5.837812, vmag: 4.33 },
  { name: 'π-Pav', ra: 18.143, dec: -63.668553, vmag: 4.34 },
  { name: '102-Her', ra: 18.14597, dec: 20.814557, vmag: 4.34 },
  { name: 'Yildun', ra: 17.536918, dec: 86.58646, vmag: 4.34 },
  { name: 'γ-Col', ra: 5.958947, dec: -35.28328, vmag: 4.34 },
  { name: 'π-Aur', ra: 5.998917, dec: 45.936736, vmag: 4.34 },
  { name: 'θ-Cas', ra: 1.185017, dec: 55.149901, vmag: 4.34 },
  { name: 'θ¹-Sgr', ra: 19.995605, dec: -35.276305, vmag: 4.34 },
  { name: 'π²-Ori', ra: 4.843534, dec: 8.900176, vmag: 4.34 },
  { name: 'θ-Lyr', ra: 19.272804, dec: 38.133731, vmag: 4.34 },
  { name: '111-Her', ra: 18.783686, dec: 18.181519, vmag: 4.34 },
  { name: 'Botein', ra: 3.193822, dec: 19.726677, vmag: 4.34 },
  { name: 'θ-Cha', ra: 8.344115, dec: -77.484477, vmag: 4.34 },
  { name: 'σ-Per', ra: 3.509579, dec: 47.995216, vmag: 4.34 },
  { name: 'ω-Lup', ra: 15.634232, dec: -42.567348, vmag: 4.34 },
  { name: 'υ²-Cen', ra: 14.028748, dec: -45.603421, vmag: 4.35 },
  { name: 'γ-Com', ra: 12.448966, dec: 28.268423, vmag: 4.35 },
  { name: 'A¹-Tau', ra: 4.078253, dec: 22.081926, vmag: 4.35 },
  { name: 'ε-And', ra: 0.642602, dec: 29.311751, vmag: 4.35 },
  { name: 'F-Lup', ra: 15.297178, dec: -30.148673, vmag: 4.35 },
  { name: 'β-Hya', ra: 11.881813, dec: -33.908124, vmag: 4.35 },
  { name: 'ζ-Mon', ra: 8.143236, dec: -2.983786, vmag: 4.36 },
  { name: 'ι-Oph', ra: 16.900131, dec: 10.165359, vmag: 4.36 },
  { name: 'γ-CrA', ra: 19.106971, dec: -37.063437, vmag: 4.36 },
  { name: 'η-Phe', ra: 0.722567, dec: -57.46306, vmag: 4.36 },
  { name: 'ι-Aql', ra: 19.612022, dec: -1.286601, vmag: 4.36 },
  { name: 'DM Eri', ra: 4.674031, dec: -19.671493, vmag: 4.36 },
  { name: '15-Lyn', ra: 6.954612, dec: 58.422759, vmag: 4.36 },
  { name: 'β-Scl', ra: 23.549512, dec: -37.818268, vmag: 4.36 },
  { name: 'τ²-Lup', ra: 14.436336, dec: -45.379276, vmag: 4.36 },
  { name: 'ξ¹-Cet', ra: 2.216665, dec: 8.846717, vmag: 4.36 },
  { name: 'κ-Col', ra: 6.275871, dec: -35.140519, vmag: 4.37 },
  { name: 'κ-Pav', ra: 18.949177, dec: -67.233495, vmag: 4.37 },
  { name: 'ω-Eri', ra: 4.881575, dec: -5.452695, vmag: 4.37 },
  { name: '5-Lac', ra: 22.492173, dec: 47.706887, vmag: 4.37 },
  { name: 'A-Leo', ra: 10.131742, dec: 9.997508, vmag: 4.38 },
  { name: 'B²-Aqr', ra: 23.434108, dec: -20.642014, vmag: 4.38 },
  { name: 'β-Sge', ra: 19.68415, dec: 17.476041, vmag: 4.38 },
  { name: 'ι-CMa', ra: 6.935618, dec: -17.054242, vmag: 4.38 },
  { name: 'Sham', ra: 19.668275, dec: 18.01389, vmag: 4.38 },
  { name: 'ξ-Pav', ra: 18.387117, dec: -61.493901, vmag: 4.38 },
  { name: 'α-Com', ra: 13.166469, dec: 17.529431, vmag: 4.38 },
  { name: '16-Pup', ra: 8.150455, dec: -19.245014, vmag: 4.38 },
  { name: 'φ¹-Ori', ra: 5.580344, dec: 9.489579, vmag: 4.38 },
  { name: 'ν-Ori', ra: 6.126201, dec: 14.768472, vmag: 4.39 },
  { name: 'η-Lyr', ra: 19.229302, dec: 39.145968, vmag: 4.39 },
  { name: 'θ-Vir', ra: 13.165831, dec: -5.53901, vmag: 4.39 },
  { name: 'ξ-Oph', ra: 17.350101, dec: -21.112933, vmag: 4.39 },
  { name: 'ε-Vol', ra: 8.132173, dec: -68.617062, vmag: 4.39 },
  { name: 'κ-Cep', ra: 20.148145, dec: 77.711419, vmag: 4.4 },
  { name: 'τ-Gem', ra: 7.185659, dec: 30.245163, vmag: 4.4 },
  { name: 'B-Leo', ra: 11.038827, dec: 20.179842, vmag: 4.4 },
  { name: 'Maasym', ra: 17.512308, dec: 26.110645, vmag: 4.4 },
  { name: 'η-And', ra: 0.953445, dec: 23.417648, vmag: 4.4 },
  { name: 'τ-CMa', ra: 7.311802, dec: -24.954375, vmag: 4.4 },
  { name: 'δ-Ind', ra: 21.965293, dec: -54.992575, vmag: 4.4 },
  { name: '110-Vir', ra: 15.048344, dec: 2.091303, vmag: 4.4 },
  { name: 'χ¹-Ori', ra: 5.906386, dec: 20.276174, vmag: 4.4 },
  { name: 'ε-Mon', ra: 6.396135, dec: 4.592865, vmag: 4.4 },
  { name: 'YY Psc', ra: 0.032672, dec: -6.014072, vmag: 4.4 },
  { name: 'Alula Australis', ra: 11.303118, dec: 31.528783, vmag: 4.41 },
  { name: 'ψ²-Aqr', ra: 23.298393, dec: -9.182513, vmag: 4.41 },
  { name: 'θ-Gru', ra: 23.11465, dec: -43.520358, vmag: 4.41 },
  { name: 'σ-Lup', ra: 14.543629, dec: -50.457157, vmag: 4.41 },
  { name: 'γ-Scl', ra: 23.313733, dec: -32.532027, vmag: 4.41 },
  { name: 'ν-Her', ra: 17.975041, dec: 30.189277, vmag: 4.42 },
  { name: 'CE Tau', ra: 5.536875, dec: 18.594234, vmag: 4.42 },
  { name: 'E-Hya', ra: 14.838147, dec: -27.960371, vmag: 4.42 },
  { name: 'υ-Cyg', ra: 21.298632, dec: 34.896898, vmag: 4.42 },
  { name: 'δ²-Cha', ra: 10.763087, dec: -80.540188, vmag: 4.42 },
  { name: 'λ-Ser', ra: 15.77406, dec: 7.353073, vmag: 4.42 },
  { name: 'δ-Del', ra: 20.724315, dec: 15.074581, vmag: 4.43 },
  { name: '68-Oph', ra: 18.029222, dec: 1.305076, vmag: 4.43 },
  { name: 'ξ-Ori', ra: 6.198999, dec: 14.208765, vmag: 4.43 },
  { name: 'Keid', ra: 4.254537, dec: -7.652871, vmag: 4.43 },
  { name: '39-Cyg', ra: 20.397671, dec: 32.190172, vmag: 4.43 },
  { name: 'υ-Peg', ra: 23.422993, dec: 23.404101, vmag: 4.43 },
  { name: '7-Cam', ra: 4.95478, dec: 53.752101, vmag: 4.43 },
  { name: 'δ-Psc', ra: 0.811373, dec: 7.585079, vmag: 4.43 },
  { name: 'ψ-Phe', ra: 1.894102, dec: -46.302669, vmag: 4.43 },
  { name: 'β-Lac', ra: 22.392675, dec: 52.229046, vmag: 4.44 },
  { name: 'π-Eri', ra: 3.769037, dec: -12.101589, vmag: 4.44 },
  { name: 'ω-Oph', ra: 16.535611, dec: -21.46639, vmag: 4.44 },
  { name: 'ε-Ret', ra: 4.274738, dec: -59.302156, vmag: 4.44 },
  { name: 'ν-Psc', ra: 1.690526, dec: 5.487613, vmag: 4.44 },
  { name: 'ν³-CMa', ra: 6.631506, dec: -18.237478, vmag: 4.44 },
  { name: 'κ-Lep', ra: 5.220522, dec: -12.941291, vmag: 4.44 },
  { name: 'ι-Lep', ra: 5.204973, dec: -11.869219, vmag: 4.45 },
  { name: 'α-Cae', ra: 4.676039, dec: -41.863752, vmag: 4.45 },
  { name: 'σ-Hya', ra: 8.645955, dec: 3.341435, vmag: 4.45 },
  { name: 'UZ Lyn', ra: 6.327052, dec: 59.010964, vmag: 4.45 },
  { name: 'EW CMa', ra: 7.237559, dec: -26.352507, vmag: 4.45 },
  { name: 'α-Vul', ra: 19.478427, dec: 24.664905, vmag: 4.45 },
  { name: 'μ-Aql', ra: 19.568153, dec: 7.378941, vmag: 4.45 },
  { name: 'AE Cet', ra: 0.244005, dec: -18.932866, vmag: 4.45 },
  { name: 'λ-CMa', ra: 6.469503, dec: -32.58007, vmag: 4.45 },
  { name: 'A-Ori', ra: 5.51307, dec: 5.948139, vmag: 4.45 },
  { name: 'ζ-Boo', ra: 14.68582, dec: 13.7283, vmag: 4.46 },
  { name: 'φ-Leo', ra: 11.277695, dec: -3.651601, vmag: 4.46 },
  { name: 'τ-Dra', ra: 19.259229, dec: 73.355468, vmag: 4.46 },
  { name: 'F-UMa', ra: 9.147863, dec: 51.604648, vmag: 4.46 },
  { name: 'β-Crt', ra: 11.194302, dec: -22.825847, vmag: 4.46 },
  { name: '26-UMa', ra: 9.580405, dec: 52.051477, vmag: 4.46 },
  { name: 'β-For', ra: 2.818169, dec: -32.405898, vmag: 4.46 },
  { name: 'EN Aqr', ra: 20.795621, dec: -5.027701, vmag: 4.46 },
  { name: 'σ-Boo', ra: 14.578, dec: 29.74513, vmag: 4.47 },
  { name: 'κ-Leo', ra: 9.410906, dec: 26.182324, vmag: 4.47 },
  { name: 'λ-Gru', ra: 22.101914, dec: -39.543353, vmag: 4.47 },
  { name: 'π⁶-Ori', ra: 4.975806, dec: 1.714016, vmag: 4.47 },
  { name: 'β-Psc', ra: 23.064615, dec: 3.820045, vmag: 4.47 },
  { name: '16-Lib', ra: 14.953055, dec: -4.346462, vmag: 4.47 },
  { name: 'τ¹-Eri', ra: 2.751715, dec: -18.572563, vmag: 4.48 },
  { name: 'α-Sextans', ra: 10.1323, dec: -0.371637, vmag: 4.48 },
  { name: '54-Leo', ra: 10.92689, dec: 24.749718, vmag: 4.48 },
  { name: '18-Mon', ra: 6.79768, dec: 2.412159, vmag: 4.48 },
  { name: 'V777 Tau', ra: 4.439094, dec: 15.618265, vmag: 4.48 },
  { name: '21-LMi', ra: 10.123821, dec: 35.244693, vmag: 4.48 },
  { name: 'O-Cas', ra: 0.74542, dec: 48.284364, vmag: 4.48 },
  { name: 'C¹-Aqr', ra: 23.111345, dec: -23.743115, vmag: 4.48 },
  { name: 'ε-Tuc', ra: 23.998594, dec: -65.577132, vmag: 4.48 },
  { name: 'ω²-Aqr', ra: 23.712039, dec: -14.544905, vmag: 4.48 },
  { name: 'ψ-Oph', ra: 16.401718, dec: -20.037327, vmag: 4.49 },
  { name: '13-Mon', ra: 6.548396, dec: 7.332965, vmag: 4.49 },
  { name: 'τ-Boo', ra: 13.78771, dec: 17.456906, vmag: 4.49 },
  { name: 'ρ-Ori', ra: 5.221523, dec: 2.861265, vmag: 4.49 },
  { name: 'β²-Tuc', ra: 0.525946, dec: -62.965561, vmag: 4.49 },
  { name: 'λ-Psc', ra: 23.700779, dec: 1.780041, vmag: 4.49 },
  { name: 'δ-Equ', ra: 21.241337, dec: 10.006981, vmag: 4.5 },
  { name: '30-Gem', ra: 6.733137, dec: 13.228017, vmag: 4.5 },
  { name: 'δ-Tuc', ra: 22.455531, dec: -64.966354, vmag: 4.5 },
  { name: 'μ-PsA', ra: 22.139722, dec: -32.988468, vmag: 4.5 },
  { name: 'θ-Cyg', ra: 19.607372, dec: 50.221103, vmag: 4.5 },
  { name: 'O-Pup', ra: 7.801436, dec: -25.937169, vmag: 4.5 },
  { name: 'θ-Ind', ra: 21.331096, dec: -53.449427, vmag: 4.5 },
  { name: '11-Lac', ra: 22.675233, dec: 44.276305, vmag: 4.5 },
  { name: 'γ-Pic', ra: 5.830451, dec: -56.166663, vmag: 4.5 },
  { name: 'ρ-Cas', ra: 23.906398, dec: 57.499382, vmag: 4.5 },
  { name: 'ν-Aqr', ra: 21.159902, dec: -11.371693, vmag: 4.5 },
  { name: 'η-Ind', ra: 20.733966, dec: -51.920971, vmag: 4.5 },
  { name: 'ε-Ant', ra: 9.487423, dec: -35.951335, vmag: 4.5 },
  { name: 'σ-And', ra: 0.305463, dec: 36.785224, vmag: 4.5 },
  { name: 'ι-Ser', ra: 15.692516, dec: 19.670401, vmag: 4.51 },
  { name: 'γ-PsA', ra: 22.875427, dec: -32.875504, vmag: 4.51 },
  { name: 'V3872 Sgr', ra: 20.044299, dec: -27.709845, vmag: 4.51 },
  { name: 'ρ-Dra', ra: 20.04696, dec: 67.873565, vmag: 4.51 },
  { name: 'ν-And', ra: 0.830234, dec: 41.078911, vmag: 4.51 },
  { name: 'υ¹-Eri', ra: 4.55849, dec: -29.766492, vmag: 4.51 },
  { name: 'B-Cap', ra: 21.478721, dec: -21.80718, vmag: 4.51 },
  { name: 'K-Cen', ra: 13.863779, dec: -32.994089, vmag: 4.51 },
  { name: 'φ²-Lup', ra: 15.385931, dec: -36.858489, vmag: 4.51 },
  { name: 'ω-Ori', ra: 5.653096, dec: 4.121467, vmag: 4.51 },
  { name: 'ε-Tel', ra: 18.187157, dec: -45.954418, vmag: 4.51 },
  { name: 'κ²-Boo', ra: 14.224718, dec: 51.789965, vmag: 4.52 },
  { name: 'ε-Nor', ra: 16.453067, dec: -47.554786, vmag: 4.52 },
  { name: 'τ-Psc', ra: 1.194342, dec: 30.089638, vmag: 4.52 },
  { name: 'ψ-Boo', ra: 15.074098, dec: 26.947649, vmag: 4.52 },
  { name: 'A-Cap', ra: 21.118797, dec: -25.005853, vmag: 4.52 },
  { name: 'λ-Vir', ra: 14.318498, dec: -13.371095, vmag: 4.52 },
  { name: 'ε-Cap', ra: 21.618008, dec: -19.466011, vmag: 4.52 },
  { name: '39-Ari', ra: 2.79848, dec: 29.247118, vmag: 4.52 },
  { name: 'π-Cep', ra: 23.131623, dec: 75.387496, vmag: 4.52 },
  { name: '23-Vul', ra: 20.262816, dec: 27.814242, vmag: 4.52 },
  { name: 'τ-Aur', ra: 5.819567, dec: 39.181071, vmag: 4.52 },
  { name: '2-Peg', ra: 21.499137, dec: 23.638838, vmag: 4.53 },
  { name: '7-And', ra: 23.20916, dec: 49.406207, vmag: 4.53 },
  { name: 'ξ²-CMa', ra: 6.584274, dec: -22.964793, vmag: 4.53 },
  { name: 'γ-Cir', ra: 15.389625, dec: -59.320787, vmag: 4.53 },
  { name: 'B¹-Sgr', ra: 19.94912, dec: -27.169899, vmag: 4.53 },
  { name: '6-Lac', ra: 22.508128, dec: 43.123376, vmag: 4.53 },
  { name: 'γ-Ret', ra: 4.014946, dec: -62.159284, vmag: 4.53 },
  { name: 'DQ Leo', ra: 11.799762, dec: 20.218931, vmag: 4.53 },
  { name: '2-Lac', ra: 22.350428, dec: 46.536569, vmag: 4.53 },
  { name: 'F²-Cyg', ra: 21.110026, dec: 47.648403, vmag: 4.53 },
  { name: '6-CMi', ra: 7.496606, dec: 12.006564, vmag: 4.54 },
  { name: '70-Peg', ra: 23.485915, dec: 12.760554, vmag: 4.54 },
  { name: '11-Cep', ra: 21.698652, dec: 71.311417, vmag: 4.54 },
  { name: 'τ¹-Lup', ra: 14.435619, dec: -45.221424, vmag: 4.54 },
  { name: 'SU LMi', ra: 9.570384, dec: 36.397558, vmag: 4.55 },
  { name: '55-Peg', ra: 23.116739, dec: 9.409492, vmag: 4.55 },
  { name: '2-Cet', ra: 0.06233, dec: -17.335988, vmag: 4.55 },
  { name: '136-Tau', ra: 5.88879, dec: 27.612262, vmag: 4.55 },
  { name: 'τ²-Hya', ra: 9.533036, dec: -1.184664, vmag: 4.55 },
  { name: 'DK UMa', ra: 9.574703, dec: 69.830343, vmag: 4.55 },
  { name: '16-Aur', ra: 5.302935, dec: 33.371613, vmag: 4.56 },
  { name: 'φ-UMa', ra: 9.868433, dec: 54.064332, vmag: 4.56 },
  { name: 'C²-Sco', ra: 16.205057, dec: -27.926372, vmag: 4.56 },
  { name: 'ψ-Dra', ra: 17.698978, dec: 72.148843, vmag: 4.56 },
  { name: 'ι-Lib', ra: 15.203692, dec: -19.79171, vmag: 4.56 },
  { name: 'σ-Ara', ra: 17.594332, dec: -46.505684, vmag: 4.56 },
  { name: 'ω-Her', ra: 16.423598, dec: 14.03327, vmag: 4.56 },
  { name: 'δ-Ret', ra: 3.979095, dec: -61.400185, vmag: 4.57 },
  { name: '17-Per', ra: 2.858566, dec: 35.059741, vmag: 4.57 },
  { name: 'λ-Cyg', ra: 20.790149, dec: 36.490717, vmag: 4.57 },
  { name: '72-Leo', ra: 11.253397, dec: 23.095502, vmag: 4.57 },
  { name: 'δ-Scl', ra: 23.815427, dec: -28.130268, vmag: 4.57 },
  { name: 'υ-Sgr', ra: 19.362117, dec: -15.955018, vmag: 4.57 },
  { name: 'π-Lup', ra: 15.085303, dec: -47.051245, vmag: 4.57 },
  { name: '31-Vul', ra: 20.868801, dec: 27.096979, vmag: 4.58 },
  { name: 'Alya', ra: 18.936995, dec: 4.203595, vmag: 4.58 },
  { name: 'π-Dra', ra: 19.344467, dec: 65.714531, vmag: 4.58 },
  { name: 'X Sgr', ra: 17.792674, dec: -27.830788, vmag: 4.58 },
  { name: 'δ-CrA', ra: 19.139156, dec: -40.496703, vmag: 4.58 },
  { name: 'γ-Cae', ra: 5.07344, dec: -35.482978, vmag: 4.58 },
  { name: 'υ²-Hya', ra: 10.085408, dec: -13.064626, vmag: 4.58 },
  { name: 'τ-Peg', ra: 23.343956, dec: 23.740337, vmag: 4.59 },
  { name: '4-Lac', ra: 22.408609, dec: 49.476392, vmag: 4.59 },
  { name: '113-Her', ra: 18.912468, dec: 22.645076, vmag: 4.59 },
  { name: 'τ¹-Hya', ra: 9.485805, dec: -2.768964, vmag: 4.59 },
  { name: 'υ-Ori', ra: 5.532183, dec: -7.301537, vmag: 4.59 },
  { name: 'O-Sco', ra: 16.343939, dec: -24.16932, vmag: 4.59 },
  { name: 'λ-Cru', ra: 12.910889, dec: -59.146701, vmag: 4.59 },
  { name: 'Psi Ori', ra: 5.447286, dec: 3.095674, vmag: 4.6 },
  { name: 'π²-UMa', ra: 8.67024, dec: 64.327936, vmag: 4.6 },
  { name: 'θ-And', ra: 0.284863, dec: 38.681636, vmag: 4.6 },
  { name: 'ι-Ant', ra: 10.945289, dec: -37.137765, vmag: 4.6 },
  { name: 'ν-Pav', ra: 18.522896, dec: -62.278302, vmag: 4.6 },
  { name: 'μ-Phe', ra: 0.688766, dec: -46.085007, vmag: 4.61 },
  { name: 'γ-Cam', ra: 3.839302, dec: 71.332266, vmag: 4.61 },
  { name: 'δ-CrB', ra: 15.82657, dec: 26.068394, vmag: 4.61 },
  { name: 'μ-Oph', ra: 17.630754, dec: -8.118771, vmag: 4.61 },
  { name: '21-Lyn', ra: 7.445237, dec: 49.211527, vmag: 4.61 },
  { name: 'χ-Her', ra: 15.877903, dec: 42.451518, vmag: 4.61 },
  { name: '1-Pup', ra: 7.725663, dec: -28.410885, vmag: 4.61 },
  { name: 'H²-Sgr', ra: 19.611786, dec: -24.883623, vmag: 4.61 },
  { name: 'O-Boo', ra: 14.754017, dec: 16.96428, vmag: 4.61 },
  { name: 'ξ-Psc', ra: 1.892597, dec: 3.187536, vmag: 4.61 },
  { name: 'κ-Pyx', ra: 9.134133, dec: -25.858536, vmag: 4.61 },
  { name: 'ω-Per', ra: 3.188163, dec: 39.611582, vmag: 4.61 },
  { name: 'CU Dra', ra: 13.857205, dec: 64.723272, vmag: 4.61 },
  { name: 'τ^8-Eri', ra: 3.895195, dec: -24.61223, vmag: 4.62 },
  { name: 'ι-Tau', ra: 5.051596, dec: 21.589962, vmag: 4.62 },
  { name: '37-Lib', ra: 15.569638, dec: -10.064529, vmag: 4.62 },
  { name: 'ι-Cas', ra: 2.484437, dec: 67.402474, vmag: 4.62 },
  { name: '33-Psc', ra: 0.088928, dec: -5.707618, vmag: 4.62 },
  { name: 'E-Her', ra: 17.294517, dec: 37.291498, vmag: 4.62 },
  { name: 'θ-CrA', ra: 18.558383, dec: -42.31251, vmag: 4.62 },
  { name: 'ζ-Ser', ra: 18.008058, dec: -3.690269, vmag: 4.62 },
  { name: 'C-Ori', ra: 5.589768, dec: -4.838358, vmag: 4.63 },
  { name: 'χ-Leo', ra: 11.083619, dec: 7.336007, vmag: 4.63 },
  { name: 'υ²-Cas', ra: 0.944432, dec: 59.181056, vmag: 4.63 },
  { name: 'B-Sco', ra: 15.849652, dec: -25.751295, vmag: 4.63 },
  { name: 'τ^9-Eri', ra: 3.998745, dec: -24.016215, vmag: 4.63 },
  { name: 'A-Cas', ra: 2.032644, dec: 70.90702, vmag: 4.63 },
  { name: 'υ-Oph', ra: 16.463385, dec: -8.371731, vmag: 4.63 },
  { name: '35-Ari', ra: 2.724198, dec: 27.707146, vmag: 4.64 },
  { name: '13-Vul', ra: 19.891026, dec: 24.079614, vmag: 4.64 },
  { name: '9-Lac', ra: 22.622899, dec: 51.545123, vmag: 4.64 },
  { name: 'Mesarthim', ra: 1.89217, dec: 19.293852, vmag: 4.64 },
  { name: 'β-Mon', ra: 6.480297, dec: -7.033062, vmag: 4.64 },
  { name: '20-Oph', ra: 16.830563, dec: -10.783, vmag: 4.64 },
  { name: 'χ²-Ori', ra: 6.065329, dec: 20.138452, vmag: 4.64 },
  { name: 'O-Dra', ra: 18.853348, dec: 59.388351, vmag: 4.64 },
  { name: 'π-Vir', ra: 12.014553, dec: 6.614322, vmag: 4.65 },
  { name: 'ρ-Tau', ra: 4.564143, dec: 14.844424, vmag: 4.65 },
  { name: '71-Oph', ra: 18.121767, dec: 8.733867, vmag: 4.65 },
  { name: 'τ-UMa', ra: 9.181941, dec: 63.513633, vmag: 4.65 },
  { name: '3-And', ra: 23.069702, dec: 50.052091, vmag: 4.65 },
  { name: 'ζ-Del', ra: 20.588482, dec: 14.674213, vmag: 4.65 },
  { name: 'η-Nor', ra: 16.053579, dec: -49.229695, vmag: 4.65 },
  { name: 'χ-Vir', ra: 12.654102, dec: -7.995564, vmag: 4.65 },
  { name: 'π¹-Ori', ra: 4.914924, dec: 10.150833, vmag: 4.65 },
  { name: 'Asellus Borealis', ra: 8.721431, dec: 21.468501, vmag: 4.65 },
  { name: '47-Cyg', ra: 20.565052, dec: 35.250852, vmag: 4.65 },
  { name: '83-UMa', ra: 13.678967, dec: 54.681634, vmag: 4.65 },
  { name: 'V1032 Ori', ra: 5.076153, dec: 15.404105, vmag: 4.66 },
  { name: 'NT Vul', ra: 20.018346, dec: 27.753573, vmag: 4.66 },
  { name: 'ε-Boo', ra: 14.749784, dec: 27.074222, vmag: 4.66 },
  { name: 'Azelfafage', ra: 21.701573, dec: 51.189622, vmag: 4.66 },
  { name: 'χ-Cet', ra: 1.826418, dec: -10.68641, vmag: 4.66 },
  { name: 'ω-UMa', ra: 10.899648, dec: 43.189956, vmag: 4.66 },
  { name: 'γ-Mic', ra: 21.021517, dec: -32.257767, vmag: 4.66 },
  { name: 'θ-Lep', ra: 6.10259, dec: -14.935254, vmag: 4.66 },
  { name: 'χ-Psc', ra: 1.190894, dec: 21.03465, vmag: 4.66 },
  { name: 'ψ-Peg', ra: 23.962647, dec: 25.141401, vmag: 4.67 },
  { name: 'S Mon', ra: 6.682961, dec: 9.895754, vmag: 4.67 },
  { name: 'β²-Cyg', ra: 19.51261, dec: 27.965276, vmag: 4.67 },
  { name: 'ψ¹-Lup', ra: 15.662772, dec: -34.411926, vmag: 4.67 },
  { name: 'θ-Crt', ra: 11.611365, dec: -9.802247, vmag: 4.67 },
  { name: 'σ²-Tau', ra: 4.654583, dec: 15.917977, vmag: 4.67 },
  { name: 'ξ-Boo', ra: 14.856493, dec: 19.10046, vmag: 4.67 },
  { name: '24-CVn', ra: 13.57425, dec: 49.015973, vmag: 4.67 },
  { name: 'ζ-Sct', ra: 18.394329, dec: -8.934383, vmag: 4.67 },
  { name: '93-Her', ra: 18.000949, dec: 16.750919, vmag: 4.67 },
  { name: 'π-CMa', ra: 6.927064, dec: -20.136497, vmag: 4.67 },
  { name: 'ν-Aql', ra: 19.441969, dec: 0.33857, vmag: 4.67 },
  { name: 'ν-For', ra: 2.074844, dec: -29.296819, vmag: 4.67 },
  { name: 'γ-Equ', ra: 21.172361, dec: 10.131579, vmag: 4.68 },
  { name: 'ι¹-Nor', ra: 16.058931, dec: -57.775064, vmag: 4.68 },
  { name: 'σ-Dra', ra: 19.539149, dec: 69.661175, vmag: 4.68 },
  { name: 'φ-Psc', ra: 1.229152, dec: 24.583713, vmag: 4.68 },
  { name: 'γ-Sct', ra: 18.486626, dec: -14.565813, vmag: 4.68 },
  { name: 'φ-Cyg', ra: 19.656279, dec: 30.153321, vmag: 4.68 },
  { name: 'O-Hya', ra: 11.670221, dec: -34.74466, vmag: 4.68 },
  { name: 'G-Aqr', ra: 22.726454, dec: -18.830375, vmag: 4.68 },
  { name: 'ξ-Aqr', ra: 21.629197, dec: -7.854201, vmag: 4.68 },
  { name: 'π-Per', ra: 2.979352, dec: 39.662728, vmag: 4.68 },
  { name: '37-LMi', ra: 10.645337, dec: 31.976237, vmag: 4.68 },
  { name: 'π-Leo', ra: 10.003557, dec: 8.044223, vmag: 4.69 },
  { name: 'χ-Cas', ra: 1.565528, dec: 59.23204, vmag: 4.69 },
  { name: 'λ-Aur', ra: 5.318995, dec: 40.099051, vmag: 4.69 },
  { name: 'η²-Hyi', ra: 1.915572, dec: -67.647303, vmag: 4.69 },
  { name: 'ι-Cru', ra: 12.76055, dec: -60.981318, vmag: 4.69 },
  { name: 'π-Tau', ra: 4.443437, dec: 14.713782, vmag: 4.69 },
  { name: 'V645 Mon', ra: 8.020371, dec: -1.392608, vmag: 4.69 },
  { name: 'O-Ori', ra: 5.362708, dec: -0.382465, vmag: 4.7 },
  { name: 'ι-Phe', ra: 23.584599, dec: -42.615075, vmag: 4.7 },
  { name: 'W Sgr', ra: 18.083674, dec: -29.580087, vmag: 4.7 },
  { name: 'F-Per', ra: 4.248143, dec: 40.483671, vmag: 4.7 },
  { name: 'ω-Sgr', ra: 19.930651, dec: -26.299506, vmag: 4.7 },
  { name: 'δ-Sct', ra: 18.704563, dec: -9.052549, vmag: 4.7 },
  { name: 'μ¹-Cyg', ra: 21.73571, dec: 28.742632, vmag: 4.7 },
  { name: 'υ-Her', ra: 16.046634, dec: 46.036705, vmag: 4.7 },
  { name: 'A-Sco', ra: 15.893533, dec: -25.327142, vmag: 4.7 },
  { name: 'AO CVn', ra: 13.292379, dec: 40.572608, vmag: 4.71 },
  { name: 'δ-Pic', ra: 6.171642, dec: -54.968645, vmag: 4.71 },
  { name: 'θ²-Cru', ra: 12.072008, dec: -63.165711, vmag: 4.71 },
  { name: 'λ-Cet', ra: 2.99525, dec: 8.907365, vmag: 4.71 },
  { name: 'B³-Aqr', ra: 23.554618, dec: -20.914504, vmag: 4.71 },
  { name: 'ε-Mic', ra: 21.298966, dec: -32.172539, vmag: 4.71 },
  { name: 'ψ²-Lup', ra: 15.711395, dec: -34.710407, vmag: 4.71 },
  { name: 'ζ-Crt', ra: 11.746049, dec: -18.350674, vmag: 4.71 },
  { name: 'κ-Ret', ra: 3.489558, dec: -62.937527, vmag: 4.71 },
  { name: 'Libertas', ra: 19.904134, dec: 8.461453, vmag: 4.71 },
  { name: 'CI Ori', ra: 5.49555, dec: -1.092239, vmag: 4.71 },
  { name: 'ε-Ind', ra: 22.055486, dec: -56.785977, vmag: 4.72 },
  { name: 'ζ-Dor', ra: 5.091853, dec: -57.472704, vmag: 4.72 },
  { name: 'δ-Nor', ra: 16.108176, dec: -45.173185, vmag: 4.72 },
  { name: 'λ-Pyx', ra: 9.386739, dec: -28.833873, vmag: 4.72 },
  { name: '19-Pup', ra: 8.187863, dec: -12.926999, vmag: 4.72 },
  { name: '4-Sgr', ra: 17.996543, dec: -23.816133, vmag: 4.72 },
  { name: 'ζ-CrA', ra: 19.051907, dec: -42.095105, vmag: 4.72 },
  { name: 'E-Gem', ra: 6.910732, dec: 13.177827, vmag: 4.72 },
  { name: '8-Cyg', ra: 19.529534, dec: 34.452968, vmag: 4.72 },
  { name: 'L-Vir', ra: 13.532746, dec: -6.255816, vmag: 4.72 },
  { name: 'μ-Aqr', ra: 20.877565, dec: -8.983318, vmag: 4.73 },
  { name: '30-LMi', ra: 10.431895, dec: 33.79612, vmag: 4.73 },
  { name: '34-Per', ra: 3.489456, dec: 49.508948, vmag: 4.73 },
  { name: 'θ-Pyx', ra: 9.35822, dec: -25.965439, vmag: 4.73 },
  { name: '65-And', ra: 2.42706, dec: 50.278631, vmag: 4.73 },
  { name: 'H-Cen', ra: 13.886817, dec: -31.927612, vmag: 4.73 },
  { name: '11-Com', ra: 12.345286, dec: 17.792868, vmag: 4.73 },
  { name: 'δ¹-Aps', ra: 16.339119, dec: -78.695745, vmag: 4.73 },
  { name: 'ψ-Cas', ra: 1.432208, dec: 68.130012, vmag: 4.73 },
  { name: 'κ-Cap', ra: 21.710973, dec: -18.866323, vmag: 4.73 },
  { name: 'χ-Aur', ra: 5.545465, dec: 32.192022, vmag: 4.74 },
  { name: 'P²-Leo', ra: 11.030465, dec: -2.484585, vmag: 4.74 },
  { name: 'τ-CrB', ra: 16.149529, dec: 36.490944, vmag: 4.74 },
  { name: 'C³-Aqr', ra: 23.165249, dec: -22.457611, vmag: 4.74 },
  { name: 'λ-Cas', ra: 0.529539, dec: 54.522289, vmag: 4.74 },
  { name: 'V-Eri', ra: 3.510294, dec: -5.075145, vmag: 4.74 },
  { name: '61-Vir', ra: 13.306763, dec: -18.311196, vmag: 4.74 },
  { name: 'ι-Boo', ra: 14.269439, dec: 51.367231, vmag: 4.74 },
  { name: 'υ-Aur', ra: 5.850675, dec: 37.305573, vmag: 4.74 },
  { name: 'V832 Cyg', ra: 20.997098, dec: 47.520951, vmag: 4.74 },
  { name: 'ν-Cap', ra: 20.344393, dec: -12.75908, vmag: 4.75 },
  { name: '1-Vul', ra: 19.270289, dec: 21.390428, vmag: 4.75 },
  { name: 'μ-Mus', ra: 11.80403, dec: -66.81491, vmag: 4.75 },
  { name: 'υ-Psc', ra: 1.324443, dec: 27.264059, vmag: 4.75 },
  { name: 'ρ-Ser', ra: 15.85442, dec: 20.977919, vmag: 4.75 },
  { name: 'σ-Cet', ra: 2.534786, dec: -15.244677, vmag: 4.75 },
  { name: '36-Com', ra: 12.982068, dec: 17.409446, vmag: 4.75 },
  { name: 'V2048 Oph', ra: 18.004388, dec: 4.368615, vmag: 4.75 },
  { name: 'ν-Hyi', ra: 2.841255, dec: -75.066947, vmag: 4.75 },
  { name: 'O¹-Ori', ra: 4.875545, dec: 14.250642, vmag: 4.75 },
  { name: 'λ¹-Phe', ra: 0.523594, dec: -48.803514, vmag: 4.75 },
  { name: 'φ¹-Pav', ra: 20.593003, dec: -60.581749, vmag: 4.75 },
  { name: 'κ-Lib', ra: 15.699111, dec: -19.678828, vmag: 4.76 },
  { name: '69-Vir', ra: 13.457546, dec: -15.973578, vmag: 4.76 },
  { name: '55-UMa', ra: 11.318864, dec: 38.185557, vmag: 4.76 },
  { name: 'λ-Ara', ra: 17.673276, dec: -49.415587, vmag: 4.76 },
  { name: '56-Ori', ra: 5.874011, dec: 1.855134, vmag: 4.76 },
  { name: '57-Cyg', ra: 20.887431, dec: 44.38726, vmag: 4.76 },
  { name: '56-Peg', ra: 23.118539, dec: 25.468259, vmag: 4.76 },
  { name: 'E-Leo', ra: 11.505248, dec: -3.003501, vmag: 4.76 },
  { name: 'ζ-Aps', ra: 17.366531, dec: -67.770668, vmag: 4.77 },
  { name: '5-CVn', ra: 12.400414, dec: 51.562257, vmag: 4.77 },
  { name: 'ψ-Eri', ra: 5.023985, dec: -7.173965, vmag: 4.77 },
  { name: 'ξ-Sco', ra: 16.072774, dec: -11.374611, vmag: 4.77 },
  { name: 'D-Dra', ra: 18.542923, dec: 57.045599, vmag: 4.77 },
  { name: '20-Cet', ra: 0.883471, dec: -1.14426, vmag: 4.77 },
  { name: 'I-Sco', ra: 16.503466, dec: -25.115224, vmag: 4.77 },
  { name: '23-Com', ra: 12.580857, dec: 22.629259, vmag: 4.77 },
  { name: '17-Mon', ra: 6.788842, dec: 8.037254, vmag: 4.77 },
  { name: 'φ¹-Cet', ra: 0.7365, dec: -10.60955, vmag: 4.77 },
  { name: 'O-Aqr', ra: 22.055234, dec: -2.155363, vmag: 4.77 },
  { name: 'η-Mus', ra: 13.25416, dec: -67.894589, vmag: 4.77 },
  { name: 'λ-Ari', ra: 1.965478, dec: 23.596061, vmag: 4.77 },
  { name: 'D-Ori', ra: 5.648079, dec: -7.212829, vmag: 4.78 },
  { name: 'ζ¹-Sco', ra: 16.899924, dec: -42.362025, vmag: 4.78 },
  { name: 'τ²-Eri', ra: 2.850645, dec: -21.004019, vmag: 4.78 },
  { name: '26-Hya', ra: 9.329551, dec: -11.974853, vmag: 4.78 },
  { name: 'π-Aqr', ra: 22.421284, dec: 1.377401, vmag: 4.78 },
  { name: 'S Eri', ra: 4.998816, dec: -12.537416, vmag: 4.78 },
  { name: 'ρ-UMa', ra: 9.04242, dec: 67.629619, vmag: 4.78 },
  { name: 'ω-Dra', ra: 17.615859, dec: 68.75797, vmag: 4.78 },
  { name: 'ξ-Cas', ra: 0.701081, dec: 50.512526, vmag: 4.79 },
  { name: '41-Oph', ra: 17.276857, dec: -0.445297, vmag: 4.79 },
  { name: '40-Leo', ra: 10.328938, dec: 19.470914, vmag: 4.79 },
  { name: 'V337 Cep', ra: 21.632007, dec: 62.08194, vmag: 4.79 },
  { name: 'O-Peg', ra: 22.695947, dec: 29.307641, vmag: 4.79 },
  { name: '2-Aur', ra: 4.877218, dec: 36.703187, vmag: 4.79 },
  { name: 'θ-Oct', ra: 0.026616, dec: -77.065724, vmag: 4.79 },
  { name: '58-And', ra: 2.141454, dec: 37.859077, vmag: 4.79 },
  { name: '41-Com', ra: 13.119646, dec: 27.624741, vmag: 4.79 },
  { name: 'δ²-Tau', ra: 4.401599, dec: 17.44413, vmag: 4.79 },
  { name: '24-Cep', ra: 22.163441, dec: 72.341207, vmag: 4.79 },
  { name: 'C-Oph', ra: 17.523598, dec: -23.962643, vmag: 4.79 },
  { name: '32-Peg', ra: 22.355372, dec: 28.330529, vmag: 4.79 },
  { name: '35-Peg', ra: 22.464312, dec: 4.695664, vmag: 4.8 },
  { name: 'K-Hya', ra: 14.384942, dec: -27.754017, vmag: 4.8 },
  { name: '27-Lyn', ra: 8.140963, dec: 51.50667, vmag: 4.8 },
  { name: 'σ-Vir', ra: 13.293412, dec: 5.469869, vmag: 4.8 },
  { name: 'θ-Ant', ra: 9.736694, dec: -27.769471, vmag: 4.8 },
  { name: 'Zibal', ra: 3.263896, dec: -8.81973, vmag: 4.8 },
  { name: 'IN Peg', ra: 22.358632, dec: 12.205186, vmag: 4.8 },
  { name: 'ψ²-Aur', ra: 6.655507, dec: 42.488877, vmag: 4.8 },
  { name: '29-Vul', ra: 20.642038, dec: 21.201174, vmag: 4.8 },
  { name: 'ω-Boo', ra: 15.035141, dec: 25.008138, vmag: 4.8 },
  { name: 'θ¹-Mic', ra: 21.346008, dec: -40.809465, vmag: 4.8 },
  { name: 'P Cyg', ra: 20.296445, dec: 38.03293, vmag: 4.8 },
  { name: 'κ-CrB', ra: 15.85387, dec: 35.657382, vmag: 4.8 },
  { name: 'μ¹-Gru', ra: 22.260253, dec: -41.3467, vmag: 4.81 },
  { name: 'ψ-Vir', ra: 12.905879, dec: -9.538994, vmag: 4.81 },
  { name: 'V469 Per', ra: 4.359211, dec: 46.498878, vmag: 4.81 },
  { name: 'θ-Dor', ra: 5.229288, dec: -67.185255, vmag: 4.81 },
  { name: 'ι²-Sco', ra: 17.83642, dec: -40.090435, vmag: 4.81 },
  { name: 'DD UMa', ra: 9.269808, dec: 54.021857, vmag: 4.81 },
  { name: '12-Com', ra: 12.375087, dec: 25.84616, vmag: 4.81 },
  { name: '139-Tau', ra: 5.966571, dec: 25.953912, vmag: 4.82 },
  { name: 'D-Boo', ra: 14.173315, dec: 25.091677, vmag: 4.82 },
  { name: '4-UMi', ra: 14.147498, dec: 77.547514, vmag: 4.82 },
  { name: 'χ-Peg', ra: 0.243378, dec: 20.206702, vmag: 4.82 },
  { name: 'P-Hya', ra: 9.341394, dec: -9.555695, vmag: 4.82 },
  { name: 'π-Ser', ra: 16.038248, dec: 22.804454, vmag: 4.82 },
  { name: 'σ-Aqr', ra: 22.510782, dec: -10.67795, vmag: 4.82 },
  { name: '15-Ori', ra: 5.161654, dec: 15.597232, vmag: 4.82 },
  { name: 'EY CMa', ra: 6.892474, dec: -20.224254, vmag: 4.82 },
  { name: 'ε-Crt', ra: 11.410164, dec: -10.859323, vmag: 4.82 },
  { name: 'υ-Dra', ra: 18.90661, dec: 71.297192, vmag: 4.82 },
  { name: 'ζ-Hyi', ra: 2.759048, dec: -67.616617, vmag: 4.82 },
  { name: '30-Cyg', ra: 20.22168, dec: 46.815675, vmag: 4.82 },
  { name: 'σ²-UMa', ra: 9.173204, dec: 67.134018, vmag: 4.82 },
  { name: 'A²-Aqr', ra: 23.696057, dec: -17.816533, vmag: 4.82 },
  { name: 'W Boo', ra: 14.723712, dec: 26.52785, vmag: 4.82 },
  { name: 'η-Sct', ra: 18.951019, dec: -5.846314, vmag: 4.82 },
  { name: 'σ-Ser', ra: 16.367875, dec: 1.029039, vmag: 4.83 },
  { name: 'ξ¹-Cen', ra: 13.059256, dec: -49.527264, vmag: 4.83 },
  { name: 'υ¹-Cas', ra: 0.916715, dec: 58.972698, vmag: 4.83 },
  { name: '30-Oph', ra: 17.017667, dec: -4.222644, vmag: 4.83 },
  { name: 'μ-Aur', ra: 5.223811, dec: 38.484498, vmag: 4.83 },
  { name: 'O-Col', ra: 5.291411, dec: -34.895207, vmag: 4.83 },
  { name: '126-Tau', ra: 5.688255, dec: 16.534148, vmag: 4.83 },
  { name: 'V637 Her', ra: 16.820615, dec: 45.983323, vmag: 4.83 },
  { name: '36-UMa', ra: 10.510461, dec: 55.980536, vmag: 4.83 },
  { name: 'Fafnir', ra: 18.433069, dec: 65.56348, vmag: 4.83 },
  { name: 'ε-Cet', ra: 2.659398, dec: -11.872156, vmag: 4.83 },
  { name: 'ω-And', ra: 1.460915, dec: 45.406687, vmag: 4.83 },
  { name: 'λ-Tel', ra: 18.974378, dec: -52.938629, vmag: 4.83 },
  { name: '8-And', ra: 23.295732, dec: 49.0153, vmag: 4.83 },
  { name: 'β²-Sco', ra: 16.09071, dec: -19.80186, vmag: 4.84 },
  { name: 'U Her', ra: 17.288769, dec: 33.1001, vmag: 4.84 },
  { name: 'ρ-Gru', ra: 22.724993, dec: -41.414347, vmag: 4.84 },
  { name: 'B-And', ra: 2.220369, dec: 44.231652, vmag: 4.84 },
  { name: 'H-Her', ra: 16.543415, dec: 11.488041, vmag: 4.84 },
  { name: 'D-Leo', ra: 11.009347, dec: 3.617494, vmag: 4.84 },
  { name: 'ξ-Vir', ra: 11.754733, dec: 8.258119, vmag: 4.85 },
  { name: 'μ-Psc', ra: 1.503087, dec: 6.14382, vmag: 4.85 },
  { name: '20-Boo', ra: 14.329233, dec: 16.306948, vmag: 4.85 },
  { name: 'G-Dra', ra: 16.681978, dec: 64.589046, vmag: 4.85 },
  { name: 'φ-Vir', ra: 14.470038, dec: -2.227957, vmag: 4.85 },
  { name: 'η-Cap', ra: 21.073417, dec: -19.854991, vmag: 4.85 },
  { name: '1-Cas', ra: 23.110226, dec: 59.41976, vmag: 4.85 },
  { name: 'κ-Cet', ra: 3.322693, dec: 3.370198, vmag: 4.85 },
  { name: 'η-Gru', ra: 22.760519, dec: -53.500121, vmag: 4.85 },
  { name: 'A-Sgr', ra: 19.982555, dec: -26.195767, vmag: 4.85 },
  { name: 'V1086 Ori', ra: 5.412452, dec: 1.846445, vmag: 4.86 },
  { name: 'ξ-CrB', ra: 16.368287, dec: 30.891996, vmag: 4.86 },
  { name: 'ε-Cir', ra: 15.294136, dec: -63.610465, vmag: 4.86 },
  { name: 'ν¹-Sgr', ra: 18.902827, dec: -22.744834, vmag: 4.86 },
  { name: 'V1661 Cyg', ra: 20.815637, dec: 46.114134, vmag: 4.86 },
  { name: 'ρ-Pav', ra: 20.626465, dec: -61.529918, vmag: 4.86 },
  { name: 'O-Tau', ra: 5.460579, dec: 21.936965, vmag: 4.86 },
  { name: 'λ-Col', ra: 5.885245, dec: -33.801361, vmag: 4.86 },
  { name: 'ν²-Dra', ra: 17.537767, dec: 55.172958, vmag: 4.86 },
  { name: 'ν-Peg', ra: 22.094653, dec: 5.05853, vmag: 4.86 },
  { name: '74-Oph', ra: 18.347795, dec: 3.377165, vmag: 4.86 },
  { name: 'ρ-Cet', ra: 2.432501, dec: -12.29048, vmag: 4.86 },
  { name: 'ε-CrA', ra: 18.978721, dec: -37.107357, vmag: 4.87 },
  { name: 'ζ-Ari', ra: 3.24836, dec: 21.044441, vmag: 4.87 },
  { name: '31-Boo', ra: 14.694097, dec: 8.161764, vmag: 4.87 },
  { name: 'ψ-Sgr', ra: 19.259007, dec: -25.256682, vmag: 4.87 },
  { name: 'ρ-Vir', ra: 12.698071, dec: 10.235625, vmag: 4.87 },
  { name: 'ξ-UMa', ra: 11.303118, dec: 31.528783, vmag: 4.87 },
  { name: '58-Oph', ra: 17.723833, dec: -21.683194, vmag: 4.87 },
  { name: 'δ-Pyx', ra: 8.925434, dec: -27.681871, vmag: 4.87 },
  { name: '134-Tau', ra: 5.825814, dec: 12.651324, vmag: 4.87 },
  { name: '21-Sgr', ra: 18.422511, dec: -20.541679, vmag: 4.87 },
  { name: '9-Hya', ra: 8.695371, dec: -15.943384, vmag: 4.87 },
  { name: 'δ-Tri', ra: 2.284191, dec: 34.224231, vmag: 4.87 },
  { name: 'Adhil', ra: 1.372337, dec: 45.528778, vmag: 4.87 },
  { name: '72-Cyg', ra: 21.579596, dec: 38.534054, vmag: 4.87 },
  { name: '12-Vul', ra: 19.851141, dec: 22.610046, vmag: 4.87 },
  { name: '60-Her', ra: 17.089636, dec: 12.740828, vmag: 4.88 },
  { name: 'O-Cep', ra: 23.3104, dec: 68.111445, vmag: 4.88 },
  { name: 'ν-Cet', ra: 2.597909, dec: 5.593246, vmag: 4.88 },
  { name: 'G-Gem', ra: 7.768736, dec: 18.510043, vmag: 4.88 },
  { name: 'F-Sgr', ra: 19.772707, dec: -19.761113, vmag: 4.88 },
  { name: 'τ-Cas', ra: 23.784284, dec: 58.651989, vmag: 4.88 },
  { name: 'ζ-Pyx', ra: 8.661799, dec: -29.561084, vmag: 4.88 },
  { name: '132-Tau', ra: 5.816935, dec: 24.567535, vmag: 4.88 },
  { name: '15-Eri', ra: 3.30614, dec: -22.511118, vmag: 4.88 },
  { name: 'D-Sgr', ra: 19.293911, dec: -18.952908, vmag: 4.89 },
  { name: 'ι-Tel', ra: 19.586942, dec: -48.099202, vmag: 4.89 },
  { name: 'π¹-Boo', ra: 14.678768, dec: 16.418324, vmag: 4.89 },
  { name: 'O-Gem', ra: 7.65276, dec: 34.584346, vmag: 4.89 },
  { name: 'η-Scl', ra: 0.465472, dec: -33.007167, vmag: 4.89 },
  { name: 'ν¹-Dra', ra: 17.536251, dec: 55.184243, vmag: 4.89 },
  { name: '10-Lac', ra: 22.654355, dec: 39.050269, vmag: 4.89 },
  { name: 'H-Dra', ra: 16.93375, dec: 65.134796, vmag: 4.89 },
  { name: '16-Lyn', ra: 6.960309, dec: 45.094094, vmag: 4.89 },
  { name: '27-Psc', ra: 23.977883, dec: -3.555983, vmag: 4.89 },
  { name: '15-Cyg', ra: 19.737943, dec: 37.354355, vmag: 4.89 },
  { name: 'η-Aps', ra: 14.303877, dec: -81.00776, vmag: 4.9 },
  { name: 'ε-Sct', ra: 18.725348, dec: -8.275215, vmag: 4.9 },
  { name: 'α-Mic', ra: 20.8328, dec: -33.779722, vmag: 4.9 },
  { name: 'ζ-Ind', ra: 20.824709, dec: -46.226826, vmag: 4.9 },
  { name: '37-Com', ra: 13.004576, dec: 30.785021, vmag: 4.9 },
  { name: '42-Her', ra: 16.645794, dec: 48.928342, vmag: 4.9 },
  { name: '63-Aur', ra: 7.194255, dec: 39.320549, vmag: 4.9 },
  { name: '70-Aql', ra: 20.61212, dec: -2.549957, vmag: 4.9 },
  { name: 'ρ-Peg', ra: 22.920464, dec: 8.816166, vmag: 4.9 },
  { name: '12-Per', ra: 2.704144, dec: 40.193944, vmag: 4.9 },
  { name: '56-Cet', ra: 1.944499, dec: -22.526785, vmag: 4.9 },
  { name: 'A-Eri', ra: 4.239914, dec: -10.256283, vmag: 4.9 },
  { name: '6-Cet', ra: 0.187739, dec: -15.467977, vmag: 4.9 },
  { name: '45-Eri', ra: 4.531296, dec: -0.044011, vmag: 4.91 },
  { name: 'μ-Nor', ra: 16.568061, dec: -44.045315, vmag: 4.91 },
  { name: '69-Aql', ra: 20.494167, dec: -2.885531, vmag: 4.91 },
  { name: 'B-Ori', ra: 5.707953, dec: 1.474629, vmag: 4.91 },
  { name: 'ζ-TrA', ra: 16.474422, dec: -70.084401, vmag: 4.91 },
  { name: 'G Her', ra: 16.477373, dec: 41.881677, vmag: 4.91 },
  { name: 'θ²-Ser', ra: 18.937401, dec: 4.202132, vmag: 4.91 },
  { name: 'ν-Cas', ra: 0.813892, dec: 50.968168, vmag: 4.91 },
  { name: '25-CVn', ra: 13.624345, dec: 36.294898, vmag: 4.91 },
  { name: 'μ-Dra', ra: 17.088929, dec: 54.470042, vmag: 4.91 },
  { name: 'φ-Hya', ra: 10.643043, dec: -16.876572, vmag: 4.91 },
  { name: 'CW Vir', ra: 13.56887, dec: 3.658967, vmag: 4.91 },
  { name: 'ε-Cha', ra: 11.993796, dec: -78.221839, vmag: 4.91 },
  { name: 'δ¹-Tel', ra: 18.529287, dec: -45.914814, vmag: 4.91 },
  { name: '46-Cet', ra: 1.427009, dec: -14.598796, vmag: 4.91 },
  { name: 'κ-Psc', ra: 23.448876, dec: 1.255608, vmag: 4.92 },
  { name: 'V1624 Cyg', ra: 20.157116, dec: 36.839621, vmag: 4.92 },
  { name: 'χ¹-Hya', ra: 11.088867, dec: -27.293612, vmag: 4.92 },
  { name: '20-Mon', ra: 7.170467, dec: -4.237106, vmag: 4.92 },
  { name: '30-Vul', ra: 20.747919, dec: 25.270617, vmag: 4.92 },
  { name: 'ω-Tau', ra: 4.287684, dec: 20.578591, vmag: 4.92 },
  { name: 'M-Tau', ra: 5.124164, dec: 18.645052, vmag: 4.92 },
  { name: 'E-Boo', ra: 13.828564, dec: 21.264105, vmag: 4.92 },
  { name: '14-Com', ra: 12.440018, dec: 27.268237, vmag: 4.92 },
  { name: 'I-Lup', ra: 15.2437, dec: -31.519121, vmag: 4.93 },
  { name: 'ξ-Tel', ra: 20.1231, dec: -52.880793, vmag: 4.93 },
  { name: 'ω¹-Cyg', ra: 20.500983, dec: 48.951569, vmag: 4.93 },
  { name: 'ε-Lib', ra: 15.403303, dec: -10.322266, vmag: 4.93 },
  { name: 'ψ-Sco', ra: 16.199997, dec: -10.064253, vmag: 4.93 },
  { name: 'C-Boo', ra: 15.121682, dec: 24.869195, vmag: 4.93 },
  { name: '31-Com', ra: 12.861645, dec: 27.540712, vmag: 4.93 },
  { name: '7-Com', ra: 12.272372, dec: 23.945409, vmag: 4.93 },
  { name: 'ρ-Cap', ra: 20.481004, dec: -17.813687, vmag: 4.94 },
  { name: 'ψ¹-Aur', ra: 6.414973, dec: 49.287893, vmag: 4.94 },
  { name: 'FX Lib', ra: 15.969825, dec: -14.279358, vmag: 4.94 },
  { name: '54-Per', ra: 4.340178, dec: 34.566725, vmag: 4.94 },
  { name: 'F¹-Ori', ra: 6.200911, dec: 16.130406, vmag: 4.94 },
  { name: 'μ-Lup', ra: 15.308897, dec: -47.875272, vmag: 4.94 },
  { name: '11-Lib', ra: 14.850298, dec: -2.29915, vmag: 4.94 },
  { name: 'δ-Hor', ra: 4.180708, dec: -41.993573, vmag: 4.94 },
  { name: '106-Her', ra: 18.338309, dec: 21.961297, vmag: 4.94 },
  { name: '22-Cyg', ra: 19.931045, dec: 38.486705, vmag: 4.94 },
  { name: '78-UMa', ra: 13.012125, dec: 56.366338, vmag: 4.94 },
  { name: 'ψ-Hya', ra: 13.150909, dec: -23.11807, vmag: 4.94 },
  { name: '27-Mon', ra: 7.995598, dec: -3.679583, vmag: 4.94 },
  { name: '24-Per', ra: 2.984356, dec: 35.183128, vmag: 4.94 },
  { name: 'UW CMa', ra: 7.311216, dec: -24.558701, vmag: 4.94 },
  { name: 'τ-PsA', ra: 22.169093, dec: -32.548407, vmag: 4.94 },
  { name: 'χ-Gem', ra: 8.058634, dec: 27.794332, vmag: 4.94 },
  { name: 'λ-Lyr', ra: 19.000229, dec: 32.145514, vmag: 4.94 },
  { name: 'κ-Aql', ra: 19.614847, dec: -7.027477, vmag: 4.95 },
  { name: 'ρ-Aql', ra: 20.237949, dec: 15.197609, vmag: 4.95 },
  { name: 'L-Per', ra: 3.357381, dec: 43.329651, vmag: 4.95 },
  { name: 'V1644 Cyg', ra: 20.242229, dec: 36.806302, vmag: 4.95 },
  { name: '3-Cet', ra: 0.075033, dec: -10.509523, vmag: 4.95 },
  { name: 'τ-Leo', ra: 11.465622, dec: 2.856265, vmag: 4.95 },
  { name: 'τ-And', ra: 1.676337, dec: 40.577049, vmag: 4.95 },
  { name: 'κ-Tuc', ra: 1.262704, dec: -68.875927, vmag: 4.95 },
  { name: 'π-Cas', ra: 0.724466, dec: 47.024546, vmag: 4.95 },
  { name: '6-Dra', ra: 12.578902, dec: 70.02177, vmag: 4.96 },
  { name: 'ω-For', ra: 2.564085, dec: -28.232343, vmag: 4.96 },
  { name: 'N-Tau', ra: 5.321278, dec: 22.096494, vmag: 4.96 },
  { name: '47-Tau', ra: 4.232329, dec: 9.263824, vmag: 4.96 },
  { name: 'η-UMi', ra: 16.291791, dec: 75.75533, vmag: 4.96 },
  { name: 'κ-Nor', ra: 16.224648, dec: -54.630467, vmag: 4.96 },
  { name: '15-Lac', ra: 22.867225, dec: 43.312417, vmag: 4.96 },
  { name: 'φ-Tau', ra: 4.339227, dec: 27.350754, vmag: 4.96 },
  { name: '24-Lyn', ra: 7.716788, dec: 58.71036, vmag: 4.96 },
  { name: '42-Lib', ra: 15.67136, dec: -23.818078, vmag: 4.96 },
  { name: 'ν-Tuc', ra: 22.55001, dec: -61.982122, vmag: 4.96 },
  { name: 'δ-Lib', ra: 15.016208, dec: -8.518943, vmag: 4.96 },
  { name: 'μ²-Cru', ra: 12.910251, dec: -57.16867, vmag: 4.96 },
  { name: '16-Com', ra: 12.449805, dec: 26.825699, vmag: 4.96 },
  { name: 'ω-Cas', ra: 1.933337, dec: 68.685242, vmag: 4.96 },
  { name: 'δ-For', ra: 3.704139, dec: -31.938361, vmag: 4.96 },
  { name: '89-Vir', ra: 13.831191, dec: -18.134168, vmag: 4.97 },
  { name: '78-Peg', ra: 23.733189, dec: 29.361454, vmag: 4.97 },
  { name: 'φ-Gem', ra: 7.891616, dec: 26.765783, vmag: 4.97 },
  { name: 'M-Ori', ra: 5.380556, dec: 3.544452, vmag: 4.97 },
  { name: 'ξ-Col', ra: 5.924975, dec: -37.120668, vmag: 4.97 },
  { name: 'O-Per', ra: 3.706291, dec: 33.965026, vmag: 4.97 },
  { name: 'ν-Phe', ra: 1.253043, dec: -45.531664, vmag: 4.97 },
  { name: 'ι-CrB', ra: 16.024047, dec: 29.851061, vmag: 4.97 },
  { name: 'ι-Ret', ra: 4.021697, dec: -61.078822, vmag: 4.97 },
  { name: 'C-Vir', ra: 12.339161, dec: 3.312574, vmag: 4.97 },
  { name: '2-Cyg', ra: 19.402105, dec: 29.621338, vmag: 4.97 },
  { name: 'SS Lep', ra: 6.083091, dec: -16.484435, vmag: 4.97 },
  { name: 'ξ-Leo', ra: 9.532428, dec: 11.299827, vmag: 4.97 },
  { name: 'ξ-Aur', ra: 5.914107, dec: 55.706947, vmag: 4.97 },
  { name: 'A-Dra', ra: 16.4664, dec: 68.768137, vmag: 4.97 },
  { name: '11-Sgr', ra: 18.19537, dec: -23.701235, vmag: 4.97 },
  { name: 'γ¹-Del', ra: 20.777462, dec: 16.124134, vmag: 4.97 },
  { name: 'ψ-And', ra: 23.767234, dec: 46.420276, vmag: 4.97 },
  { name: 'β-Hor', ra: 2.979939, dec: -64.071284, vmag: 4.97 },
  { name: '70-Vir', ra: 13.473837, dec: 13.778787, vmag: 4.97 },
  { name: '75-Tau', ra: 4.473992, dec: 16.359672, vmag: 4.98 },
  { name: 'γ¹-Nor', ra: 16.283593, dec: -50.068122, vmag: 4.98 },
  { name: '4-Cas', ra: 23.413959, dec: 62.282806, vmag: 4.98 },
  { name: 'V1016 Ori', ra: 5.587728, dec: -5.387315, vmag: 4.98 },
  { name: 'V637 Mon', ra: 7.048549, dec: -4.239231, vmag: 4.98 },
  { name: 'L-Hya', ra: 14.469564, dec: -29.491638, vmag: 4.98 },
  { name: 'A-Hya', ra: 8.667076, dec: -12.475372, vmag: 4.98 },
  { name: 'ν²-Boo', ra: 15.529718, dec: 40.899332, vmag: 4.98 },
  { name: 'C-Leo', ra: 11.012445, dec: 6.101449, vmag: 4.98 },
  { name: 'ψ⁷-Aur', ra: 6.846097, dec: 41.78123, vmag: 4.98 },
  { name: '9-Aur', ra: 5.111289, dec: 51.59772, vmag: 4.98 },
  { name: '9-Vul', ra: 19.57636, dec: 19.773403, vmag: 4.98 },
  { name: 'ω¹-Aqr', ra: 23.663074, dec: -14.222178, vmag: 4.98 },
  { name: '14-Ari', ra: 2.157036, dec: 25.939892, vmag: 4.99 },
  { name: 'υ-PsA', ra: 22.140537, dec: -34.043841, vmag: 4.99 },
  { name: 'θ-Col', ra: 6.125453, dec: -37.25292, vmag: 4.99 },
  { name: 'ω-Hya', ra: 9.099546, dec: 5.092316, vmag: 4.99 },
  { name: '56-UMa', ra: 11.380442, dec: 43.482703, vmag: 4.99 },
  { name: 'γ-CrA', ra: 19.106847, dec: -37.06474, vmag: 4.99 },
  { name: 'V669 Her', ra: 18.198377, dec: 31.40535, vmag: 4.99 },
  { name: 'η-Tuc', ra: 23.959727, dec: -64.298231, vmag: 4.99 },
  { name: '24-Com', ra: 12.585489, dec: 18.377058, vmag: 4.99 },
  { name: 'ε-CMi', ra: 7.427471, dec: 9.276097, vmag: 4.99 },
  { name: '20-Pup', ra: 8.222213, dec: -15.788221, vmag: 5 },
  { name: '36-Dra', ra: 18.231545, dec: 64.397287, vmag: 5 },
  { name: 'F-Aql', ra: 19.342473, dec: -5.415766, vmag: 5 },
  { name: 'ω-Aur', ra: 4.987612, dec: 37.890245, vmag: 5 },
  { name: 'G-Sgr', ra: 19.965842, dec: -15.49149, vmag: 5 },
  { name: 'G-Per', ra: 2.038359, dec: 54.487541, vmag: 5 },
  { name: 'κ-Her', ra: 16.134591, dec: 17.04698, vmag: 5 },
  { name: 'ν¹-Lup', ra: 15.368975, dec: -47.927792, vmag: 5 },
  { name: 'θ-UMi', ra: 15.523619, dec: 77.349352, vmag: 5 },
  { name: 'ψ³-Aqr', ra: 23.316021, dec: -9.61075, vmag: 5 },
  { name: '4-Aql', ra: 18.747205, dec: 2.060038, vmag: 5 },
  { name: 'ν²-Sgr', ra: 18.918649, dec: -22.671328, vmag: 5 },
  { name: 'χ-Aqr', ra: 23.280817, dec: -7.726504, vmag: 5 },
  { name: '3-Mon', ra: 6.030673, dec: -10.59793, vmag: 5 },
  { name: 'KW Aur', ra: 5.256777, dec: 32.6876, vmag: 5.01 },
  { name: 'φ-Cas', ra: 1.334699, dec: 58.231611, vmag: 5.01 },
  { name: '111-Tau', ra: 5.407071, dec: 17.383534, vmag: 5.01 },
  { name: 'σ-Aur', ra: 5.410873, dec: 37.385346, vmag: 5.01 },
  { name: '98-Her', ra: 18.100528, dec: 22.218879, vmag: 5.01 },
  { name: '54-Dra', ra: 19.231987, dec: 57.705102, vmag: 5.01 },
  { name: '9-Boo', ra: 13.942827, dec: 27.492082, vmag: 5.01 },
  { name: '16-Lyr', ra: 19.023991, dec: 46.934812, vmag: 5.01 },
  { name: 'TX Psc', ra: 23.773199, dec: 3.486811, vmag: 5.01 },
  { name: '17-Cyg', ra: 19.773777, dec: 33.727598, vmag: 5.01 },
  { name: 'B-Tau', ra: 4.480601, dec: 13.047602, vmag: 5.01 },
  { name: 'ζ-Scl', ra: 0.038867, dec: -29.720414, vmag: 5.01 },
  { name: '32-Vul', ra: 20.909344, dec: 28.057621, vmag: 5.02 },
  { name: 'χ¹-Sgr', ra: 19.421247, dec: -24.508575, vmag: 5.02 },
  { name: 'χ-And', ra: 1.655835, dec: 44.386165, vmag: 5.02 },
  { name: '10-Leo', ra: 9.620185, dec: 6.835802, vmag: 5.02 },
  { name: 'B-Gem', ra: 7.49688, dec: 27.916146, vmag: 5.02 },
  { name: 'θ-PsA', ra: 21.795598, dec: -30.898304, vmag: 5.02 },
  { name: '30-Dra', ra: 17.817862, dec: 50.781075, vmag: 5.02 },
  { name: '6-CVn', ra: 12.43082, dec: 39.018616, vmag: 5.02 },
  { name: '72-Peg', ra: 23.565884, dec: 31.325277, vmag: 5.02 },
  { name: 'η-CrB', ra: 15.38675, dec: 30.287812, vmag: 5.02 },
  { name: 'A-Oph', ra: 17.255734, dec: -26.603215, vmag: 5.02 },
  { name: 'η-Tel', ra: 19.380888, dec: -54.423931, vmag: 5.02 },
  { name: 'ψ-Cyg', ra: 19.927167, dec: 52.438948, vmag: 5.02 },
  { name: 'D-Cyg', ra: 19.843813, dec: 52.988001, vmag: 5.02 },
  { name: 'κ-Ari', ra: 2.109423, dec: 22.648317, vmag: 5.02 },
  { name: '11-UMi', ra: 15.284968, dec: 71.823901, vmag: 5.03 },
  { name: '35-Dra', ra: 17.824155, dec: 76.962881, vmag: 5.03 },
  { name: '31-Per', ra: 3.318787, dec: 50.094966, vmag: 5.03 },
  { name: '10-Mon', ra: 6.465992, dec: -4.762154, vmag: 5.03 },
  { name: 'A-Gem', ra: 7.391254, dec: 25.050531, vmag: 5.03 },
  { name: 'V1809 Cyg', ra: 21.307551, dec: 43.945945, vmag: 5.03 },
  { name: 'λ-Lib', ra: 15.888905, dec: -20.16704, vmag: 5.03 },
  { name: 'C-Dra', ra: 18.710543, dec: 55.539457, vmag: 5.03 },
  { name: 'θ-Cir', ra: 14.945554, dec: -62.781016, vmag: 5.03 },
  { name: '41-And', ra: 1.133559, dec: 43.942092, vmag: 5.03 },
  { name: '22-And', ra: 0.172012, dec: 46.072272, vmag: 5.03 },
  { name: 'CQ Dra', ra: 12.501868, dec: 69.201123, vmag: 5.03 },
  { name: 'ν-Dor', ra: 6.145643, dec: -68.843409, vmag: 5.03 },
  { name: '4-Pup', ra: 7.765797, dec: -14.563805, vmag: 5.03 },
  { name: '60-Eri', ra: 4.83656, dec: -16.217159, vmag: 5.03 },
  { name: 'η²-Dor', ra: 6.1875, dec: -65.589417, vmag: 5.03 },
  { name: '2-Mon', ra: 5.984531, dec: -9.55825, vmag: 5.04 },
  { name: 'Pleione', ra: 3.819782, dec: 24.136712, vmag: 5.04 },
  { name: 'ζ-Sge', ra: 19.816294, dec: 19.142042, vmag: 5.04 },
  { name: 'Situla', ra: 22.629273, dec: -4.228056, vmag: 5.04 },
  { name: '51-Her', ra: 16.862573, dec: 24.656433, vmag: 5.04 },
  { name: 'θ²-Ori', ra: 5.589695, dec: -5.41606, vmag: 5.04 },
  { name: 'UW Lyn', ra: 6.298563, dec: 61.515286, vmag: 5.04 },
  { name: '53-Vir', ra: 13.200984, dec: -16.198601, vmag: 5.04 },
  { name: 'E-Aql', ra: 19.511066, dec: -2.788887, vmag: 5.04 },
  { name: 'κ-Cha', ra: 12.079616, dec: -76.519061, vmag: 5.04 },
  { name: 'B-Dra', ra: 18.398507, dec: 58.800736, vmag: 5.04 },
  { name: '46-UMa', ra: 10.928999, dec: 33.506929, vmag: 5.04 },
  { name: '28-Vul', ra: 20.642198, dec: 24.115958, vmag: 5.04 },
  { name: 'Chalawan', ra: 10.99112, dec: 40.430257, vmag: 5.04 },
  { name: '74-Cyg', ra: 21.615827, dec: 40.413521, vmag: 5.04 },
  { name: '35-Com', ra: 12.888263, dec: 21.244943, vmag: 5.04 },
  { name: 'κ-Hya', ra: 9.671768, dec: -14.332292, vmag: 5.04 },
  { name: 'K-Ori', ra: 6.274061, dec: 12.272163, vmag: 5.04 },
  { name: 'β-Cae', ra: 4.700965, dec: -37.144297, vmag: 5.04 },
  { name: 'ε-Aps', ra: 14.373108, dec: -80.108945, vmag: 5.04 },
  { name: '17-Vul', ra: 20.114835, dec: 23.614425, vmag: 5.05 },
  { name: '16-Cep', ra: 21.987518, dec: 73.179896, vmag: 5.05 },
  { name: 'δ-Cae', ra: 4.513916, dec: -44.953749, vmag: 5.05 },
  { name: 'F-Gem', ra: 7.657942, dec: 17.674519, vmag: 5.05 },
  { name: 'ψ⁴-Aur', ra: 6.718051, dec: 44.52445, vmag: 5.05 },
  { name: 'ι¹-Mus', ra: 13.418694, dec: -74.887818, vmag: 5.05 },
  { name: 'ν¹-Boo', ra: 15.515488, dec: 40.833047, vmag: 5.05 },
  { name: '19-Aur', ra: 5.333589, dec: 33.958054, vmag: 5.05 },
  { name: 'ρ-Oph', ra: 16.426422, dec: -23.447178, vmag: 5.05 },
  { name: 'ζ-Cha', ra: 9.564857, dec: -80.941258, vmag: 5.05 },
  { name: 'ι-Ind', ra: 20.858347, dec: -51.608179, vmag: 5.05 },
  { name: 'β-Sextans', ra: 10.504855, dec: -0.637026, vmag: 5.05 },
  { name: 'E²-Sgr', ra: 19.708648, dec: -16.123996, vmag: 5.05 },
  { name: 'M-Vir', ra: 13.693549, dec: -8.702984, vmag: 5.05 },
  { name: '56-Cyg', ra: 20.834695, dec: 44.059304, vmag: 5.05 },
  { name: 'E-Cyg', ra: 20.022655, dec: 50.104695, vmag: 5.05 },
  { name: 'ξ¹-Sgr', ra: 18.955688, dec: -20.656346, vmag: 5.06 },
  { name: 'η²-Pic', ra: 5.082776, dec: -49.577837, vmag: 5.06 },
  { name: 'B-Her', ra: 18.117097, dec: 30.56214, vmag: 5.06 },
  { name: 'δ²-Tel', ra: 18.533874, dec: -45.757382, vmag: 5.06 },
  { name: 'β³-Tuc', ra: 0.545512, dec: -63.0315, vmag: 5.06 },
  { name: 'θ¹-Ori', ra: 5.587907, dec: -5.389696, vmag: 5.06 },
  { name: 'MQ Ser', ra: 15.321888, dec: 1.765408, vmag: 5.07 },
  { name: '64-Gem', ra: 7.489012, dec: 28.118275, vmag: 5.07 },
  { name: 'E-Tau', ra: 3.804519, dec: 11.143294, vmag: 5.07 },
  { name: '14-Peg', ra: 21.830748, dec: 30.174215, vmag: 5.07 },
  { name: '49-UMa', ra: 11.014009, dec: 39.212092, vmag: 5.07 },
  { name: '31-Cep', ra: 22.596077, dec: 73.643188, vmag: 5.07 },
  { name: '64-Psc', ra: 0.816308, dec: 16.940644, vmag: 5.07 },
  { name: 'φ-Aur', ra: 5.460802, dec: 34.475892, vmag: 5.07 },
  { name: 'H-Leo', ra: 9.53266, dec: 9.715767, vmag: 5.07 },
  { name: '41-LMi', ra: 10.7236, dec: 23.188404, vmag: 5.07 },
  { name: '16-Peg', ra: 21.88438, dec: 25.92514, vmag: 5.07 },
  { name: 'TV Psc', ra: 0.467475, dec: 17.893125, vmag: 5.07 },
  { name: 'B-Psc', ra: 23.339051, dec: 5.381307, vmag: 5.08 },
  { name: '48-Leo', ra: 10.580004, dec: 6.953749, vmag: 5.08 },
  { name: 'α-Men', ra: 6.170632, dec: -74.753045, vmag: 5.08 },
  { name: 'P-Ori', ra: 5.40803, dec: -0.891328, vmag: 5.08 },
  { name: '50-Hya', ra: 14.212785, dec: -27.261186, vmag: 5.08 },
  { name: 'ξ¹-Lup', ra: 15.948193, dec: -33.966134, vmag: 5.08 },
  { name: '94-Cet', ra: 3.212899, dec: -1.196101, vmag: 5.08 },
  { name: 'κ-Del', ra: 20.652161, dec: 10.086203, vmag: 5.08 },
  { name: 'λ-Crt', ra: 11.389415, dec: -18.779973, vmag: 5.08 },
  { name: 'σ¹-Tau', ra: 4.65256, dec: 15.799846, vmag: 5.08 },
  { name: '3-Cam', ra: 4.66519, dec: 53.079535, vmag: 5.08 },
  { name: '44-Hya', ra: 10.566912, dec: -23.745165, vmag: 5.08 },
  { name: 'F-Dra', ra: 17.532745, dec: 68.135024, vmag: 5.08 },
  { name: 'Y Aql', ra: 19.116279, dec: 11.071228, vmag: 5.08 },
  { name: 'δ-Cir', ra: 15.282471, dec: -60.957255, vmag: 5.08 },
  { name: 'μ-Cap', ra: 21.888268, dec: -13.551768, vmag: 5.08 },
  { name: 'ε-Dor', ra: 5.831539, dec: -66.901187, vmag: 5.08 },
  { name: 'τ²-Ari', ra: 3.379234, dec: 20.742069, vmag: 5.08 },
  { name: '6-Com', ra: 12.266719, dec: 14.899071, vmag: 5.08 },
  { name: 'C-Cap', ra: 21.750071, dec: -9.082428, vmag: 5.09 },
  { name: 'φ-Peg', ra: 23.874802, dec: 19.120287, vmag: 5.09 },
  { name: '12-Pup', ra: 7.984921, dec: -23.310396, vmag: 5.09 },
  { name: '43-Cam', ra: 6.895068, dec: 68.888309, vmag: 5.09 },
  { name: 'O-Pav', ra: 21.222351, dec: -70.126267, vmag: 5.09 },
  { name: 'λ-Cep', ra: 22.191828, dec: 59.414488, vmag: 5.09 },
  { name: '66-Peg', ra: 23.384602, dec: 12.31391, vmag: 5.09 },
  { name: 'LT Per', ra: 2.954801, dec: 31.934219, vmag: 5.09 },
  { name: 'BQ Gem', ra: 7.222854, dec: 16.158966, vmag: 5.09 },
  { name: 'B-Ser', ra: 15.854331, dec: -3.090497, vmag: 5.09 },
  { name: 'λ-Hyi', ra: 0.809777, dec: -74.923438, vmag: 5.09 },
  { name: 'V480 Tau', ra: 4.856239, dec: 18.839861, vmag: 5.09 },
  { name: '29-Psc', ra: 0.030402, dec: -3.027504, vmag: 5.09 },
  { name: 'M-Hya', ra: 14.766691, dec: -25.443181, vmag: 5.1 },
  { name: '77-Peg', ra: 23.722878, dec: 10.331536, vmag: 5.1 },
  { name: '56-Gem', ra: 7.365795, dec: 20.443658, vmag: 5.1 },
  { name: 'η-Sge', ra: 20.08597, dec: 19.991071, vmag: 5.1 },
  { name: '66-Eri', ra: 5.112681, dec: -4.655163, vmag: 5.1 },
  { name: '95-Her', ra: 18.025113, dec: 21.595782, vmag: 5.1 },
  { name: '2-And', ra: 23.043436, dec: 42.757795, vmag: 5.1 },
  { name: 'R-Tau', ra: 4.397729, dec: 9.460968, vmag: 5.1 },
  { name: 'ζ-CMi', ra: 7.861663, dec: 1.766868, vmag: 5.1 },
  { name: 'O¹-Cen', ra: 11.529464, dec: -59.442061, vmag: 5.1 },
  { name: 'κ-TrA', ra: 15.924891, dec: -68.603001, vmag: 5.1 },
  { name: 'ι-Mic', ra: 20.808084, dec: -43.988544, vmag: 5.1 },
  { name: '101-Her', ra: 18.148018, dec: 20.045233, vmag: 5.1 },
  { name: 'φ-Phe', ra: 1.906122, dec: -42.49695, vmag: 5.11 },
  { name: '87-Her', ra: 17.813652, dec: 25.622869, vmag: 5.11 },
  { name: 'μ-Lyr', ra: 18.40383, dec: 39.507239, vmag: 5.11 },
  { name: 'D-Aqr', ra: 21.65924, dec: 2.243558, vmag: 5.11 },
  { name: '75-Cyg', ra: 21.669749, dec: 43.273839, vmag: 5.11 },
  { name: 'γ-Sextans', ra: 9.875121, dec: -8.10503, vmag: 5.11 },
  { name: 'R-Her', ra: 16.020644, dec: 17.818397, vmag: 5.11 },
  { name: '48-Cet', ra: 1.49337, dec: -21.629339, vmag: 5.11 },
  { name: 'O-Oph', ra: 17.300189, dec: -24.286901, vmag: 5.11 },
  { name: 'μ-CMa', ra: 6.935179, dec: -14.04343, vmag: 5.11 },
  { name: '42-Cam', ra: 6.849191, dec: 67.571934, vmag: 5.11 },
  { name: 'ι-Ari', ra: 1.955848, dec: 17.817532, vmag: 5.11 },
  { name: '19-LMi', ra: 9.96141, dec: 41.055633, vmag: 5.11 },
  { name: '13-Lac', ra: 22.734856, dec: 41.819235, vmag: 5.11 },
  { name: 'γ¹-Oct', ra: 23.868518, dec: -82.018818, vmag: 5.11 },
  { name: 'λ-CrA', ra: 18.729706, dec: -38.323441, vmag: 5.11 },
  { name: '59-Dra', ra: 19.152716, dec: 76.560502, vmag: 5.12 },
  { name: '38-UMa', ra: 10.69908, dec: 65.71628, vmag: 5.12 },
  { name: 'θ-Nor', ra: 16.254257, dec: -47.372021, vmag: 5.12 },
  { name: '19-Cep', ra: 22.085775, dec: 62.279814, vmag: 5.12 },
  { name: '44-UMa', ra: 10.892911, dec: 54.585128, vmag: 5.12 },
  { name: 'S-Tau', ra: 3.506797, dec: 11.336442, vmag: 5.12 },
  { name: '27-Com', ra: 12.777433, dec: 16.577691, vmag: 5.12 },
  { name: 'T-Her', ra: 18.350283, dec: 28.869954, vmag: 5.12 },
  { name: '70-Her', ra: 17.348391, dec: 24.499435, vmag: 5.12 },
  { name: '64-Ori', ra: 6.057602, dec: 19.690561, vmag: 5.12 },
  { name: 'ν-Mic', ra: 20.565297, dec: -44.516048, vmag: 5.12 },
  { name: 'V1288 Aql', ra: 19.228529, dec: 2.293707, vmag: 5.12 },
  { name: 'μ²-Gru', ra: 22.274045, dec: -41.627225, vmag: 5.12 },
  { name: 'φ-For', ra: 2.467139, dec: -33.811039, vmag: 5.13 },
  { name: '65-Aur', ra: 7.367397, dec: 36.760584, vmag: 5.13 },
  { name: '37-Aql', ra: 19.585349, dec: -10.560444, vmag: 5.13 },
  { name: 'Cervantes', ra: 17.735752, dec: -51.834053, vmag: 5.13 },
  { name: '68-Eri', ra: 5.145472, dec: -4.456207, vmag: 5.13 },
  { name: 'υ-Pav', ra: 20.699186, dec: -66.760682, vmag: 5.13 },
  { name: '47-Aqr', ra: 22.35988, dec: -21.59823, vmag: 5.13 },
  { name: 'φ²-Pav', ra: 20.667347, dec: -60.548892, vmag: 5.13 },
  { name: 'μ-Hor', ra: 3.060239, dec: -59.737775, vmag: 5.13 },
  { name: '53-Dra', ra: 19.194597, dec: 56.859213, vmag: 5.13 },
  { name: 'π-PsA', ra: 23.05828, dec: -34.749412, vmag: 5.13 },
  { name: 'O-Aql', ra: 19.850456, dec: 10.415727, vmag: 5.13 },
  { name: 'V1746 Cyg', ra: 19.998665, dec: 37.042885, vmag: 5.13 },
  { name: 'α-Oct', ra: 21.078621, dec: -77.023767, vmag: 5.13 },
  { name: 'ω-Pav', ra: 18.976812, dec: -60.20055, vmag: 5.13 },
  { name: 'χ-Cnc', ra: 8.334406, dec: 27.217707, vmag: 5.13 },
  { name: '8-Cnc', ra: 8.08458, dec: 13.118215, vmag: 5.13 },
  { name: 'V467 Per', ra: 3.825748, dec: 33.091382, vmag: 5.14 },
  { name: 'BK CVn', ra: 13.304034, dec: 49.682062, vmag: 5.14 },
  { name: 'λ-Dor', ra: 5.438687, dec: -58.91252, vmag: 5.14 },
  { name: 'F-Psc', ra: 1.296654, dec: 3.614466, vmag: 5.14 },
  { name: 'π-Phe', ra: 23.982155, dec: -52.745807, vmag: 5.14 },
  { name: '23-Cyg', ra: 19.88816, dec: 57.523482, vmag: 5.14 },
  { name: '25-Mon', ra: 7.621303, dec: -4.110979, vmag: 5.14 },
  { name: 'μ-Col', ra: 5.766637, dec: -32.306435, vmag: 5.14 },
  { name: '4-Vul', ra: 19.424611, dec: 19.798365, vmag: 5.14 },
  { name: 'π-Gem', ra: 7.791757, dec: 33.415697, vmag: 5.14 },
  { name: 'I Boo', ra: 15.063174, dec: 47.65406, vmag: 5.15 },
  { name: 'μ-CrB', ra: 15.587476, dec: 39.010067, vmag: 5.15 },
  { name: '36-Lib', ra: 15.577033, dec: -28.046983, vmag: 5.15 },
  { name: '37-Cet', ra: 1.240011, dec: -7.922826, vmag: 5.15 },
  { name: 'υ-Vir', ra: 14.325689, dec: -2.265518, vmag: 5.15 },
  { name: 'GN Com', ra: 12.405146, dec: 26.098606, vmag: 5.15 },
  { name: '27-UMa', ra: 9.715895, dec: 72.252618, vmag: 5.15 },
  { name: 'β-Equ', ra: 21.381559, dec: 6.81114, vmag: 5.15 },
  { name: 'F-Her', ra: 17.888341, dec: 40.007959, vmag: 5.15 },
  { name: 'α¹-Lib', ra: 14.844773, dec: -15.997237, vmag: 5.15 },
  { name: 'GZ Peg', ra: 23.158738, dec: 8.677161, vmag: 5.15 },
  { name: '29-Per', ra: 3.310482, dec: 50.222174, vmag: 5.15 },
  { name: 'ζ²-Mus', ra: 12.368713, dec: -67.522105, vmag: 5.15 },
  { name: 'σ¹-UMa', ra: 9.139867, dec: 66.873235, vmag: 5.15 },
  { name: 'χ-Phe', ra: 2.02844, dec: -44.713509, vmag: 5.15 },
  { name: 'V1741 Cyg', ra: 19.435868, dec: 36.317896, vmag: 5.15 },
  { name: '35-Lyn', ra: 8.865787, dec: 43.726603, vmag: 5.15 },
  { name: '10-Ser', ra: 15.477288, dec: 1.842081, vmag: 5.16 },
  { name: 'σ-Phe', ra: 23.787776, dec: -50.226461, vmag: 5.16 },
  { name: 'ξ-Cnc', ra: 9.155982, dec: 22.045446, vmag: 5.16 },
  { name: '125-Tau', ra: 5.662277, dec: 25.897091, vmag: 5.16 },
  { name: 'η-Crt', ra: 11.933599, dec: -17.150829, vmag: 5.16 },
  { name: '23-Aql', ra: 19.309026, dec: 1.085129, vmag: 5.16 },
  { name: '49-Vir', ra: 13.131614, dec: -10.740408, vmag: 5.16 },
  { name: '59-Peg', ra: 23.195608, dec: 8.720116, vmag: 5.16 },
  { name: 'φ-Cap', ra: 21.260528, dec: -20.651696, vmag: 5.16 },
  { name: '14-Tri', ra: 2.535045, dec: 36.147271, vmag: 5.16 },
  { name: 'G-Psc', ra: 1.185213, dec: 31.424736, vmag: 5.16 },
  { name: '37-UMa', ra: 10.586017, dec: 57.082637, vmag: 5.16 },
  { name: '1-Aqr', ra: 20.656914, dec: 0.486445, vmag: 5.16 },
  { name: 'I-Her', ra: 16.763859, dec: 8.582616, vmag: 5.16 },
  { name: 'μ-Cas', ra: 1.137477, dec: 54.92034, vmag: 5.16 },
  { name: 'υ-Cap', ra: 20.667485, dec: -18.138659, vmag: 5.16 },
  { name: 'τ¹-Ser', ra: 15.429832, dec: 15.428036, vmag: 5.16 },
  { name: 'GS Tau', ra: 4.110114, dec: 27.599903, vmag: 5.16 },
  { name: 'ε-Ari', ra: 2.986868, dec: 21.340429, vmag: 5.16 },
  { name: 'P-Vir', ra: 13.911707, dec: -1.503125, vmag: 5.17 },
  { name: 'B-Aql', ra: 19.416164, dec: 11.944415, vmag: 5.17 },
  { name: '42-Cap', ra: 21.692462, dec: -14.047611, vmag: 5.17 },
  { name: 'ρ-And', ra: 0.352017, dec: 37.968603, vmag: 5.17 },
  { name: 'σ-Peg', ra: 22.873353, dec: 9.835664, vmag: 5.17 },
  { name: 'ξ-Eri', ra: 4.394681, dec: -3.74547, vmag: 5.17 },
  { name: '6-Pup', ra: 7.828111, dec: -17.228408, vmag: 5.17 },
  { name: 'μ-Ind', ra: 21.08729, dec: -54.727042, vmag: 5.17 },
  { name: '35-Cyg', ra: 20.310853, dec: 34.982775, vmag: 5.17 },
  { name: '42-Cas', ra: 1.715493, dec: 70.622526, vmag: 5.17 },
  { name: 'ι-Scl', ra: 0.358665, dec: -28.981469, vmag: 5.17 },
  { name: 'φ²-Cet', ra: 0.835443, dec: -10.644326, vmag: 5.17 },
  { name: '6-Cep', ra: 21.322838, dec: 64.871855, vmag: 5.17 },
  { name: 'η-Cir', ra: 15.08003, dec: -64.03135, vmag: 5.18 },
  { name: 'δ-Sextans', ra: 10.491306, dec: -2.739078, vmag: 5.18 },
  { name: 'κ-Tel', ra: 18.877675, dec: -52.10737, vmag: 5.18 },
  { name: 'σ-Aql', ra: 19.653234, dec: 5.397773, vmag: 5.18 },
  { name: '75-Leo', ra: 11.288167, dec: 2.010556, vmag: 5.18 },
  { name: 'O²-Cen', ra: 11.530223, dec: -59.515648, vmag: 5.18 },
  { name: 'QS Vul', ra: 20.2584, dec: 23.508906, vmag: 5.18 },
  { name: 'θ-Vol', ra: 8.651428, dec: -70.386745, vmag: 5.18 },
  { name: 'ρ-Tel', ra: 19.10554, dec: -52.34091, vmag: 5.18 },
  { name: 'UV Ari', ra: 2.749328, dec: 12.445761, vmag: 5.18 },
  { name: '3-Vul', ra: 19.380801, dec: 26.262403, vmag: 5.18 },
  { name: 'ε-Oct', ra: 22.333754, dec: -80.439747, vmag: 5.19 },
  { name: 'γ-Men', ra: 5.531318, dec: -76.340964, vmag: 5.19 },
  { name: 'AF Dra', ra: 20.525112, dec: 74.954619, vmag: 5.19 },
  { name: 'G-Ori', ra: 4.913027, dec: 11.426006, vmag: 5.19 },
  { name: 'ω-Gem', ra: 7.040217, dec: 24.215446, vmag: 5.19 },
  { name: '17-Del', ra: 20.926858, dec: 13.721536, vmag: 5.19 },
  { name: '64-And', ra: 2.406919, dec: 50.006546, vmag: 5.19 },
  { name: '30-Cep', ra: 22.644182, dec: 63.584472, vmag: 5.19 },
  { name: 'ET Aqr', ra: 23.855927, dec: -18.909163, vmag: 5.19 },
  { name: 'E-Vir', ra: 13.279588, dec: 9.424156, vmag: 5.19 },
  { name: 'ζ-Psc', ra: 1.228857, dec: 7.575354, vmag: 5.19 },
  { name: '2-Dra', ra: 11.600744, dec: 69.322952, vmag: 5.19 },
  { name: '66-Aur', ra: 7.402352, dec: 40.672389, vmag: 5.2 },
  { name: 'NU Vul', ra: 20.237369, dec: 28.694817, vmag: 5.2 },
  { name: 'ν-Lib', ra: 15.110444, dec: -16.256818, vmag: 5.2 },
  { name: 'C-UMa', ra: 9.239041, dec: 61.423318, vmag: 5.2 },
  { name: 'ρ-Aur', ra: 5.363448, dec: 41.804572, vmag: 5.2 },
  { name: 'V1509 Cyg', ra: 19.842776, dec: 38.722419, vmag: 5.2 },
  { name: '60-Ori', ra: 5.980437, dec: 0.552979, vmag: 5.2 },
  { name: 'κ-Ara', ra: 17.433344, dec: -50.63351, vmag: 5.2 },
  { name: 'κ-For', ra: 2.375704, dec: -23.816326, vmag: 5.2 },
  { name: '14-CVn', ra: 13.095678, dec: 35.798899, vmag: 5.2 },
  { name: 'V1803 Cyg', ra: 21.114794, dec: 38.749415, vmag: 5.2 },
  { name: '94-Aqr', ra: 23.318518, dec: -13.458552, vmag: 5.2 },
  { name: '97-Aqr', ra: 23.377547, dec: -15.039338, vmag: 5.2 },
  { name: '71-Ori', ra: 6.247467, dec: 19.156448, vmag: 5.2 },
  { name: '9-Pup', ra: 7.862862, dec: -13.898029, vmag: 5.2 },
  { name: 'V474 Per', ra: 2.372621, dec: 55.845653, vmag: 5.21 },
  { name: '18-Lyn', ra: 7.265267, dec: 59.637467, vmag: 5.21 },
  { name: 'TU Cam', ra: 5.916063, dec: 59.888367, vmag: 5.21 },
  { name: 'ζ-Crv', ra: 12.34268, dec: -22.215901, vmag: 5.21 },
  { name: '47-Hya', ra: 13.975319, dec: -24.972249, vmag: 5.21 },
  { name: '13-Cet', ra: 0.587466, dec: -3.592846, vmag: 5.21 },
  { name: 'κ-Cnc', ra: 9.129115, dec: 10.668191, vmag: 5.21 },
  { name: 'υ-Aqr', ra: 22.57823, dec: -20.708216, vmag: 5.21 },
  { name: 'ψ-Tau', ra: 4.116795, dec: 29.001299, vmag: 5.21 },
  { name: 'υ-Phe', ra: 1.129957, dec: -41.486916, vmag: 5.21 },
  { name: 'DV Eri', ra: 4.569897, dec: -8.231352, vmag: 5.21 },
  { name: 'DP UMa', ra: 12.035239, dec: 43.0456, vmag: 5.21 },
  { name: '8-Lep', ra: 5.39171, dec: -13.927352, vmag: 5.21 },
  { name: '5-Lyn', ra: 6.44691, dec: 58.417409, vmag: 5.21 },
  { name: 'FM Vir', ra: 12.760294, dec: 7.673326, vmag: 5.22 },
  { name: 'C-Eri', ra: 4.626703, dec: -2.473548, vmag: 5.22 },
  { name: 'ν¹-CrB', ra: 16.372618, dec: 33.799052, vmag: 5.22 },
  { name: '24-Eri', ra: 3.741808, dec: -1.163091, vmag: 5.22 },
  { name: 'ζ-Hor', ra: 2.677666, dec: -54.549911, vmag: 5.22 },
  { name: 'V776 Her', ra: 16.796227, dec: 5.246746, vmag: 5.22 },
  { name: '26-Gem', ra: 6.706757, dec: 17.645303, vmag: 5.22 },
  { name: 'DD Lac', ra: 22.691292, dec: 40.225449, vmag: 5.22 },
  { name: 'α-Com', ra: 13.166389, dec: 17.528977, vmag: 5.22 },
  { name: 'GN And', ra: 0.502045, dec: 29.751557, vmag: 5.22 },
  { name: 'H-Vir', ra: 13.549465, dec: -10.165, vmag: 5.22 },
  { name: '29-Sgr', ra: 18.827807, dec: -20.324656, vmag: 5.22 },
  { name: 'ψ⁶-Aur', ra: 6.794327, dec: 48.789476, vmag: 5.22 },
  { name: '26-Dra', ra: 17.58317, dec: 61.874554, vmag: 5.22 },
  { name: '49-Cas', ra: 2.092103, dec: 76.11506, vmag: 5.22 },
  { name: 'G-Cyg', ra: 21.490816, dec: 46.540585, vmag: 5.22 },
  { name: 'ω-Ser', ra: 15.838207, dec: 2.196509, vmag: 5.22 },
  { name: 'μ-CrA', ra: 18.795726, dec: -40.406167, vmag: 5.23 },
  { name: 'O¹-Cnc', ra: 8.954152, dec: 15.322762, vmag: 5.23 },
  { name: '57-Vir', ra: 13.266322, dec: -19.943103, vmag: 5.23 },
  { name: 'FT CMa', ra: 6.741241, dec: -31.070523, vmag: 5.23 },
  { name: 'σ³-Cnc', ra: 8.992405, dec: 32.418559, vmag: 5.23 },
  { name: 'ε²-Lyr', ra: 18.739661, dec: 39.612721, vmag: 5.23 },
  { name: 'ν-Lyr', ra: 18.831366, dec: 32.551058, vmag: 5.23 },
  { name: 'BV Cam', ra: 5.102349, dec: 58.972372, vmag: 5.23 },
  { name: 'η-Ant', ra: 9.981191, dec: -35.890973, vmag: 5.23 },
  { name: '17-Lyr', ra: 19.123769, dec: 32.501738, vmag: 5.23 },
  { name: 'τ-Oph', ra: 18.051367, dec: -8.180349, vmag: 5.23 },
  { name: 'EG Eri', ra: 3.604837, dec: -17.467064, vmag: 5.23 },
  { name: 'ρ²-Cnc', ra: 8.927689, dec: 27.927481, vmag: 5.23 },
  { name: 'η-CMi', ra: 7.467243, dec: 6.941968, vmag: 5.23 },
  { name: 'AI Com', ra: 12.481863, dec: 25.912852, vmag: 5.23 },
  { name: 'Veritate', ra: 23.52149, dec: 39.236198, vmag: 5.23 },
  { name: '8-Dra', ra: 12.924598, dec: 65.438474, vmag: 5.23 },
  { name: 'ρ-Phe', ra: 0.844768, dec: -50.986816, vmag: 5.23 },
  { name: 'L-Psc', ra: 1.352047, dec: 28.738207, vmag: 5.23 },
  { name: 'E-Dra', ra: 20.024594, dec: 64.820974, vmag: 5.24 },
  { name: 'η-Ari', ra: 2.213355, dec: 21.210993, vmag: 5.24 },
  { name: '19-Aql', ra: 19.149976, dec: 6.073207, vmag: 5.24 },
  { name: '23-Oph', ra: 16.909915, dec: -6.153982, vmag: 5.24 },
  { name: '11-CMi', ra: 7.771167, dec: 10.768252, vmag: 5.24 },
  { name: '56-Hya', ra: 14.795779, dec: -26.0875, vmag: 5.24 },
  { name: '23-Hya', ra: 9.27826, dec: -6.353144, vmag: 5.24 },
  { name: 'τ⁷-Eri', ra: 3.794347, dec: -23.874677, vmag: 5.24 },
  { name: 'η-Pyx', ra: 8.631154, dec: -26.255, vmag: 5.24 },
  { name: '7-Mon', ra: 6.328555, dec: -7.822908, vmag: 5.24 },
  { name: 'δ¹-CMi', ra: 7.534986, dec: 1.914481, vmag: 5.24 },
  { name: 'ζ²-Ret', ra: 3.303309, dec: -62.506363, vmag: 5.24 },
  { name: 'τ-Oph', ra: 18.051202, dec: -8.181708, vmag: 5.24 },
  { name: 'I¹-Aqr', ra: 23.736688, dec: -18.276938, vmag: 5.24 },
  { name: 'ι-Ara', ra: 17.387799, dec: -47.468197, vmag: 5.24 },
  { name: '63-Gem', ra: 7.462324, dec: 21.445247, vmag: 5.24 },
  { name: '45-Ori', ra: 5.594301, dec: -4.856067, vmag: 5.24 },
  { name: 'η-Ret', ra: 4.364796, dec: -63.386391, vmag: 5.24 },
  { name: 'V820 Her', ra: 18.039736, dec: 20.833632, vmag: 5.24 },
  { name: 'τ-Cap', ra: 20.654533, dec: -14.95476, vmag: 5.24 },
  { name: 'ι-Lyr', ra: 19.121703, dec: 36.100157, vmag: 5.25 },
  { name: '41-Cap', ra: 21.700192, dec: -23.262858, vmag: 5.25 },
  { name: '7-Tri', ra: 2.265635, dec: 33.358895, vmag: 5.25 },
  { name: 'π-Ara', ra: 17.634871, dec: -54.500434, vmag: 5.25 },
  { name: 'ε-Sextans', ra: 10.293834, dec: -8.068914, vmag: 5.25 },
  { name: 'θ-Scl', ra: 0.195552, dec: -35.133119, vmag: 5.25 },
  { name: '68-Aqr', ra: 22.792535, dec: -19.613375, vmag: 5.25 },
  { name: '16-Cam', ra: 5.391065, dec: 57.544395, vmag: 5.25 },
  { name: '107-Psc', ra: 1.70827, dec: 20.268504, vmag: 5.25 },
  { name: 'χ-Sco', ra: 16.230807, dec: -11.837747, vmag: 5.25 },
  { name: 'ζ²-Cnc', ra: 8.203535, dec: 17.647771, vmag: 5.25 },
  { name: 'V696 Tau', ra: 4.343419, dec: 15.095453, vmag: 5.25 },
  { name: '35-Eri', ra: 4.025569, dec: -1.54966, vmag: 5.25 },
  { name: 'ψ⁵-Aur', ra: 6.778983, dec: 43.577427, vmag: 5.26 },
  { name: 'ν-Hor', ra: 2.817062, dec: -62.806521, vmag: 5.26 },
  { name: 'ν-Leo', ra: 9.970382, dec: 12.4448, vmag: 5.26 },
  { name: 'D-Gem', ra: 6.859179, dec: 21.761148, vmag: 5.26 },
  { name: 'μ-For', ra: 2.21513, dec: -30.723825, vmag: 5.26 },
  { name: 'δ²-Aps', ra: 16.340795, dec: -78.667496, vmag: 5.26 },
  { name: '49-Aur', ra: 6.586684, dec: 28.022314, vmag: 5.26 },
  { name: '133-Tau', ra: 5.795252, dec: 13.899599, vmag: 5.26 },
  { name: '16-Ser', ra: 15.608216, dec: 10.010176, vmag: 5.26 },
  { name: '92-Leo', ra: 11.679742, dec: 21.35273, vmag: 5.26 },
  { name: 'φ-Boo', ra: 15.630441, dec: 40.353433, vmag: 5.26 },
  { name: 'ρ³-Eri', ra: 3.071254, dec: -7.600857, vmag: 5.26 },
  { name: 'π-Scl', ra: 1.702389, dec: -32.32697, vmag: 5.26 },
  { name: '68-Gem', ra: 7.560134, dec: 15.826662, vmag: 5.26 },
  { name: 'D-Her', ra: 17.026767, dec: 33.56827, vmag: 5.27 },
  { name: '11-Aql', ra: 18.984928, dec: 13.622245, vmag: 5.27 },
  { name: 'A-And', ra: 1.501695, dec: 47.007274, vmag: 5.27 },
  { name: '11-CMa', ra: 6.780859, dec: -14.425971, vmag: 5.27 },
  { name: 'κ²-Tau', ra: 4.423614, dec: 22.199998, vmag: 5.27 },
  { name: 'SY UMa', ra: 9.928612, dec: 49.819843, vmag: 5.27 },
  { name: 'ψ¹-Psc', ra: 1.094709, dec: 21.473181, vmag: 5.27 },
  { name: 'χ-Boo', ra: 15.241435, dec: 29.164295, vmag: 5.27 },
  { name: 'CF Boo', ra: 14.138145, dec: 49.458167, vmag: 5.27 },
  { name: '12-Lib', ra: 14.905592, dec: -24.642202, vmag: 5.28 },
  { name: 'I-Vir', ra: 13.445325, dec: -12.707664, vmag: 5.28 },
  { name: 'σ-Cap', ra: 20.323223, dec: -19.118533, vmag: 5.28 },
  { name: '12-Peg', ra: 21.767879, dec: 22.94888, vmag: 5.28 },
  { name: '47-Cas', ra: 2.085315, dec: 77.281341, vmag: 5.28 },
  { name: 'φ-Aql', ra: 19.937292, dec: 11.423721, vmag: 5.28 },
  { name: 'ν-Lep', ra: 5.333062, dec: -12.315585, vmag: 5.28 },
  { name: '20-Cep', ra: 22.083469, dec: 62.785671, vmag: 5.28 },
  { name: 'η-Vol', ra: 8.367918, dec: -73.399985, vmag: 5.28 },
  { name: '32-Aqr', ra: 22.079839, dec: -0.906343, vmag: 5.28 },
  { name: 'A-Per', ra: 3.94347, dec: 50.695381, vmag: 5.28 },
  { name: 'KX Hya', ra: 8.822702, dec: -3.443023, vmag: 5.28 },
  { name: 'μ-Hyi', ra: 2.527834, dec: -79.109382, vmag: 5.28 },
  { name: '4-Cam', ra: 4.800069, dec: 56.757183, vmag: 5.28 },
  { name: '42-Lyn', ra: 9.639383, dec: 40.239793, vmag: 5.28 },
  { name: '70-Cyg', ra: 21.455935, dec: 37.116798, vmag: 5.28 },
  { name: 'ν²-Col', ra: 5.629061, dec: -28.68969, vmag: 5.28 },
  { name: 'χ-Oct', ra: 18.91323, dec: -87.605843, vmag: 5.29 },
  { name: '17-UMa', ra: 9.263832, dec: 56.741406, vmag: 5.29 },
  { name: 'ε²-Ara', ra: 17.052419, dec: -53.237028, vmag: 5.29 },
  { name: '40-Cas', ra: 1.641926, dec: 73.04004, vmag: 5.29 },
  { name: 'ν-Ind', ra: 22.409764, dec: -72.255412, vmag: 5.29 },
  { name: 'κ-Dor', ra: 4.739205, dec: -59.732733, vmag: 5.29 },
  { name: 'ω¹-Aql', ra: 19.296944, dec: 11.595422, vmag: 5.29 },
  { name: 'γ³-Oct', ra: 0.167293, dec: -82.224047, vmag: 5.29 },
  { name: '10-Tri', ra: 2.315831, dec: 28.642674, vmag: 5.29 },
  { name: 'L-Tau', ra: 5.130111, dec: 20.418379, vmag: 5.29 },
  { name: 'ξ-Gru', ra: 21.534965, dec: -41.17931, vmag: 5.29 },
  { name: 'ι-TrA', ra: 16.465918, dec: -64.057942, vmag: 5.29 },
  { name: '12-Tri', ra: 2.469439, dec: 29.66933, vmag: 5.29 },
  { name: 'G-Leo', ra: 9.864732, dec: 24.395369, vmag: 5.3 },
  { name: '3-CVn', ra: 12.330199, dec: 48.984148, vmag: 5.3 },
  { name: '105-Her', ra: 18.319633, dec: 24.446059, vmag: 5.3 },
  { name: '59-Per', ra: 4.715089, dec: 43.365138, vmag: 5.3 },
  { name: 'μ-Cnc', ra: 8.129404, dec: 21.581816, vmag: 5.3 },
  { name: '46-Tau', ra: 4.225862, dec: 7.716045, vmag: 5.3 },
  { name: '33-Ari', ra: 2.678075, dec: 27.060943, vmag: 5.3 },
  { name: '36-Lyn', ra: 9.230059, dec: 43.217825, vmag: 5.3 },
  { name: 'χ-Cap', ra: 21.142673, dec: -21.193669, vmag: 5.3 },
  { name: '33-Vul', ra: 20.971209, dec: 22.325908, vmag: 5.3 },
  { name: 'β-Men', ra: 5.045279, dec: -71.3143, vmag: 5.3 },
  { name: 'η-Hor', ra: 2.623425, dec: -52.543086, vmag: 5.3 },
  { name: '40-Tau', ra: 4.06239, dec: 5.435624, vmag: 5.3 },
  { name: 'ξ-Oct', ra: 22.839655, dec: -80.123845, vmag: 5.3 },
  { name: 'E¹-Sgr', ra: 19.678717, dec: -16.293268, vmag: 5.3 },
  { name: '19-Lep', ra: 6.128233, dec: -19.165866, vmag: 5.3 },
  { name: 'θ²-Sgr', ra: 19.997595, dec: -34.697799, vmag: 5.3 },
  { name: 'λ-Pic', ra: 4.712899, dec: -50.481334, vmag: 5.3 },
  { name: '36-Per', ra: 3.540631, dec: 46.056862, vmag: 5.31 },
  { name: '4-And', ra: 23.127575, dec: 46.387231, vmag: 5.31 },
  { name: '31-Cas', ra: 1.177579, dec: 68.778621, vmag: 5.31 },
  { name: '43-Oph', ra: 17.389331, dec: -28.142831, vmag: 5.31 },
  { name: 'C-Gem', ra: 7.735254, dec: 25.784159, vmag: 5.31 },
  { name: '24-Vul', ra: 20.279746, dec: 24.671102, vmag: 5.31 },
  { name: 'C-And', ra: 2.321337, dec: 47.379973, vmag: 5.31 },
  { name: 'μ-Scl', ra: 23.677266, dec: -32.073125, vmag: 5.31 },
  { name: 'χ-Aql', ra: 19.709447, dec: 11.826583, vmag: 5.31 },
  { name: '32-And', ra: 0.68533, dec: 39.458664, vmag: 5.31 },
  { name: '69-Cet', ra: 2.36573, dec: 0.395675, vmag: 5.31 },
  { name: 'L-Leo', ra: 10.820953, dec: 10.545202, vmag: 5.31 },
  { name: '14-CMi', ra: 7.972404, dec: 2.224767, vmag: 5.31 },
  { name: 'κ¹-Vol', ra: 8.330274, dec: -71.514906, vmag: 5.31 },
  { name: 'ζ-Mic', ra: 21.049433, dec: -38.631447, vmag: 5.31 },
  { name: 'MO Cep', ra: 22.064709, dec: 63.11992, vmag: 5.31 },
  { name: '61-UMa', ra: 11.684171, dec: 34.201635, vmag: 5.32 },
  { name: 'A¹-Vir', ra: 11.798584, dec: 8.245895, vmag: 5.32 },
  { name: '3-Dra', ra: 11.707889, dec: 66.744906, vmag: 5.32 },
  { name: 'HT Peg', ra: 23.876974, dec: 10.94732, vmag: 5.32 },
  { name: 'χ-Ser', ra: 15.696504, dec: 12.847528, vmag: 5.32 },
  { name: 'F²-Ori', ra: 6.25698, dec: 16.143175, vmag: 5.32 },
  { name: 'N-Leo', ra: 11.264417, dec: 13.307578, vmag: 5.32 },
  { name: '7-Peg', ra: 21.704292, dec: 5.680137, vmag: 5.33 },
  { name: 'ψ³-Aur', ra: 6.646995, dec: 39.902559, vmag: 5.33 },
  { name: '55-Ori', ra: 5.856107, dec: -7.518003, vmag: 5.33 },
  { name: 'N²-Ori', ra: 5.571326, dec: 3.766895, vmag: 5.33 },
  { name: 'ω-Vir', ra: 11.641002, dec: 8.134298, vmag: 5.33 },
  { name: '15-Boo', ra: 14.247458, dec: 10.10061, vmag: 5.33 },
  { name: '55-Vir', ra: 13.236361, dec: -19.930947, vmag: 5.33 },
  { name: 'U-Tau', ra: 3.761234, dec: 6.049991, vmag: 5.33 },
  { name: 'ε-Scl', ra: 1.760763, dec: -25.05261, vmag: 5.33 },
  { name: 'π-Ari', ra: 2.821544, dec: 17.464309, vmag: 5.33 },
  { name: 'D Ser', ra: 18.453475, dec: 0.196108, vmag: 5.33 },
  { name: 'η-Cnc', ra: 8.545139, dec: 20.441162, vmag: 5.33 },
  { name: '21-Ori', ra: 5.319783, dec: 2.595806, vmag: 5.33 },
  { name: 'ρ-Aqr', ra: 22.336643, dec: -7.821102, vmag: 5.33 },
  { name: '18-And', ra: 23.652316, dec: 50.471733, vmag: 5.34 },
  { name: 'ν-Tel', ra: 19.800321, dec: -56.362611, vmag: 5.34 },
  { name: '29-Cap', ra: 21.262456, dec: -15.1715, vmag: 5.34 },
  { name: 'μ²-Pav', ra: 20.03123, dec: -66.943966, vmag: 5.34 },
  { name: 'V724 Tau', ra: 4.326862, dec: 21.773491, vmag: 5.34 },
  { name: '42-Aqr', ra: 22.280012, dec: -12.831436, vmag: 5.34 },
  { name: '13-Peg', ra: 21.835749, dec: 17.285851, vmag: 5.34 },
  { name: '64-Peg', ra: 23.365259, dec: 31.812465, vmag: 5.34 },
  { name: '53-Her', ra: 16.882796, dec: 31.701674, vmag: 5.34 },
  { name: '13-Lyn', ra: 6.780417, dec: 57.169176, vmag: 5.34 },
  { name: '45-Aur', ra: 6.362811, dec: 53.452179, vmag: 5.34 },
  { name: 'ρ²-Eri', ra: 3.045076, dec: -7.685472, vmag: 5.34 },
  { name: 'φ³-Cet', ra: 0.933747, dec: -11.266526, vmag: 5.34 },
  { name: '3-Ser', ra: 15.253154, dec: 4.939362, vmag: 5.34 },
  { name: 'B-Vir', ra: 11.999142, dec: 3.655197, vmag: 5.34 },
  { name: '37-Oph', ra: 17.207725, dec: 10.585168, vmag: 5.35 },
  { name: '5-Ori', ra: 4.889659, dec: 2.508225, vmag: 5.35 },
  { name: 'ι-Cha', ra: 9.40268, dec: -80.786876, vmag: 5.35 },
  { name: '42-LMi', ra: 10.764416, dec: 30.682313, vmag: 5.35 },
  { name: 'τ-Ari', ra: 3.353784, dec: 21.147086, vmag: 5.35 },
  { name: 'ι-Tuc', ra: 1.121838, dec: -61.775289, vmag: 5.35 },
  { name: '15-Sgr', ra: 18.253585, dec: -20.72827, vmag: 5.35 },
  { name: '20-Aql', ra: 19.211309, dec: -7.939518, vmag: 5.35 },
  { name: '57-UMa', ra: 11.484481, dec: 39.336974, vmag: 5.35 },
  { name: '40-Aur', ra: 6.109749, dec: 38.482644, vmag: 5.35 },
  { name: '20-Per', ra: 2.895168, dec: 38.337488, vmag: 5.35 },
  { name: 'ρ-Psc', ra: 1.437573, dec: 19.172346, vmag: 5.35 },
  { name: '74-UMa', ra: 12.499267, dec: 58.405742, vmag: 5.35 },
  { name: '36-Cam', ra: 6.214182, dec: 65.718422, vmag: 5.35 },
  { name: 'π-For', ra: 2.020759, dec: -30.00183, vmag: 5.36 },
  { name: 'θ-Cnc', ra: 8.526592, dec: 18.09442, vmag: 5.36 },
  { name: 'π-Cnc', ra: 9.253848, dec: 14.941507, vmag: 5.36 },
  { name: '50-Dra', ra: 18.772849, dec: 75.433964, vmag: 5.36 },
  { name: 'Y-Her', ra: 17.610457, dec: 48.585634, vmag: 5.36 },
  { name: '63-Vir', ra: 13.383643, dec: -17.735274, vmag: 5.36 },
  { name: 'υ-Lup', ra: 15.412504, dec: -39.710268, vmag: 5.36 },
  { name: '40-Cam', ra: 6.261257, dec: 59.998975, vmag: 5.36 },
  { name: '37-Cam', ra: 6.16639, dec: 58.935694, vmag: 5.36 },
  { name: '85-Gem', ra: 7.927749, dec: 19.88397, vmag: 5.36 },
  { name: 'λ-Hor', ra: 2.414987, dec: -60.311947, vmag: 5.36 },
  { name: 'A¹-Aqr', ra: 23.692914, dec: -18.027077, vmag: 5.36 },
  { name: '121-Tau', ra: 5.590869, dec: 24.039589, vmag: 5.36 },
  { name: '1-CMi', ra: 7.416161, dec: 11.669524, vmag: 5.36 },
  { name: '75-Cet', ra: 2.53595, dec: -1.034896, vmag: 5.37 },
  { name: '34-Lyn', ra: 8.683629, dec: 45.83401, vmag: 5.37 },
  { name: '22-Lyn', ra: 7.498867, dec: 49.672463, vmag: 5.37 },
  { name: 'ψ-Leo', ra: 9.728862, dec: 14.021692, vmag: 5.37 },
  { name: '54-Her', ra: 16.922825, dec: 18.433213, vmag: 5.37 },
  { name: '30-Peg', ra: 22.340994, dec: 5.789498, vmag: 5.37 },
  { name: '41-Lib', ra: 15.648488, dec: -19.301892, vmag: 5.37 },
  { name: '50-Boo', ra: 15.363495, dec: 32.933695, vmag: 5.37 },
  { name: '2-Cam', ra: 4.666126, dec: 53.473021, vmag: 5.37 },
  { name: '33-Cap', ra: 21.402665, dec: -20.851869, vmag: 5.37 },
  { name: '75-Dra', ra: 20.470687, dec: 81.422708, vmag: 5.37 },
  { name: 'χ-Tau', ra: 4.376373, dec: 25.629314, vmag: 5.37 },
  { name: 'C-Ser', ra: 18.494717, dec: -1.985308, vmag: 5.38 },
  { name: '30-Cap', ra: 21.299246, dec: -17.985138, vmag: 5.38 },
  { name: '12-Cas', ra: 0.413193, dec: 61.831057, vmag: 5.38 },
  { name: 'γ¹-Vol', ra: 7.145098, dec: -70.497087, vmag: 5.38 },
  { name: '52-Psc', ra: 0.543189, dec: 20.294316, vmag: 5.38 },
  { name: '9-Dra', ra: 12.998665, dec: 66.597272, vmag: 5.38 },
  { name: 'γ²-For', ra: 2.831716, dec: -27.941981, vmag: 5.38 },
  { name: 'π²-Dor', ra: 6.424623, dec: -69.690299, vmag: 5.38 },
  { name: 'κ-Gru', ra: 23.077668, dec: -53.964905, vmag: 5.38 },
  { name: '2-Her', ra: 15.910516, dec: 43.138567, vmag: 5.38 },
  { name: '14-Lyn', ra: 6.884738, dec: 59.448543, vmag: 5.38 },
  { name: '35-Vul', ra: 21.461126, dec: 27.608593, vmag: 5.38 },
  { name: '58-Peg', ra: 23.167072, dec: 9.822082, vmag: 5.38 },
  { name: 'D-Psc', ra: 0.343295, dec: 8.190271, vmag: 5.38 },
  { name: 'η¹-Pic', ra: 5.046861, dec: -49.151407, vmag: 5.38 },
  { name: 'ι-Aps', ra: 17.368299, dec: -70.123208, vmag: 5.38 },
  { name: 'η-Del', ra: 20.565845, dec: 13.027255, vmag: 5.38 },
  { name: 'A²-Ser', ra: 15.768233, dec: -1.804193, vmag: 5.38 },
  { name: '20-LMi', ra: 10.016864, dec: 31.923672, vmag: 5.38 },
  { name: '8-LMi', ra: 9.525671, dec: 35.103273, vmag: 5.39 },
  { name: '33-Boo', ra: 14.647289, dec: 44.4045, vmag: 5.39 },
  { name: '28-Sgr', ra: 18.772391, dec: -22.392176, vmag: 5.39 },
  { name: '112-Her', ra: 18.87123, dec: 21.425142, vmag: 5.39 },
  { name: 'ι-Vol', ra: 6.857495, dec: -70.963411, vmag: 5.39 },
  { name: 'κ¹-Aps', ra: 15.525228, dec: -73.389591, vmag: 5.39 },
  { name: 'L-Ori', ra: 6.285172, dec: 9.94239, vmag: 5.39 },
  { name: 'ρ-Tuc', ra: 0.707869, dec: -65.46803, vmag: 5.39 },
  { name: '51-Aql', ra: 19.846329, dec: -10.763512, vmag: 5.39 },
  { name: 'B¹-Cyg', ra: 20.106055, dec: 35.972468, vmag: 5.39 },
  { name: 'W-Her', ra: 17.34432, dec: 32.467743, vmag: 5.39 },
  { name: '79-Leo', ra: 11.400646, dec: 1.407765, vmag: 5.39 },
  { name: '83-Tau', ra: 4.510378, dec: 13.724402, vmag: 5.39 },
  { name: '51-Cyg', ra: 20.703508, dec: 50.34003, vmag: 5.39 },
  { name: '14-Cyg', ra: 19.657356, dec: 42.818278, vmag: 5.39 },
  { name: '51-Dra', ra: 19.081991, dec: 53.396654, vmag: 5.39 },
  { name: 'IM Tau', ra: 4.180517, dec: 26.480952, vmag: 5.4 },
  { name: '15-Tri', ra: 2.596336, dec: 34.687558, vmag: 5.4 },
  { name: 'G-Aql', ra: 19.048472, dec: -3.698987, vmag: 5.4 },
  { name: '63-Eri', ra: 4.997348, dec: -10.263325, vmag: 5.4 },
  { name: '115-Tau', ra: 5.452804, dec: 17.962216, vmag: 5.4 },
  { name: 'SV LMi', ra: 9.594334, dec: 35.810133, vmag: 5.4 },
  { name: 'ι-Hor', ra: 2.709265, dec: -50.800294, vmag: 5.4 },
  { name: 'ρ-Her', ra: 17.394708, dec: 37.145946, vmag: 5.4 },
  { name: 'H-Aql', ra: 19.082687, dec: -4.03142, vmag: 5.4 },
  { name: '6-Ser', ra: 15.350554, dec: 0.715337, vmag: 5.4 },
  { name: 'F-Boo', ra: 14.440935, dec: 19.2269, vmag: 5.4 },
  { name: '7-Sgr', ra: 18.047527, dec: -24.282468, vmag: 5.4 },
  { name: 'P⁵-Leo', ra: 11.22932, dec: -0.069502, vmag: 5.4 },
  { name: '7-Cep', ra: 21.46282, dec: 66.809096, vmag: 5.4 },
  { name: '55-And', ra: 1.888152, dec: 40.72979, vmag: 5.4 },
  { name: '18-Boo', ra: 14.321188, dec: 13.004299, vmag: 5.41 },
  { name: 'VZ Sge', ra: 20.000919, dec: 17.516511, vmag: 5.41 },
  { name: '23-Cas', ra: 0.796119, dec: 74.847573, vmag: 5.41 },
  { name: 'ν²-CrB', ra: 16.374783, dec: 33.703478, vmag: 5.41 },
  { name: '50-Cet', ra: 1.599713, dec: -15.400183, vmag: 5.41 },
  { name: 'ρ-CrB', ra: 16.017412, dec: 33.303509, vmag: 5.41 },
  { name: 'σ-Pav', ra: 20.821733, dec: -68.776521, vmag: 5.41 },
  { name: 'κ²-Scl', ra: 0.192894, dec: -27.799737, vmag: 5.41 },
  { name: '66-Dra', ra: 20.092444, dec: 61.99542, vmag: 5.41 },
  { name: 'E-Aqr', ra: 22.177078, dec: -11.564939, vmag: 5.41 },
  { name: '25-Cet', ra: 1.050705, dec: -4.836601, vmag: 5.42 },
  { name: '26-Aur', ra: 5.643913, dec: 30.492412, vmag: 5.42 },
  { name: '9-Cyg', ra: 19.580813, dec: 29.462954, vmag: 5.42 },
  { name: 'V1931 Cyg', ra: 21.019702, dec: 46.155773, vmag: 5.42 },
  { name: 'η-Lib', ra: 15.734556, dec: -15.672834, vmag: 5.42 },
  { name: 'ι-Del', ra: 20.630311, dec: 11.377676, vmag: 5.42 },
  { name: '57-Psc', ra: 0.775822, dec: 15.475504, vmag: 5.42 },
  { name: 'HW Peg', ra: 23.557804, dec: 22.498775, vmag: 5.42 },
  { name: 'ψ²-Dra', ra: 17.919762, dec: 72.005127, vmag: 5.42 },
  { name: 'λ-PsA', ra: 22.238542, dec: -27.766908, vmag: 5.42 },
  { name: '28-Gem', ra: 6.745961, dec: 28.970932, vmag: 5.43 },
  { name: 'ζ-Oct', ra: 8.944949, dec: -85.663152, vmag: 5.43 },
  { name: 'H-Ori', ra: 5.155456, dec: 9.829579, vmag: 5.43 },
  { name: 'τ-Cnc', ra: 9.133348, dec: 29.654235, vmag: 5.43 },
  { name: '60-Cet', ra: 2.053236, dec: 0.128507, vmag: 5.43 },
  { name: '16-Sco', ra: 16.202032, dec: -8.547576, vmag: 5.43 },
  { name: '70-Cet', ra: 2.37011, dec: -0.884852, vmag: 5.43 },
  { name: '84-Vir', ra: 13.717698, dec: 3.537903, vmag: 5.43 },
  { name: '37-Leo', ra: 10.277983, dec: 13.728334, vmag: 5.43 },
  { name: 'λ-CrB', ra: 15.929884, dec: 37.946958, vmag: 5.43 },
  { name: '2-Psc', ra: 22.99096, dec: 0.962927, vmag: 5.43 },
  { name: 'A-Psc', ra: 23.1447, dec: 2.127883, vmag: 5.43 },
  { name: '106-Vir', ra: 14.478256, dec: -6.900536, vmag: 5.43 },
  { name: '55-Psc', ra: 0.665436, dec: 21.438495, vmag: 5.43 },
  { name: 'ES Vul', ra: 19.295454, dec: 23.02554, vmag: 5.43 },
  { name: '17-Cam', ra: 5.502835, dec: 63.06722, vmag: 5.43 },
  { name: 'AY Cet', ra: 1.276747, dec: -2.500368, vmag: 5.44 },
  { name: 'V571 Mon', ra: 7.189893, dec: -0.301928, vmag: 5.44 },
  { name: '93-Tau', ra: 4.667616, dec: 12.197609, vmag: 5.44 },
  { name: 'UU Com', ra: 12.516823, dec: 24.567168, vmag: 5.44 },
  { name: '87-Vir', ra: 13.790386, dec: -17.859839, vmag: 5.44 },
  { name: '4-Eri', ra: 2.9566, dec: -23.862164, vmag: 5.44 },
  { name: 'σ²-Cnc', ra: 8.949056, dec: 32.91043, vmag: 5.44 },
  { name: 'λ-Nor', ra: 16.321568, dec: -42.673965, vmag: 5.44 },
  { name: 'H-Aqr', ra: 23.086052, dec: -7.693801, vmag: 5.44 },
  { name: '7-Dra', ra: 12.792873, dec: 66.790304, vmag: 5.44 },
  { name: '14-Per', ra: 2.734766, dec: 44.29704, vmag: 5.44 },
  { name: 'χ³-Sgr', ra: 19.424906, dec: -23.962457, vmag: 5.44 },
  { name: 'I-Ori', ra: 5.131359, dec: 8.498429, vmag: 5.44 },
  { name: 'ν-Cnc', ra: 9.045629, dec: 24.452915, vmag: 5.44 },
  { name: '42-Aql', ra: 19.62981, dec: -4.64764, vmag: 5.44 },
  { name: 'H-Psc', ra: 0.963931, dec: 28.992217, vmag: 5.44 },
  { name: 'Celaeno', ra: 3.746726, dec: 24.28947, vmag: 5.45 },
  { name: 'ζ-Pic', ra: 5.322813, dec: -50.605967, vmag: 5.45 },
  { name: 'κ-Men', ra: 5.837999, dec: -79.361362, vmag: 5.45 },
  { name: '11-And', ra: 23.324945, dec: 48.625322, vmag: 5.45 },
  { name: 'η-Cha', ra: 8.688773, dec: -78.963359, vmag: 5.45 },
  { name: '3-Crv', ra: 12.184401, dec: -23.602423, vmag: 5.45 },
  { name: 'ω-Leo', ra: 9.474278, dec: 9.056778, vmag: 5.45 },
  { name: 'D-Aql', ra: 19.343246, dec: -0.892161, vmag: 5.45 },
  { name: 'σ-Oct', ra: 21.146119, dec: -88.956499, vmag: 5.45 },
  { name: 'ν-Cha', ra: 9.772352, dec: -76.77612, vmag: 5.45 },
  { name: '46-Leo', ra: 10.536604, dec: 14.13727, vmag: 5.45 },
  { name: '37-Eri', ra: 4.172923, dec: -6.923852, vmag: 5.45 },
  { name: 'θ-Men', ra: 6.942911, dec: -79.420193, vmag: 5.45 },
  { name: '57-Cet', ra: 1.996166, dec: -20.824539, vmag: 5.45 },
  { name: 'ω²-Cyg', ra: 20.521893, dec: 49.220297, vmag: 5.45 },
  { name: 'ψ¹-Psc', ra: 1.094919, dec: 21.465442, vmag: 5.45 },
  { name: '60-Cnc', ra: 8.932097, dec: 11.626023, vmag: 5.46 },
  { name: 'ν-Ari', ra: 2.646943, dec: 21.961408, vmag: 5.46 },
  { name: '5-Peg', ra: 21.629285, dec: 19.318607, vmag: 5.46 },
  { name: 'φ-Oct', ra: 18.393456, dec: -75.044277, vmag: 5.46 },
  { name: '81-Tau', ra: 4.510802, dec: 15.691879, vmag: 5.46 },
  { name: 'ρ-Cep', ra: 22.498047, dec: 78.824285, vmag: 5.46 },
  { name: 'A-UMa', ra: 8.576711, dec: 65.14517, vmag: 5.46 },
  { name: 'O-Aur', ra: 5.765012, dec: 49.826255, vmag: 5.46 },
  { name: 'η¹-CrA', ra: 18.814024, dec: -43.680047, vmag: 5.46 },
  { name: 'λ²-Tuc', ra: 0.916751, dec: -69.527084, vmag: 5.46 },
  { name: '82-UMa', ra: 13.658472, dec: 52.921208, vmag: 5.46 },
  { name: '26-Lyn', ra: 7.911864, dec: 47.564596, vmag: 5.46 },
  { name: 'Helvetios', ra: 22.95777, dec: 20.768832, vmag: 5.46 },
  { name: '95-Vir', ra: 14.111896, dec: -9.313515, vmag: 5.46 },
  { name: '24-Hya', ra: 9.278158, dec: -8.744759, vmag: 5.46 },
  { name: '20-Hya', ra: 9.15988, dec: -8.787648, vmag: 5.46 },
  { name: '130-Tau', ra: 5.79061, dec: 17.729141, vmag: 5.46 },
  { name: '49-Lib', ra: 16.005447, dec: -16.53335, vmag: 5.46 },
  { name: 'ξ²-Lib', ra: 14.946142, dec: -11.409701, vmag: 5.47 },
  { name: '73-Ori', ra: 6.26249, dec: 12.551067, vmag: 5.47 },
  { name: 'η-Men', ra: 4.919765, dec: -74.936852, vmag: 5.47 },
  { name: '19-UMi', ra: 16.180424, dec: 75.877563, vmag: 5.47 },
  { name: '52-Ari', ra: 3.090747, dec: 25.255174, vmag: 5.47 },
  { name: '9-Her', ra: 16.220953, dec: 5.021086, vmag: 5.47 },
  { name: '30-Eri', ra: 3.878238, dec: -5.361259, vmag: 5.47 },
  { name: 'V441 Her', ra: 17.923663, dec: 26.049991, vmag: 5.47 },
  { name: '30-Per', ra: 3.296485, dec: 44.025024, vmag: 5.47 },
  { name: 'ξ-Ari', ra: 2.413627, dec: 10.610565, vmag: 5.47 },
  { name: 'Q-Vir', ra: 12.562986, dec: -9.452077, vmag: 5.47 },
  { name: 'K-Her', ra: 16.838717, dec: 7.247683, vmag: 5.47 },
  { name: '66-Aql', ra: 20.220523, dec: -1.009339, vmag: 5.47 },
  { name: 'B-Eri', ra: 4.940052, dec: -5.171356, vmag: 5.47 },
  { name: 'ι-Pav', ra: 18.173948, dec: -62.002197, vmag: 5.48 },
  { name: '18-Com', ra: 12.490845, dec: 24.108925, vmag: 5.48 },
  { name: '53-Tau', ra: 4.323916, dec: 21.142307, vmag: 5.48 },
  { name: 'η³-For', ra: 2.844557, dec: -35.675849, vmag: 5.48 },
  { name: 'ν-Gru', ra: 22.477557, dec: -39.131792, vmag: 5.48 },
  { name: 'α¹-CVn', ra: 12.933468, dec: 38.314912, vmag: 5.48 },
  { name: 'ψ-Oct', ra: 22.297409, dec: -77.511553, vmag: 5.48 },
  { name: 'KS Peg', ra: 23.632445, dec: 18.400667, vmag: 5.48 },
  { name: '95-Cet', ra: 3.306229, dec: -0.930288, vmag: 5.48 },
  { name: '45-Gem', ra: 7.139455, dec: 15.930675, vmag: 5.48 },
  { name: '21-Aqr', ra: 21.421377, dec: -3.556747, vmag: 5.48 },
  { name: '18-Aqr', ra: 21.403192, dec: -12.878108, vmag: 5.48 },
  { name: '26-Com', ra: 12.652031, dec: 21.062559, vmag: 5.49 },
  { name: 'K-Leo', ra: 10.773689, dec: 14.194645, vmag: 5.49 },
  { name: '23-LMi', ra: 10.270677, dec: 29.310501, vmag: 5.49 },
  { name: '14-Sgr', ra: 18.23775, dec: -21.713164, vmag: 5.49 },
  { name: 'ζ-Lib', ra: 15.548673, dec: -16.852844, vmag: 5.49 },
  { name: 'σ-Psc', ra: 1.046971, dec: 31.804263, vmag: 5.49 },
  { name: 'π²-Col', ra: 6.13135, dec: -42.154043, vmag: 5.49 },
  { name: 'θ-Hyi', ra: 3.037615, dec: -71.902457, vmag: 5.49 },
  { name: '27-Sco', ra: 16.953104, dec: -33.259492, vmag: 5.49 },
  { name: 'ι-Crt', ra: 11.644449, dec: -13.201943, vmag: 5.49 },
  { name: 'π-Tuc', ra: 0.344178, dec: -69.624913, vmag: 5.5 },
  { name: '58-Eri', ra: 4.793413, dec: -16.934456, vmag: 5.5 },
  { name: '24-Sgr', ra: 18.564857, dec: -24.032283, vmag: 5.5 },
  { name: '20-Psc', ra: 23.79904, dec: -2.761598, vmag: 5.5 },
  { name: '7-Aqr', ra: 20.948341, dec: -9.697545, vmag: 5.5 },
  { name: '19-Vul', ra: 20.19666, dec: 26.80899, vmag: 5.5 },
  { name: 'M-Leo', ra: 10.773484, dec: 18.891523, vmag: 5.5 },
  { name: 'τ-Oct', ra: 23.46766, dec: -87.482214, vmag: 5.5 },
  { name: '16-Dra', ra: 16.603174, dec: 52.900048, vmag: 5.5 },
  { name: '94-Psc', ra: 1.44491, dec: 19.240422, vmag: 5.5 },
  { name: 'κ²-Lup', ra: 15.199363, dec: -48.743687, vmag: 5.5 },
  { name: 'A¹-Ser', ra: 15.549427, dec: -1.186399, vmag: 5.5 },
  { name: '103-Tau', ra: 5.135173, dec: 24.265175, vmag: 5.5 },
  { name: 'μ-Men', ra: 4.717764, dec: -70.931027, vmag: 5.5 },
  { name: 'σ-Scl', ra: 1.040674, dec: -31.552005, vmag: 5.5 },
  { name: '10-Vul', ra: 19.72859, dec: 25.771929, vmag: 5.5 },
  { name: '74-Her', ra: 17.339203, dec: 46.24078, vmag: 5.5 },
  { name: '18-Sco', ra: 16.260352, dec: -8.369442, vmag: 5.51 },
  { name: '67-Cet', ra: 2.283068, dec: -6.422116, vmag: 5.51 },
  { name: 'θ-TrA', ra: 16.595775, dec: -65.495399, vmag: 5.51 },
  { name: '22-Eri', ra: 3.677315, dec: -5.210706, vmag: 5.51 },
  { name: '72-Tau', ra: 4.454847, dec: 22.996337, vmag: 5.51 },
  { name: 'O-CrB', ra: 15.335714, dec: 29.616209, vmag: 5.51 },
  { name: 'σ-Ari', ra: 2.858218, dec: 15.082071, vmag: 5.51 },
  { name: 'ζ¹-Ret', ra: 3.295903, dec: -62.575322, vmag: 5.51 },
  { name: '18-Vul', ra: 20.175982, dec: 26.904169, vmag: 5.51 },
  { name: '64-Ari', ra: 3.405132, dec: 24.724063, vmag: 5.51 },
  { name: 'E-Psc', ra: 1.1395, dec: 5.649819, vmag: 5.51 },
  { name: '28-LMi', ra: 10.40239, dec: 33.718531, vmag: 5.51 },
  { name: '58-Psc', ra: 0.783738, dec: 11.973849, vmag: 5.51 },
  { name: 'ω¹-Tau', ra: 4.152768, dec: 19.609217, vmag: 5.51 },
  { name: '40-LMi', ra: 10.717191, dec: 26.325577, vmag: 5.51 },
  { name: '18-Ori', ra: 5.267815, dec: 11.341354, vmag: 5.51 },
  { name: '47-Cet', ra: 1.447657, dec: -13.056512, vmag: 5.51 },
  { name: 'Musica', ra: 20.973871, dec: 10.839286, vmag: 5.51 },
  { name: 'τ-Aql', ra: 20.068976, dec: 7.277966, vmag: 5.51 },
  { name: '116-Tau', ra: 5.462669, dec: 15.874052, vmag: 5.51 },
  { name: 'η-Mic', ra: 21.107087, dec: -41.385965, vmag: 5.51 },
  { name: '21-Oph', ra: 16.856925, dec: 1.215947, vmag: 5.52 },
  { name: 'ι-Hyi', ra: 3.265951, dec: -77.388454, vmag: 5.52 },
  { name: 'ε-Tri', ra: 2.049433, dec: 33.284135, vmag: 5.52 },
  { name: 'O-Ind', ra: 21.846448, dec: -69.629416, vmag: 5.52 },
  { name: '25-Vul', ra: 20.36762, dec: 24.446099, vmag: 5.52 },
  { name: 'λ²-Phe', ra: 0.594767, dec: -48.000907, vmag: 5.52 },
  { name: '36-Tau', ra: 4.072687, dec: 24.105993, vmag: 5.52 },
  { name: 'μ-Cha', ra: 10.012191, dec: -82.21467, vmag: 5.52 },
  { name: '49-Dra', ra: 19.012072, dec: 55.658301, vmag: 5.52 },
  { name: '50-Per', ra: 4.143497, dec: 38.039733, vmag: 5.52 },
  { name: 'σ-Col', ra: 5.939151, dec: -31.38244, vmag: 5.52 },
  { name: '26-Cep', ra: 22.451475, dec: 65.13227, vmag: 5.52 },
  { name: '10-Lep', ra: 5.518785, dec: -20.863659, vmag: 5.52 },
  { name: 'ρ-For', ra: 3.7989, dec: -30.167882, vmag: 5.52 },
  { name: '34-Psc', ra: 0.167278, dec: 11.145813, vmag: 5.53 },
  { name: 'O-Leo', ra: 11.927926, dec: 15.646818, vmag: 5.53 },
  { name: 'V1208 Aql', ra: 19.327597, dec: 12.37468, vmag: 5.53 },
  { name: 'ι-Oct', ra: 12.916219, dec: -85.123369, vmag: 5.53 },
  { name: '50-Lib', ra: 16.013231, dec: -8.411353, vmag: 5.53 },
  { name: 'V436 Per', ra: 1.866476, dec: 55.147385, vmag: 5.53 },
  { name: '5-Cam', ra: 4.917537, dec: 55.259109, vmag: 5.53 },
  { name: '11-Sge', ra: 19.962624, dec: 16.789163, vmag: 5.53 },
  { name: 'ε-Men', ra: 7.42727, dec: -79.094188, vmag: 5.53 },
  { name: 'O-Gru', ra: 23.44349, dec: -52.721603, vmag: 5.53 },
  { name: '15-Peg', ra: 21.874978, dec: 28.793538, vmag: 5.53 },
  { name: '12-Cep', ra: 21.790362, dec: 60.692689, vmag: 5.53 },
  { name: '122-Tau', ra: 5.617704, dec: 17.040324, vmag: 5.53 },
  { name: '17-Peg', ra: 21.948992, dec: 12.076492, vmag: 5.53 },
  { name: '49-Aqr', ra: 22.391901, dec: -24.762661, vmag: 5.53 },
  { name: '18-Pup', ra: 8.177731, dec: -13.799207, vmag: 5.54 },
  { name: '75-Vir', ra: 13.547679, dec: -15.363012, vmag: 5.54 },
  { name: 'ψ-Dra', ra: 17.699461, dec: 72.156911, vmag: 5.54 },
  { name: '25-Her', ra: 16.42338, dec: 37.394079, vmag: 5.54 },
  { name: 'φ-Ser', ra: 15.954048, dec: 14.41448, vmag: 5.54 },
  { name: '70-UMa', ra: 12.347461, dec: 57.864118, vmag: 5.54 },
  { name: '16-Del', ra: 20.927381, dec: 12.568558, vmag: 5.54 },
  { name: '5-Eri', ra: 2.994767, dec: -2.464952, vmag: 5.54 },
  { name: '77-Aqr', ra: 22.912632, dec: -16.271957, vmag: 5.54 },
  { name: '67-Peg', ra: 23.41412, dec: 32.384882, vmag: 5.54 },
  { name: '14-Boo', ra: 14.234773, dec: 12.959444, vmag: 5.54 },
  { name: '62-Ari', ra: 3.36997, dec: 27.607553, vmag: 5.54 },
  { name: '86-Peg', ra: 0.094989, dec: 13.396266, vmag: 5.54 },
  { name: 'φ-Gru', ra: 23.302739, dec: -40.824361, vmag: 5.55 },
  { name: 'P⁴-Leo', ra: 11.115058, dec: 1.955525, vmag: 5.55 },
  { name: '5-Aqr', ra: 20.869082, dec: -5.507059, vmag: 5.55 },
  { name: '37-Peg', ra: 22.499427, dec: 4.43169, vmag: 5.55 },
  { name: 'ξ²-Lup', ra: 15.948366, dec: -33.964281, vmag: 5.55 },
  { name: '30-Aqr', ra: 22.054572, dec: -6.522406, vmag: 5.55 },
  { name: 'π-Psc', ra: 1.61831, dec: 12.141535, vmag: 5.55 },
  { name: 'LZ Cep', ra: 22.034604, dec: 58.000366, vmag: 5.55 },
  { name: '64-Ser', ra: 18.954608, dec: 2.535346, vmag: 5.55 },
  { name: '135-Tau', ra: 5.841363, dec: 14.305608, vmag: 5.55 },
  { name: 'V557 Cas', ra: 1.705688, dec: 68.043021, vmag: 5.55 },
  { name: '80-Cet', ra: 2.600013, dec: -7.831597, vmag: 5.55 },
  { name: 'A-Hya', ra: 9.575736, dec: -5.914948, vmag: 5.55 },
  { name: '63-And', ra: 2.349499, dec: 50.151466, vmag: 5.56 },
  { name: '86-Leo', ra: 11.508065, dec: 18.409801, vmag: 5.56 },
  { name: '11-Tri', ra: 2.457715, dec: 31.80128, vmag: 5.56 },
  { name: '59-UMa', ra: 11.639056, dec: 43.625429, vmag: 5.56 },
  { name: 'π¹-Dor', ra: 6.37729, dec: -69.984043, vmag: 5.56 },
  { name: 'RU Cas', ra: 1.194829, dec: 65.018854, vmag: 5.56 },
  { name: '32-Boo', ra: 14.695423, dec: 11.660662, vmag: 5.56 },
  { name: 'δ-Ant', ra: 10.493161, dec: -30.607065, vmag: 5.56 },
  { name: 'κ-Oct', ra: 13.682257, dec: -85.786043, vmag: 5.56 },
  { name: '87-Peg', ra: 0.150672, dec: 18.211963, vmag: 5.56 },
  { name: 'TZ CrB', ra: 16.24469, dec: 33.858613, vmag: 5.56 },
  { name: '12-Tau', ra: 3.664201, dec: 3.056863, vmag: 5.56 },
  { name: 'δ¹-Lyr', ra: 18.895433, dec: 36.971721, vmag: 5.56 },
  { name: '34-LMi', ra: 10.558587, dec: 34.988695, vmag: 5.56 },
  { name: '86-Vir', ra: 13.765644, dec: -12.426528, vmag: 5.56 },
  { name: '28-Cet', ra: 1.10143, dec: -9.839354, vmag: 5.56 },
  { name: '25-Eri', ra: 3.749027, dec: -0.29672, vmag: 5.57 },
  { name: 'λ-Cap', ra: 21.775583, dec: -11.365954, vmag: 5.57 },
  { name: '15-And', ra: 23.577095, dec: 40.236441, vmag: 5.57 },
  { name: 'ψ²-Psc', ra: 1.132544, dec: 20.739113, vmag: 5.57 },
  { name: 'ι²-Nor', ra: 16.155154, dec: -57.934318, vmag: 5.57 },
  { name: '6-UMa', ra: 8.943741, dec: 64.603831, vmag: 5.57 },
  { name: '42-UMa', ra: 10.856594, dec: 59.320119, vmag: 5.57 },
  { name: '10-Cas', ra: 0.10737, dec: 64.196168, vmag: 5.57 },
  { name: '36-Cyg', ra: 20.307958, dec: 36.999803, vmag: 5.57 },
  { name: '83-Her', ra: 17.707879, dec: 24.564058, vmag: 5.57 },
  { name: 'D¹-Vir', ra: 12.699199, dec: 6.806617, vmag: 5.57 },
  { name: 'κ¹-Sgr', ra: 20.374305, dec: -42.049548, vmag: 5.57 },
  { name: 'ψ³-Psc', ra: 1.163667, dec: 19.658408, vmag: 5.57 },
  { name: 'ρ-Oct', ra: 15.721161, dec: -84.465273, vmag: 5.57 },
  { name: '22-Aql', ra: 19.275287, dec: 4.834795, vmag: 5.57 },
  { name: 'θ-Ari', ra: 2.302094, dec: 19.901164, vmag: 5.57 },
  { name: '22-Psc', ra: 23.866066, dec: 2.930384, vmag: 5.57 },
  { name: '63-Peg', ra: 23.347097, dec: 30.414921, vmag: 5.58 },
  { name: 'K-Boo', ra: 15.090515, dec: 48.150972, vmag: 5.58 },
  { name: '83-Vir', ra: 13.741618, dec: -16.179072, vmag: 5.58 },
  { name: 'A²-Vir', ra: 11.917537, dec: 8.443943, vmag: 5.58 },
  { name: '50-Sgr', ra: 19.438654, dec: -21.776693, vmag: 5.58 },
  { name: 'π¹-Hyi', ra: 2.237366, dec: -67.841441, vmag: 5.58 },
  { name: 'EN Lac', ra: 22.939897, dec: 41.603876, vmag: 5.58 },
  { name: '96-Aqr', ra: 23.323327, dec: -5.124352, vmag: 5.58 },
  { name: '27-Vul', ra: 20.617964, dec: 26.461947, vmag: 5.58 },
  { name: '70-Gem', ra: 7.64246, dec: 35.04855, vmag: 5.58 },
  { name: 'δ²-CMi', ra: 7.553241, dec: 3.290379, vmag: 5.58 },
  { name: 'V483 Tau', ra: 4.332695, dec: 14.035201, vmag: 5.58 },
  { name: '81-Leo', ra: 11.426771, dec: 16.456539, vmag: 5.58 },
  { name: '18-Sgr', ra: 18.417066, dec: -30.75657, vmag: 5.58 },
  { name: '36-And', ra: 0.916139, dec: 23.628335, vmag: 5.58 },
  { name: 'π-CrB', ra: 15.73314, dec: 32.515807, vmag: 5.58 },
  { name: 'η²-CrA', ra: 18.826388, dec: -43.434102, vmag: 5.58 },
  { name: 'V809 Tau', ra: 5.872859, dec: 14.171787, vmag: 5.58 },
  { name: 'δ¹-Cha', ra: 10.754546, dec: -80.469597, vmag: 5.58 },
  { name: 'ι-Pic', ra: 4.848706, dec: -53.461508, vmag: 5.58 },
  { name: 'κ²-CrA', ra: 18.556426, dec: -38.725985, vmag: 5.59 },
  { name: '35-Ori', ra: 5.565079, dec: 14.305578, vmag: 5.59 },
  { name: 'φ¹-Cnc', ra: 8.44103, dec: 27.893583, vmag: 5.59 },
  { name: '21-Ari', ra: 2.261884, dec: 25.043043, vmag: 5.59 },
  { name: 'π¹-Peg', ra: 22.153789, dec: 33.172337, vmag: 5.59 },
  { name: 'ξ-Scl', ra: 1.02174, dec: -38.916527, vmag: 5.59 },
  { name: 'BP Cnc', ra: 8.445539, dec: 12.654612, vmag: 5.59 },
  { name: '5-Vul', ra: 19.437013, dec: 20.097733, vmag: 5.59 },
  { name: '4-Cep', ra: 20.719722, dec: 66.657447, vmag: 5.59 },
  { name: 'ρ-Ari', ra: 2.940596, dec: 18.023119, vmag: 5.59 },
  { name: 'ζ²-Lyr', ra: 18.746722, dec: 37.594615, vmag: 5.59 },
  { name: 'G-Boo', ra: 14.477197, dec: 49.844851, vmag: 5.59 },
  { name: '36-Peg', ra: 22.485551, dec: 9.129034, vmag: 5.59 },
  { name: '28-Hya', ra: 9.423343, dec: -5.117394, vmag: 5.59 },
  { name: '47-And', ra: 1.394612, dec: 37.714943, vmag: 5.59 },
  { name: 'LM Hya', ra: 8.440891, dec: -3.987479, vmag: 5.6 },
  { name: '3-Cnc', ra: 8.013141, dec: 17.308703, vmag: 5.6 },
  { name: 'ε-Pyx', ra: 9.16567, dec: -30.365401, vmag: 5.6 },
  { name: 'V566 Cas', ra: 23.813937, dec: 62.214516, vmag: 5.6 },
  { name: '81-UMa', ra: 13.568698, dec: 55.348434, vmag: 5.6 },
  { name: '93-Cet', ra: 3.039588, dec: 4.352884, vmag: 5.6 },
  { name: '23-CVn', ra: 13.3386, dec: 40.150548, vmag: 5.6 },
  { name: 'κ²-Vol', ra: 8.333486, dec: -71.505377, vmag: 5.6 },
  { name: 'BM Cnc', ra: 8.21913, dec: 29.656536, vmag: 5.6 },
  { name: '5-Com', ra: 12.202581, dec: 20.542064, vmag: 5.6 },
  { name: '19-Hya', ra: 9.14505, dec: -8.589524, vmag: 5.6 },
  { name: 'μ-Lib', ra: 14.821959, dec: -14.149022, vmag: 5.6 },
  { name: 'ν-Pic', ra: 6.382179, dec: -56.369969, vmag: 5.6 },
  { name: '28-Aqr', ra: 22.01806, dec: 0.604715, vmag: 5.61 },
  { name: '55-Hya', ra: 14.789599, dec: -25.624267, vmag: 5.61 },
  { name: '20-Peg', ra: 22.018152, dec: 13.119823, vmag: 5.61 },
  { name: 'FS Com', ra: 13.106278, dec: 22.616187, vmag: 5.61 },
  { name: '49-Cet', ra: 1.57716, dec: -15.676359, vmag: 5.61 },
  { name: 'ζ-Men', ra: 6.667474, dec: -80.813593, vmag: 5.61 },
  { name: '108-Her', ra: 18.349158, dec: 29.858925, vmag: 5.61 },
  { name: '3-Equ', ra: 21.076292, dec: 5.502862, vmag: 5.61 },
  { name: 'N-Her', ra: 16.543246, dec: 5.52122, vmag: 5.62 },
  { name: '43-Lyn', ra: 9.700098, dec: 39.757851, vmag: 5.62 },
  { name: 'BI Cnc', ra: 8.745844, dec: 10.08167, vmag: 5.62 },
  { name: 'φ⁴-Cet', ra: 0.978852, dec: -11.379975, vmag: 5.62 },
  { name: '1-Hya', ra: 8.409726, dec: -3.75124, vmag: 5.62 },
  { name: 'κ-Ind', ra: 22.097496, dec: -59.636072, vmag: 5.62 },
  { name: '53-Cas', ra: 2.050052, dec: 64.390018, vmag: 5.62 },
  { name: '38-Peg', ra: 22.500503, dec: 32.572638, vmag: 5.62 },
  { name: '11-Peg', ra: 21.787212, dec: 2.686124, vmag: 5.62 },
  { name: 'DE Leo', ra: 10.420887, dec: 8.784845, vmag: 5.62 },
  { name: 'F-Leo', ra: 9.725906, dec: 29.974473, vmag: 5.63 },
  { name: '32-Tau', ra: 3.947798, dec: 22.477971, vmag: 5.63 },
  { name: '18-Sextans', ra: 10.182184, dec: -8.418462, vmag: 5.63 },
  { name: '63-Tau', ra: 4.390294, dec: 16.77726, vmag: 5.63 },
  { name: '66-Ori', ra: 6.082878, dec: 4.158671, vmag: 5.63 },
  { name: '73-Peg', ra: 23.577279, dec: 33.497328, vmag: 5.63 },
  { name: '4-Ser', ra: 15.263633, dec: 0.372139, vmag: 5.63 },
  { name: 'π²-Gru', ra: 22.385535, dec: -45.928488, vmag: 5.63 },
  { name: '2-Boo', ra: 13.683986, dec: 22.495768, vmag: 5.63 },
  { name: '4-Sco', ra: 15.925023, dec: -26.265993, vmag: 5.63 },
  { name: 'I²-Aqr', ra: 23.766922, dec: -18.67834, vmag: 5.63 },
  { name: '29-Lyn', ra: 8.297338, dec: 59.571133, vmag: 5.63 },
  { name: '40-Cyg', ra: 20.459517, dec: 38.440332, vmag: 5.63 },
  { name: '58-Aql', ra: 19.912444, dec: 0.273627, vmag: 5.63 },
  { name: '64-Cet', ra: 2.189189, dec: 8.569805, vmag: 5.63 },
  { name: '51-Tau', ra: 4.306444, dec: 21.579297, vmag: 5.63 },
  { name: 'κ²-Aps', ra: 15.672598, dec: -73.446685, vmag: 5.63 },
  { name: 'A¹-Cnc', ra: 8.720091, dec: 12.680876, vmag: 5.64 },
  { name: '45-Aql', ra: 19.6787, dec: -0.621233, vmag: 5.64 },
  { name: '13-Del', ra: 20.796759, dec: 6.008209, vmag: 5.64 },
  { name: '72-Psc', ra: 1.084821, dec: 14.946133, vmag: 5.64 },
  { name: '45-Ser', ra: 16.127094, dec: 9.891743, vmag: 5.64 },
  { name: 'π¹-UMa', ra: 8.653257, dec: 65.020907, vmag: 5.64 },
  { name: 'μ-Pic', ra: 6.532864, dec: -58.753835, vmag: 5.64 },
  { name: '18-Tau', ra: 3.752705, dec: 24.83926, vmag: 5.64 },
  { name: '40-Boo', ra: 14.993598, dec: 39.265333, vmag: 5.64 },
  { name: 'ζ¹-Lib', ra: 15.470947, dec: -16.716484, vmag: 5.64 },
  { name: '49-Cyg', ra: 20.684039, dec: 32.307287, vmag: 5.65 },
  { name: 'μ-Dra', ra: 17.088714, dec: 54.469093, vmag: 5.65 },
  { name: 'π-Cha', ra: 11.621074, dec: -75.896544, vmag: 5.65 },
  { name: 'H¹-Sgr', ra: 19.600459, dec: -24.719081, vmag: 5.65 },
  { name: '1-Sge', ra: 19.254822, dec: 21.232118, vmag: 5.65 },
  { name: '19-Peg', ra: 22.019232, dec: 8.257164, vmag: 5.65 },
  { name: 'π¹-Oct', ra: 15.030754, dec: -83.227646, vmag: 5.65 },
  { name: '78-Her', ra: 17.530439, dec: 28.407499, vmag: 5.65 },
  { name: 'κ²-Sgr', ra: 20.398106, dec: -42.422868, vmag: 5.65 },
  { name: 'π-Men', ra: 5.61916, dec: -80.469122, vmag: 5.65 },
  { name: '41-Dra', ra: 18.002526, dec: 80.004095, vmag: 5.65 },
  { name: '31-Ari', ra: 2.610531, dec: 12.447639, vmag: 5.65 },
  { name: '71-Vir', ra: 13.486945, dec: 10.81831, vmag: 5.65 },
  { name: 'π²-Oct', ra: 15.079711, dec: -83.038311, vmag: 5.65 },
  { name: '81-Cet', ra: 2.628278, dec: -3.396175, vmag: 5.65 },
  { name: 'YZ Cas', ra: 0.760862, dec: 74.988073, vmag: 5.65 },
  { name: '4-Com', ra: 12.19755, dec: 25.87028, vmag: 5.65 },
  { name: '26-Aqr', ra: 21.702809, dec: 1.285253, vmag: 5.66 },
  { name: 'ν²-Lup', ra: 15.363507, dec: -48.317628, vmag: 5.66 },
  { name: 'θ-Mus', ra: 13.135321, dec: -65.306023, vmag: 5.66 },
  { name: 'θ-Aps', ra: 14.088903, dec: -76.796752, vmag: 5.66 },
  { name: '57-Aql', ra: 19.910459, dec: -8.227289, vmag: 5.66 },
  { name: '18-Leo', ra: 9.773147, dec: 11.810043, vmag: 5.66 },
  { name: 'V960 Tau', ra: 5.558786, dec: 18.540231, vmag: 5.66 },
  { name: '108-Vir', ra: 14.75839, dec: 0.717271, vmag: 5.66 },
  { name: '33-Vir', ra: 12.772928, dec: 9.539684, vmag: 5.66 },
  { name: '4-Peg', ra: 21.642205, dec: 5.771742, vmag: 5.66 },
  { name: '6-Crv', ra: 12.38933, dec: -24.840669, vmag: 5.66 },
  { name: '63-Ori', ra: 6.082829, dec: 5.41997, vmag: 5.67 },
  { name: 'ε-Sge', ra: 19.621498, dec: 16.462802, vmag: 5.67 },
  { name: '66-Cet', ra: 2.213206, dec: -2.393637, vmag: 5.67 },
  { name: '43-UMa', ra: 10.853067, dec: 56.58225, vmag: 5.67 },
  { name: '13-Tau', ra: 3.705263, dec: 19.700254, vmag: 5.67 },
  { name: 'π²-Hyi', ra: 2.25794, dec: -67.746366, vmag: 5.67 },
  { name: 'σ¹-Cnc', ra: 8.876284, dec: 32.474157, vmag: 5.67 },
  { name: '48-Dra', ra: 18.945851, dec: 57.814851, vmag: 5.67 },
  { name: 'CR UMa', ra: 13.776573, dec: 54.432679, vmag: 5.67 },
  { name: '56-And', ra: 1.935927, dec: 37.25183, vmag: 5.67 },
  { name: '44-And', ra: 1.17188, dec: 42.081475, vmag: 5.67 },
  { name: '80-Tau', ra: 4.502388, dec: 15.63784, vmag: 5.67 },
  { name: '62-Aql', ra: 20.073098, dec: -0.709309, vmag: 5.68 },
  { name: '16-Psc', ra: 23.606468, dec: 2.102222, vmag: 5.68 },
  { name: 'B-Boo', ra: 15.139939, dec: 26.301152, vmag: 5.68 },
  { name: '51-Psc', ra: 0.539939, dec: 6.955463, vmag: 5.68 },
  { name: 'τ¹-Aqr', ra: 22.795213, dec: -14.056428, vmag: 5.68 },
  { name: '20-Com', ra: 12.495344, dec: 20.896109, vmag: 5.68 },
  { name: '29-Com', ra: 12.815059, dec: 14.122584, vmag: 5.68 },
  { name: '35-Gem', ra: 6.840416, dec: 13.413177, vmag: 5.68 },
  { name: '14-Vul', ra: 19.986261, dec: 23.101281, vmag: 5.68 },
  { name: '23-Peg', ra: 22.092964, dec: 28.963981, vmag: 5.68 },
  { name: 'O²-Cnc', ra: 8.959777, dec: 15.581281, vmag: 5.68 },
  { name: '2-Per', ra: 1.869268, dec: 50.792794, vmag: 5.68 },
  { name: '33-Sgr', ra: 18.900025, dec: -21.359845, vmag: 5.69 },
  { name: '2-CVn', ra: 12.268763, dec: 40.66018, vmag: 5.69 },
  { name: '5-And', ra: 23.12926, dec: 49.295776, vmag: 5.69 },
  { name: 'κ²-Cet', ra: 3.35189, dec: 3.67562, vmag: 5.69 },
  { name: '2-Cas', ra: 23.162261, dec: 59.332692, vmag: 5.69 },
  { name: 'δ-Men', ra: 4.299776, dec: -80.214033, vmag: 5.69 },
  { name: 'θ-Del', ra: 20.645552, dec: 13.315125, vmag: 5.69 },
  { name: '5-Pup', ra: 7.799089, dec: -12.192705, vmag: 5.69 },
  { name: 'η¹-Dor', ra: 6.102603, dec: -66.039621, vmag: 5.69 },
  { name: 'RT Aur', ra: 6.476136, dec: 30.493034, vmag: 5.69 },
  { name: '4-Lib', ra: 14.720431, dec: -24.997753, vmag: 5.69 },
  { name: '25-Com', ra: 12.616204, dec: 17.089536, vmag: 5.69 },
  { name: '63-Sgr', ra: 20.032944, dec: -13.637217, vmag: 5.69 },
  { name: '86-UMa', ra: 13.897507, dec: 53.728677, vmag: 5.69 },
  { name: 'δ-Mic', ra: 21.100317, dec: -30.12512, vmag: 5.69 },
  { name: '51-Aur', ra: 6.644317, dec: 39.390854, vmag: 5.69 },
  { name: '79-Cyg', ra: 21.723791, dec: 38.283589, vmag: 5.69 },
  { name: 'ζ-For', ra: 2.993381, dec: -25.274133, vmag: 5.7 },
  { name: '10-Pup', ra: 7.871911, dec: -14.846175, vmag: 5.7 },
  { name: 'C-Psc', ra: 0.041584, dec: 8.485463, vmag: 5.7 },
  { name: 'υ-Gru', ra: 23.114894, dec: -38.892293, vmag: 5.7 },
  { name: '67-Leo', ra: 11.146969, dec: 24.658464, vmag: 5.7 },
  { name: '73-UMa', ra: 12.459754, dec: 55.712724, vmag: 5.7 },
  { name: 'υ¹-Cnc', ra: 8.525145, dec: 24.081105, vmag: 5.7 },
  { name: 'ξ-Phe', ra: 0.69621, dec: -56.501315, vmag: 5.7 },
  { name: 'ν¹-CMa', ra: 6.606347, dec: -18.659904, vmag: 5.7 },
  { name: '38-Cet', ra: 1.246992, dec: -0.973795, vmag: 5.7 },
  { name: '36-Aur', ra: 6.016267, dec: 47.901923, vmag: 5.7 },
  { name: 'τ-Phe', ra: 0.017941, dec: -48.809876, vmag: 5.71 },
  { name: '37-Cap', ra: 21.580848, dec: -20.084274, vmag: 5.71 },
  { name: 'DE Dra', ra: 20.326863, dec: 62.257472, vmag: 5.71 },
  { name: 'η-PsA', ra: 22.013951, dec: -28.453736, vmag: 5.71 },
  { name: '23-And', ra: 0.22524, dec: 41.03537, vmag: 5.71 },
  { name: 'θ-Pav', ra: 18.810538, dec: -65.077679, vmag: 5.71 },
  { name: '3-Per', ra: 1.975973, dec: 49.204352, vmag: 5.71 },
  { name: 'χ²-Hya', ra: 11.099324, dec: -27.287853, vmag: 5.71 },
  { name: '68-Dra', ra: 20.193007, dec: 62.078542, vmag: 5.71 },
  { name: '11-Vir', ra: 12.167616, dec: 5.807008, vmag: 5.71 },
  { name: '45-Tau', ra: 4.188967, dec: 5.523047, vmag: 5.71 },
  { name: 'χ²-For', ra: 3.459281, dec: -35.681323, vmag: 5.71 },
  { name: '15-Ari', ra: 2.177109, dec: 19.500338, vmag: 5.71 },
  { name: '16-Her', ra: 16.257955, dec: 18.808087, vmag: 5.71 },
  { name: '41-Gem', ra: 7.004396, dec: 16.078998, vmag: 5.71 },
  { name: 'υ-Ser', ra: 15.788144, dec: 14.115348, vmag: 5.71 },
  { name: '73-Her', ra: 17.40183, dec: 22.960285, vmag: 5.71 },
  { name: '80-Vir', ra: 13.592027, dec: -5.396191, vmag: 5.71 },
  { name: '55-Per', ra: 4.408098, dec: 34.130758, vmag: 5.71 },
  { name: '30-Cet', ra: 1.129502, dec: -9.78555, vmag: 5.71 },
  { name: 'HV Hya', ra: 8.591166, dec: -7.982292, vmag: 5.71 },
  { name: 'B-UMa', ra: 8.889601, dec: 61.962268, vmag: 5.72 },
  { name: 'V775 Tau', ra: 4.367643, dec: 14.077198, vmag: 5.72 },
  { name: '7-Boo', ra: 13.886925, dec: 17.932868, vmag: 5.72 },
  { name: 'ι¹-Cyg', ra: 19.457212, dec: 52.320436, vmag: 5.72 },
  { name: '19-Ari', ra: 2.217584, dec: 15.27986, vmag: 5.72 },
  { name: '19-Aqr', ra: 21.420285, dec: -9.748552, vmag: 5.72 },
  { name: '3-Leo', ra: 9.474771, dec: 8.188298, vmag: 5.72 },
  { name: 'τ³-Gru', ra: 22.946613, dec: -47.969221, vmag: 5.72 },
  { name: '43-Cyg', ra: 20.450624, dec: 49.383367, vmag: 5.72 },
  { name: '131-Tau', ra: 5.786987, dec: 14.488322, vmag: 5.72 },
  { name: 'ψ-Cnc', ra: 8.174218, dec: 25.507334, vmag: 5.72 },
  { name: 'N¹-Ori', ra: 5.520703, dec: 3.292133, vmag: 5.73 },
  { name: '77-Cyg', ra: 21.706376, dec: 41.077019, vmag: 5.73 },
  { name: 'S Sge', ra: 19.933684, dec: 16.634799, vmag: 5.73 },
  { name: 'EH Eri', ra: 4.565202, dec: -6.738908, vmag: 5.73 },
  { name: 'ζ¹-Mus', ra: 12.370009, dec: -68.307316, vmag: 5.73 },
  { name: '12-Cet', ra: 0.500655, dec: -3.957332, vmag: 5.73 },
  { name: 'γ²-Oct', ra: 23.959159, dec: -82.169804, vmag: 5.73 },
  { name: 'μ-Ari', ra: 2.706094, dec: 20.011465, vmag: 5.73 },
  { name: '15-Hya', ra: 8.859559, dec: -7.177226, vmag: 5.73 },
  { name: '73-Oph', ra: 18.159415, dec: 3.993276, vmag: 5.73 },
  { name: '8-PsA', ra: 21.603046, dec: -26.171516, vmag: 5.73 },
  { name: '59-Hya', ra: 14.977572, dec: -27.657314, vmag: 5.73 },
  { name: '50-Her', ra: 16.844155, dec: 29.806538, vmag: 5.73 },
  { name: '14-Oph', ra: 16.695134, dec: 1.181231, vmag: 5.73 },
  { name: '13-And', ra: 23.45205, dec: 42.91201, vmag: 5.73 },
  { name: 'ι¹-For', ra: 2.602574, dec: -30.044978, vmag: 5.74 },
  { name: '4-Her', ra: 15.925166, dec: 42.566193, vmag: 5.74 },
  { name: '84-Her', ra: 17.722659, dec: 24.327821, vmag: 5.74 },
  { name: '76-Dra', ra: 20.709755, dec: 82.531158, vmag: 5.74 },
  { name: '26-Oph', ra: 17.002641, dec: -24.98907, vmag: 5.74 },
  { name: '8-Leo', ra: 9.617384, dec: 16.437952, vmag: 5.74 },
  { name: '32-UMa', ra: 10.300583, dec: 65.108351, vmag: 5.74 },
  { name: '77-Cet', ra: 2.578507, dec: -7.859445, vmag: 5.74 },
  { name: '53-Aur', ra: 6.639725, dec: 28.984354, vmag: 5.74 },
  { name: '55-Ari', ra: 3.160206, dec: 29.07708, vmag: 5.74 },
  { name: '68-Ori', ra: 6.200372, dec: 19.790543, vmag: 5.74 },
  { name: '1-Lep', ra: 5.045828, dec: -22.795052, vmag: 5.74 },
  { name: '85-Leo', ra: 11.494957, dec: 15.413269, vmag: 5.75 },
  { name: '11-Per', ra: 2.717451, dec: 55.106019, vmag: 5.75 },
  { name: '10-Boo', ra: 13.977479, dec: 21.696219, vmag: 5.75 },
  { name: 'FS Ser', ra: 16.141132, dec: 8.53431, vmag: 5.75 },
  { name: '62-UMa', ra: 11.69286, dec: 31.746058, vmag: 5.75 },
  { name: 'Asterope', ra: 3.765132, dec: 24.554511, vmag: 5.75 },
  { name: '25-Cep', ra: 22.303505, dec: 62.804388, vmag: 5.75 },
  { name: 'γ-Hor', ra: 2.757629, dec: -63.704553, vmag: 5.75 },
  { name: '33-Lyn', ra: 8.578858, dec: 36.419619, vmag: 5.75 },
  { name: 'T-Tau', ra: 3.543319, dec: 9.373438, vmag: 5.75 },
  { name: '30-Com', ra: 12.821516, dec: 27.552379, vmag: 5.75 },
  { name: '47-Gem', ra: 7.189741, dec: 26.856587, vmag: 5.75 },
  { name: '8-Per', ra: 2.29996, dec: 57.89982, vmag: 5.76 },
  { name: '1-Boo', ra: 13.677909, dec: 19.955719, vmag: 5.76 },
  { name: 'RR Ari', ra: 1.930844, dec: 23.577322, vmag: 5.76 },
  { name: '53-Gem', ra: 7.26588, dec: 27.897419, vmag: 5.76 },
  { name: 'ρ¹-Eri', ra: 3.019451, dec: -7.663012, vmag: 5.76 },
  { name: '79-Her', ra: 17.625304, dec: 24.309991, vmag: 5.76 },
  { name: '37-Gem', ra: 6.921853, dec: 25.375697, vmag: 5.76 },
  { name: '66-Vir', ra: 13.40923, dec: -5.16401, vmag: 5.76 },
  { name: '44-Aqr', ra: 22.285139, dec: -5.387164, vmag: 5.76 },
  { name: 'υ-Oct', ra: 22.527168, dec: -85.967253, vmag: 5.76 },
  { name: '50-Aqr', ra: 22.407517, dec: -13.529369, vmag: 5.76 },
  { name: '37-Her', ra: 16.677413, dec: 4.219789, vmag: 5.76 },
  { name: '24-UMi', ra: 17.513056, dec: 86.968047, vmag: 5.76 },
  { name: '57-Hya', ra: 14.799322, dec: -26.646155, vmag: 5.76 },
  { name: 'μ¹-Pav', ra: 20.006418, dec: -66.94936, vmag: 5.76 },
  { name: 'SX Ari', ra: 3.203957, dec: 27.256968, vmag: 5.76 },
  { name: '34-Peg', ra: 22.443718, dec: 4.393766, vmag: 5.76 },
  { name: '89-Leo', ra: 11.572764, dec: 3.060165, vmag: 5.76 },
  { name: '59-Eri', ra: 4.809037, dec: -16.329484, vmag: 5.76 },
  { name: 'Merga', ra: 14.821853, dec: 46.116205, vmag: 5.77 },
  { name: '31-Tau', ra: 3.86673, dec: 6.534907, vmag: 5.77 },
  { name: '21-Psc', ra: 23.824299, dec: 1.076131, vmag: 5.77 },
  { name: 'V2133 Oph', ra: 16.605958, dec: -2.324584, vmag: 5.77 },
  { name: '59-Gem', ra: 7.409292, dec: 27.637857, vmag: 5.77 },
  { name: 'DX Eri', ra: 4.734811, dec: -8.503571, vmag: 5.77 },
  { name: '85-Peg', ra: 0.036139, dec: 27.082256, vmag: 5.77 },
  { name: '19-Lyn', ra: 7.381127, dec: 55.281392, vmag: 5.77 },
  { name: '11-Sco', ra: 16.126782, dec: -12.74541, vmag: 5.77 },
  { name: 'θ²-Mic', ra: 21.406893, dec: -41.006695, vmag: 5.77 },
  { name: '44-Cas', ra: 1.722151, dec: 60.551332, vmag: 5.77 },
  { name: 'ν-Men', ra: 4.349455, dec: -81.57992, vmag: 5.77 },
  { name: '12-And', ra: 23.348123, dec: 38.182326, vmag: 5.77 },
  { name: '48-Hya', ra: 14.000037, dec: -25.010403, vmag: 5.77 },
  { name: 'O-Ari', ra: 2.742493, dec: 15.311862, vmag: 5.77 },
  { name: '10-Ari', ra: 2.060927, dec: 25.935471, vmag: 5.77 },
  { name: '35-Cap', ra: 21.454117, dec: -21.19621, vmag: 5.77 },
  { name: 'HI Aqr', ra: 22.891307, dec: -11.616514, vmag: 5.78 },
  { name: '84-Cet', ra: 2.687222, dec: -0.695653, vmag: 5.78 },
  { name: '51-Aqr', ra: 22.401912, dec: -4.83702, vmag: 5.78 },
  { name: '44-Psc', ra: 0.423391, dec: 1.939692, vmag: 5.78 },
  { name: '22-UMa', ra: 9.581508, dec: 72.205679, vmag: 5.78 },
  { name: '39-UMa', ra: 10.728702, dec: 57.199203, vmag: 5.78 },
  { name: 'λ²-For', ra: 2.616281, dec: -34.577977, vmag: 5.78 },
  { name: '89-Tau', ra: 4.635956, dec: 16.033291, vmag: 5.78 },
  { name: '41-Aur', ra: 6.193496, dec: 48.710989, vmag: 5.78 },
  { name: '45-And', ra: 1.186189, dec: 37.724121, vmag: 5.78 },
  { name: '25-Peg', ra: 22.130641, dec: 21.702926, vmag: 5.78 },
  { name: 'υ-CrB', ra: 16.279107, dec: 29.150261, vmag: 5.78 },
  { name: '3-Gem', ra: 6.162218, dec: 23.113466, vmag: 5.78 },
  { name: 'ζ-Nor', ra: 16.222984, dec: -55.540947, vmag: 5.78 },
  { name: '117-Tau', ra: 5.467114, dec: 17.23913, vmag: 5.78 },
  { name: '35-Aqr', ra: 22.14972, dec: -18.519592, vmag: 5.78 },
  { name: '19-CVn', ra: 13.258882, dec: 40.855199, vmag: 5.78 },
  { name: 'K-Tau', ra: 4.969275, dec: 25.050405, vmag: 5.78 },
  { name: 'C-Aql', ra: 19.483608, dec: 1.950448, vmag: 5.79 },
  { name: '32-LMi', ra: 10.501792, dec: 38.925132, vmag: 5.79 },
  { name: '19-Sextans', ra: 10.213435, dec: 4.61468, vmag: 5.79 },
  { name: '19-Cap', ra: 20.913283, dec: -17.922894, vmag: 5.79 },
  { name: '56-Aql', ra: 19.902299, dec: -8.574211, vmag: 5.79 },
  { name: '17-CMa', ra: 6.917427, dec: -20.404876, vmag: 5.79 },
  { name: 'TX Leo', ra: 10.583933, dec: 8.650425, vmag: 5.79 },
  { name: 'ξ¹-Lib', ra: 14.906354, dec: -11.898348, vmag: 5.79 },
  { name: '52-Peg', ra: 22.986615, dec: 11.728844, vmag: 5.79 },
  { name: '47-Ari', ra: 2.968114, dec: 20.668733, vmag: 5.8 },
  { name: '41-Sextans', ra: 10.838349, dec: -8.897763, vmag: 5.8 },
  { name: '16-Vul', ra: 20.03373, dec: 24.938043, vmag: 5.8 },
  { name: 'K-Vir', ra: 12.99431, dec: -3.811926, vmag: 5.8 },
  { name: '15-Sge', ra: 20.068399, dec: 17.070173, vmag: 5.8 },
  { name: 'τ⁷-Ser', ra: 15.698532, dec: 18.464037, vmag: 5.8 },
  { name: '100-Her', ra: 18.130417, dec: 26.09734, vmag: 5.8 },
  { name: '20-Ari', ra: 2.262789, dec: 25.782937, vmag: 5.8 },
  { name: 'F-Oph', ra: 17.57686, dec: 9.5867, vmag: 5.8 },
  { name: 'C¹-Sco', ra: 16.204456, dec: -28.417305, vmag: 5.8 },
  { name: '56-Per', ra: 4.410404, dec: 33.959686, vmag: 5.8 },
  { name: '15-Aqr', ra: 21.303076, dec: -4.519478, vmag: 5.8 },
  { name: 'HH Peg', ra: 23.855902, dec: 9.313351, vmag: 5.8 },
  { name: '10-And', ra: 23.331225, dec: 42.078044, vmag: 5.81 },
  { name: '1-Cnc', ra: 7.949848, dec: 15.790281, vmag: 5.81 },
  { name: '13-Cep', ra: 21.914766, dec: 56.611227, vmag: 5.81 },
  { name: '99-Tau', ra: 4.963513, dec: 23.948562, vmag: 5.81 },
  { name: 'ζ³-Lib', ra: 15.511223, dec: -16.609464, vmag: 5.81 },
  { name: 'δ³-CMi', ra: 7.571081, dec: 3.371725, vmag: 5.81 },
  { name: '21-Peg', ra: 22.055287, dec: 11.386552, vmag: 5.82 },
  { name: '6-Eri', ra: 2.968258, dec: -23.606012, vmag: 5.82 },
  { name: '8-Vul', ra: 19.482523, dec: 24.768723, vmag: 5.82 },
  { name: 'O-Her', ra: 16.403008, dec: 6.948207, vmag: 5.82 },
  { name: 'RZ Ari', ra: 2.930138, dec: 18.33164, vmag: 5.82 },
  { name: '66-Psc', ra: 0.909785, dec: 19.188417, vmag: 5.82 },
  { name: '39-Leo', ra: 10.287378, dec: 23.10622, vmag: 5.82 },
  { name: '100-Her', ra: 18.130434, dec: 26.10128, vmag: 5.82 },
  { name: '9-Equ', ra: 21.35134, dec: 7.354503, vmag: 5.82 },
  { name: 'X-Her', ra: 17.445623, dec: 48.260065, vmag: 5.83 },
  { name: '38-Cas', ra: 1.520444, dec: 70.264604, vmag: 5.83 },
  { name: '60-Hya', ra: 15.035119, dec: -28.060611, vmag: 5.83 },
  { name: '66-UMa', ra: 11.932892, dec: 56.59856, vmag: 5.83 },
  { name: 'OV Gem', ra: 6.83051, dec: 16.202888, vmag: 5.83 },
  { name: '118-Tau', ra: 5.487916, dec: 25.150215, vmag: 5.83 },
  { name: '5-Gem', ra: 6.192307, dec: 24.420253, vmag: 5.83 },
  { name: 'ψ^9-Aur', ra: 6.942238, dec: 46.273998, vmag: 5.83 },
  { name: 'ξ-Men', ra: 4.980829, dec: -82.470512, vmag: 5.84 },
  { name: '105-Tau', ra: 5.132066, dec: 21.704821, vmag: 5.84 },
  { name: '12-Vir', ra: 12.223872, dec: 10.262341, vmag: 5.84 },
  { name: '40-Ari', ra: 2.808913, dec: 18.28379, vmag: 5.84 },
  { name: 'ι²-For', ra: 2.638515, dec: -30.194062, vmag: 5.84 },
  { name: '4-Ari', ra: 1.803038, dec: 16.955551, vmag: 5.84 },
  { name: 'ρ¹-Cep', ra: 22.445122, dec: 78.785853, vmag: 5.84 },
  { name: '52-Gem', ra: 7.244993, dec: 24.884984, vmag: 5.84 },
  { name: 'LQ Her', ra: 16.193899, dec: 23.494801, vmag: 5.84 },
  { name: 'ξ-Cap', ra: 20.207186, dec: -12.617497, vmag: 5.84 },
  { name: '71-UMa', ra: 12.41756, dec: 56.777828, vmag: 5.85 },
  { name: '38-LMi', ra: 10.65213, dec: 37.91, vmag: 5.85 },
  { name: '12-Mon', ra: 6.538668, dec: 4.855999, vmag: 5.85 },
  { name: '40-Peg', ra: 22.647942, dec: 19.522263, vmag: 5.85 },
  { name: '48-Gem', ra: 7.207327, dec: 24.128594, vmag: 5.85 },
  { name: 'ρ²-Sgr', ra: 19.364137, dec: -18.308388, vmag: 5.85 },
  { name: 'AG Psc', ra: 0.613142, dec: 15.231725, vmag: 5.85 },
  { name: '16-Aqr', ra: 21.351199, dec: -4.560125, vmag: 5.86 },
  { name: 'V927 Sco', ra: 15.910981, dec: -25.243741, vmag: 5.86 },
  { name: '4-Cap', ra: 20.300388, dec: -21.80996, vmag: 5.86 },
  { name: 'ω-Cnc', ra: 8.01552, dec: 25.392836, vmag: 5.86 },
  { name: '6-Lyn', ra: 6.51309, dec: 58.162633, vmag: 5.86 },
  { name: 'ω-Oct', ra: 15.185777, dec: -84.787812, vmag: 5.86 },
  { name: '7-LMi', ra: 9.512006, dec: 33.655711, vmag: 5.86 },
  { name: '18-Lib', ra: 14.98155, dec: -11.144014, vmag: 5.87 },
  { name: 'F-Vir', ra: 12.613154, dec: -5.831898, vmag: 5.87 },
  { name: '5-Aql', ra: 18.77461, dec: -0.961692, vmag: 5.87 },
  { name: '11-Lyn', ra: 6.627332, dec: 56.857531, vmag: 5.87 },
  { name: '65-Vir', ra: 13.388582, dec: -4.924427, vmag: 5.87 },
  { name: '12-Lep', ra: 5.703877, dec: -22.373715, vmag: 5.87 },
  { name: '64-Aur', ra: 7.300616, dec: 40.883392, vmag: 5.88 },
  { name: 'σ²-Gru', ra: 22.616346, dec: -40.591034, vmag: 5.88 },
  { name: '64-Vir', ra: 13.369358, dec: 5.154764, vmag: 5.88 },
  { name: 'ψ-Ser', ra: 15.733839, dec: 2.515173, vmag: 5.88 },
  { name: 'η¹-TrA', ra: 16.689756, dec: -68.296123, vmag: 5.88 },
  { name: '14-Psc', ra: 23.569171, dec: -1.247567, vmag: 5.88 },
  { name: '112-Psc', ra: 2.002544, dec: 3.097015, vmag: 5.88 },
  { name: '47-Aur', ra: 6.500827, dec: 46.685554, vmag: 5.88 },
  { name: 'ε-For', ra: 3.027115, dec: -28.091554, vmag: 5.88 },
  { name: '60-Aqr', ra: 22.567476, dec: -1.57427, vmag: 5.88 },
  { name: '54-Psc', ra: 0.656063, dec: 21.250472, vmag: 5.88 },
  { name: '57-Ori', ra: 5.915746, dec: 19.749614, vmag: 5.89 },
  { name: '30-Lyn', ra: 8.340564, dec: 57.743278, vmag: 5.89 },
  { name: '16-Mon', ra: 6.775671, dec: 8.587153, vmag: 5.89 },
  { name: '44-Cap', ra: 21.717888, dec: -14.399709, vmag: 5.89 },
  { name: '26-CMa', ra: 7.203393, dec: -25.942588, vmag: 5.89 },
  { name: 'A²-Cnc', ra: 8.782227, dec: 12.109952, vmag: 5.89 },
  { name: '27-LMi', ra: 10.385091, dec: 33.908145, vmag: 5.89 },
  { name: 'υ-Aql', ra: 19.761096, dec: 7.613158, vmag: 5.89 },
  { name: '9-Cas', ra: 0.070462, dec: 62.287664, vmag: 5.89 },
  { name: 'V1004 Ori', ra: 5.973456, dec: 1.837108, vmag: 5.89 },
  { name: '20-Vul', ra: 20.200195, dec: 26.478806, vmag: 5.9 },
  { name: 'λ¹-For', ra: 2.551952, dec: -34.649967, vmag: 5.9 },
  { name: '39-Aur', ra: 6.084276, dec: 42.981635, vmag: 5.9 },
  { name: 'O-Cap', ra: 20.498307, dec: -18.583178, vmag: 5.9 },
  { name: '17-Sextans', ra: 10.168761, dec: -8.40817, vmag: 5.9 },
  { name: 'V1286 Aql', ra: 18.979701, dec: 13.906648, vmag: 5.9 },
  { name: '76-Tau', ra: 4.473167, dec: 14.740974, vmag: 5.9 },
  { name: '13-Vir', ra: 12.311199, dec: -0.787184, vmag: 5.9 },
  { name: '57-Sgr', ra: 19.870001, dec: -19.044991, vmag: 5.9 },
  { name: '69-Cyg', ra: 21.429729, dec: 36.667386, vmag: 5.9 },
  { name: '17-Cap', ra: 20.769441, dec: -21.514032, vmag: 5.9 },
  { name: 'ν¹-Lyr', ra: 18.82942, dec: 32.81282, vmag: 5.9 },
  { name: '92-Vir', ra: 13.941077, dec: 1.050581, vmag: 5.9 },
  { name: '26-Boo', ra: 14.542374, dec: 22.260059, vmag: 5.91 },
  { name: 'ζ²-Ant', ra: 9.525601, dec: -31.871831, vmag: 5.91 },
  { name: 'A²-Tau', ra: 4.088958, dec: 22.008905, vmag: 5.91 },
  { name: '42-Cyg', ra: 20.488997, dec: 36.454729, vmag: 5.91 },
  { name: 'σ-For', ra: 3.774286, dec: -29.338157, vmag: 5.91 },
  { name: 'λ-Cnc', ra: 8.34226, dec: 24.022314, vmag: 5.91 },
  { name: '33-LMi', ra: 10.530937, dec: 32.379554, vmag: 5.91 },
  { name: 'λ²-Scl', ra: 0.736683, dec: -38.421686, vmag: 5.91 },
  { name: '13-Tri', ra: 2.480139, dec: 29.93176, vmag: 5.91 },
  { name: '76-Leo', ra: 11.315266, dec: 1.650395, vmag: 5.91 },
  { name: '6-And', ra: 23.174235, dec: 43.544232, vmag: 5.91 },
  { name: 'V360 Lac', ra: 22.839381, dec: 41.953394, vmag: 5.91 },
  { name: 'C-Cnc', ra: 8.61827, dec: 9.65558, vmag: 5.91 },
  { name: '49-Ari', ra: 3.031706, dec: 26.462354, vmag: 5.91 },
  { name: 'ε-Equ', ra: 20.984577, dec: 4.293481, vmag: 5.92 },
  { name: '17-CVn', ra: 13.167563, dec: 38.498981, vmag: 5.92 },
  { name: '62-Psc', ra: 0.804836, dec: 7.299928, vmag: 5.92 },
  { name: 'SS Sextans', ra: 10.390688, dec: -4.074035, vmag: 5.92 },
  { name: '39-Her', ra: 16.693527, dec: 26.91688, vmag: 5.93 },
  { name: '59-Ari', ra: 3.332166, dec: 27.071134, vmag: 5.93 },
  { name: 'V471 Lyr', ra: 19.196114, dec: 31.283456, vmag: 5.93 },
  { name: 'η²-For', ra: 2.837438, dec: -35.843636, vmag: 5.93 },
  { name: 'ζ¹-CrB', ra: 15.656299, dec: 36.635812, vmag: 5.93 },
  { name: '34-Cet', ra: 1.195419, dec: -2.251079, vmag: 5.93 },
  { name: '51-Cam', ra: 7.777793, dec: 65.455676, vmag: 5.93 },
  { name: 'C-Cyg', ra: 19.696945, dec: 50.52506, vmag: 5.93 },
  { name: '26-Cam', ra: 5.775106, dec: 56.115575, vmag: 5.93 },
  { name: 'κ-Crt', ra: 11.452644, dec: -12.356749, vmag: 5.93 },
  { name: 'τ⁵-Ser', ra: 15.608121, dec: 16.119085, vmag: 5.93 },
  { name: 'P³-Leo', ra: 11.060164, dec: -0.000833, vmag: 5.93 },
  { name: 'ψ-For', ra: 2.892885, dec: -38.437004, vmag: 5.94 },
  { name: 'τ-Scl', ra: 1.602361, dec: -29.907317, vmag: 5.94 },
  { name: 'D¹-Cnc', ra: 8.3894, dec: 18.3322, vmag: 5.94 },
  { name: '39-And', ra: 1.048407, dec: 41.345157, vmag: 5.94 },
  { name: '63-Cet', ra: 2.193287, dec: -1.825429, vmag: 5.94 },
  { name: '66-Cnc', ra: 9.023369, dec: 32.252296, vmag: 5.94 },
  { name: '61-Ser', ra: 18.532498, dec: -1.002977, vmag: 5.94 },
  { name: '61-Gem', ra: 7.448981, dec: 20.257557, vmag: 5.94 },
  { name: '55-Leo', ra: 10.928444, dec: 0.736922, vmag: 5.94 },
  { name: '14-Cet', ra: 0.592454, dec: -0.50561, vmag: 5.95 },
  { name: 'Copernicus', ra: 8.876625, dec: 28.330819, vmag: 5.95 },
  { name: '24-Psc', ra: 23.882101, dec: -3.155482, vmag: 5.95 },
  { name: 'κ-Cru', ra: 12.896923, dec: -60.376244, vmag: 5.95 },
  { name: '40-Dra', ra: 18.000944, dec: 80.000841, vmag: 5.95 },
  { name: '8-Lyn', ra: 6.6282, dec: 61.481233, vmag: 5.95 },
  { name: '61-Cet', ra: 2.063381, dec: -0.340251, vmag: 5.95 },
  { name: '58-UMa', ra: 11.508651, dec: 43.173242, vmag: 5.95 },
  { name: '29-Cnc', ra: 8.477039, dec: 14.210822, vmag: 5.95 },
  { name: '45-Cap', ra: 21.733602, dec: -14.74937, vmag: 5.96 },
  { name: 'ι-Cnc', ra: 8.777773, dec: 28.765059, vmag: 5.96 },
  { name: '79-Peg', ra: 23.827608, dec: 28.842389, vmag: 5.96 },
  { name: '87-Psc', ra: 1.235453, dec: 16.133479, vmag: 5.96 },
  { name: '52-Ori', ra: 5.800065, dec: 6.454156, vmag: 5.96 },
  { name: '33-Cet', ra: 1.175987, dec: 2.44567, vmag: 5.96 },
  { name: '61-Cyg', ra: 21.115163, dec: 38.742055, vmag: 5.96 },
  { name: '50-Vir', ra: 13.162578, dec: -10.329327, vmag: 5.96 },
  { name: '6-PsA', ra: 21.537381, dec: -33.944623, vmag: 5.96 },
  { name: '37-Dra', ra: 18.254739, dec: 68.75581, vmag: 5.96 },
  { name: '75-Cnc', ra: 9.146483, dec: 26.629112, vmag: 5.96 },
  { name: '47-Lib', ra: 15.916768, dec: -19.382926, vmag: 5.96 },
  { name: '9-Sgr', ra: 18.064568, dec: -24.36073, vmag: 5.96 },
  { name: '4-Equ', ra: 21.090756, dec: 5.958199, vmag: 5.96 },
  { name: '10-CVn', ra: 12.749852, dec: 39.278916, vmag: 5.96 },
  { name: '38-Com', ra: 13.019337, dec: 17.123147, vmag: 5.96 },
  { name: '10-Vir', ra: 12.161475, dec: 1.897889, vmag: 5.96 },
  { name: '35-Leo', ra: 10.275639, dec: 23.503095, vmag: 5.97 },
  { name: '45-Aqr', ra: 22.316872, dec: -13.304995, vmag: 5.97 },
  { name: '60-Psc', ra: 0.789898, dec: 6.740956, vmag: 5.97 },
  { name: '21-Eri', ra: 3.65031, dec: -5.62621, vmag: 5.97 },
  { name: '74-Dra', ra: 20.490931, dec: 81.091277, vmag: 5.97 },
  { name: '3-Boo', ra: 13.778701, dec: 25.702236, vmag: 5.97 },
  { name: 'HV Peg', ra: 23.461218, dec: 25.167281, vmag: 5.97 },
  { name: '64-Aql', ra: 20.13384, dec: -0.678185, vmag: 5.97 },
  { name: '16-Sgr', ra: 18.253603, dec: -20.387974, vmag: 5.98 },
  { name: '5-Aur', ra: 5.005095, dec: 39.394701, vmag: 5.98 },
  { name: '5-Cnc', ra: 8.02508, dec: 16.455309, vmag: 5.98 },
  { name: '17-Aqr', ra: 21.382293, dec: -9.31933, vmag: 5.98 },
  { name: '57-Cnc', ra: 8.904091, dec: 30.579115, vmag: 5.98 },
  { name: 'VY Leo', ra: 10.933742, dec: 6.185371, vmag: 5.98 },
  { name: '18-Peg', ra: 22.002202, dec: 6.717437, vmag: 5.99 },
  { name: '105-Psc', ra: 1.661338, dec: 16.405858, vmag: 5.99 },
  { name: '52-Cas', ra: 2.047913, dec: 64.901466, vmag: 5.99 },
  { name: 'μ¹-Oct', ra: 20.700731, dec: -76.180592, vmag: 5.99 },
  { name: '129-Tau', ra: 5.779305, dec: 15.822497, vmag: 5.99 },
  { name: 'BL Cnc', ra: 8.10511, dec: 22.63549, vmag: 5.99 },
  { name: 'AN And', ra: 23.306479, dec: 41.773676, vmag: 5.99 },
  { name: 'κ-Hyi', ra: 2.38123, dec: -73.645792, vmag: 5.99 },
  { name: '21-PsA', ra: 22.855817, dec: -29.536309, vmag: 5.99 },
  { name: 'τ-For', ra: 3.646575, dec: -27.943054, vmag: 6 },
  { name: '29-Ari', ra: 2.548372, dec: 15.034554, vmag: 6 },
  { name: '2-Pup', ra: 7.758092, dec: -14.690537, vmag: 6 },
  { name: 'τ⁶-Ser', ra: 15.683083, dec: 16.024588, vmag: 6 },
  { name: 'CX Leo', ra: 10.460831, dec: 9.762396, vmag: 6 },
  { name: 'ε¹-Lyr', ra: 18.738984, dec: 39.670123, vmag: 6 },
  { name: '15-Del', ra: 20.827158, dec: 12.545128, vmag: 6 },
  { name: '44-Gem', ra: 7.088436, dec: 22.637458, vmag: 6 },
  { name: '85-Tau', ra: 4.531043, dec: 15.85156, vmag: 6 },
  { name: 'HX Vir', ra: 13.534114, dec: -18.72888, vmag: 6 },
  { name: 'χ-Per', ra: 2.301275, dec: 57.516321, vmag: 6 },
  { name: '10-Del', ra: 20.687836, dec: 14.58288, vmag: 6.01 },
  { name: '7-Sextans', ra: 9.870045, dec: 2.454131, vmag: 6.01 },
  { name: '11-Ari', ra: 2.113676, dec: 25.704553, vmag: 6.01 },
  { name: '16-Ari', ra: 2.186682, dec: 25.936938, vmag: 6.01 },
  { name: '37-Vir', ra: 12.860247, dec: 3.056788, vmag: 6.01 },
  { name: '76-UMa', ra: 12.692759, dec: 62.713039, vmag: 6.01 },
  { name: 'AX Cam', ra: 8.028465, dec: 60.324353, vmag: 6.01 },
  { name: 'ω²-Aql', ra: 19.331407, dec: 11.534965, vmag: 6.01 },
  { name: '16-Oph', ra: 16.758243, dec: 1.020161, vmag: 6.02 },
  { name: '79-Cnc', ra: 9.172461, dec: 21.996415, vmag: 6.02 },
  { name: '6-Sextans', ra: 9.853898, dec: -4.24335, vmag: 6.02 },
  { name: '51-UMa', ra: 11.075344, dec: 38.241365, vmag: 6.02 },
  { name: '73-Psc', ra: 1.081288, dec: 5.656262, vmag: 6.03 },
  { name: 'UU Psc', ra: 0.249677, dec: 8.820962, vmag: 6.03 },
  { name: '62-Aur', ra: 6.984126, dec: 38.052317, vmag: 6.03 },
  { name: 'VX Psc', ra: 1.498017, dec: 18.355669, vmag: 6.03 },
  { name: '11-Cyg', ra: 19.596751, dec: 36.944539, vmag: 6.03 },
  { name: 'τ¹-Gru', ra: 22.893852, dec: -48.598286, vmag: 6.03 },
  { name: '88-Psc', ra: 1.245109, dec: 6.995136, vmag: 6.03 },
  { name: 'ι-Men', ra: 5.593372, dec: -78.820839, vmag: 6.03 },
  { name: 'AI CVn', ra: 12.396397, dec: 42.542743, vmag: 6.03 },
  { name: 'φ²-Hya', ra: 10.604628, dec: -16.344326, vmag: 6.03 },
  { name: 'AG Cap', ra: 21.771186, dec: -9.275935, vmag: 6.03 },
  { name: 'V817 Tau', ra: 3.951058, dec: 23.17555, vmag: 6.04 },
  { name: 'CX Cnc', ra: 8.476884, dec: 24.144934, vmag: 6.04 },
  { name: '66-Ari', ra: 3.474046, dec: 22.804006, vmag: 6.04 },
  { name: 'HK CMa', ra: 6.783745, dec: -21.015402, vmag: 6.05 },
  { name: 'θ-Ret', ra: 4.294519, dec: -63.255405, vmag: 6.05 },
  { name: 'τ²-Hyi', ra: 1.796291, dec: -80.176311, vmag: 6.05 },
  { name: '24-Cam', ra: 5.71713, dec: 56.581522, vmag: 6.05 },
  { name: '39-Aqr', ra: 22.207155, dec: -14.193957, vmag: 6.05 },
  { name: '67-Cnc', ra: 9.030234, dec: 27.902593, vmag: 6.05 },
  { name: '59-And', ra: 2.181342, dec: 39.039526, vmag: 6.05 },
  { name: 'β-Mic', ra: 20.866322, dec: -33.177974, vmag: 6.05 },
  { name: '44-LMi', ra: 10.831591, dec: 27.973948, vmag: 6.06 },
  { name: '46-Vir', ra: 13.009985, dec: -3.368488, vmag: 6.06 },
  { name: 'ρ-Ind', ra: 22.910981, dec: -70.073709, vmag: 6.06 },
  { name: '6-Equ', ra: 21.175365, dec: 10.048922, vmag: 6.06 },
  { name: '65-Ari', ra: 3.407255, dec: 20.803489, vmag: 6.06 },
  { name: '48-Psc', ra: 0.470195, dec: 16.445065, vmag: 6.06 },
  { name: '8-Aql', ra: 18.856155, dec: -3.317857, vmag: 6.06 },
  { name: '39-Com', ra: 13.105901, dec: 21.153397, vmag: 6.07 },
  { name: 'ζ-Cir', ra: 14.91183, dec: -65.991095, vmag: 6.07 },
  { name: '17-Hya', ra: 8.924891, dec: -7.971153, vmag: 6.07 },
  { name: 'ι²-Lib', ra: 15.221997, dec: -19.647572, vmag: 6.07 },
  { name: '49-Per', ra: 4.137612, dec: 37.727493, vmag: 6.07 },
  { name: '56-Her', ra: 16.917267, dec: 25.730681, vmag: 6.07 },
  { name: '75-UMa', ra: 12.501178, dec: 58.767773, vmag: 6.07 },
  { name: '26-Cet', ra: 1.063619, dec: 1.366846, vmag: 6.07 },
  { name: '55-Cas', ra: 2.241417, dec: 66.524428, vmag: 6.07 },
  { name: 'K-Psc', ra: 0.93292, dec: 27.209381, vmag: 6.07 },
  { name: '7-Tau', ra: 3.574062, dec: 24.464393, vmag: 6.07 },
  { name: '43-Ser', ra: 16.062692, dec: 4.986834, vmag: 6.07 },
  { name: '43-Leo', ra: 10.383458, dec: 6.542643, vmag: 6.08 },
  { name: '76-Cyg', ra: 21.69285, dec: 40.805222, vmag: 6.08 },
  { name: 'W-Eri', ra: 3.904862, dec: -2.95473, vmag: 6.08 },
  { name: 'η-CrB', ra: 15.38663, dec: 30.2862, vmag: 6.08 },
  { name: 'μ²-Cyg', ra: 21.735509, dec: 28.743078, vmag: 6.08 },
  { name: 'κ-Pic', ra: 5.372819, dec: -56.134401, vmag: 6.08 },
  { name: '19-Oph', ra: 16.786043, dec: 2.064526, vmag: 6.08 },
  { name: '8-Gem', ra: 6.271957, dec: 23.970027, vmag: 6.08 },
  { name: 'DG Leo', ra: 9.830582, dec: 21.179422, vmag: 6.08 },
  { name: 'κ¹-Scl', ra: 0.155851, dec: -27.987928, vmag: 6.08 },
  { name: '60-UMa', ra: 11.642645, dec: 46.834209, vmag: 6.09 },
  { name: 'M-Per', ra: 4.556917, dec: 43.063893, vmag: 6.09 },
  { name: '38-Aur', ra: 6.054982, dec: 42.911564, vmag: 6.09 },
  { name: '23-Lyn', ra: 7.680429, dec: 57.082865, vmag: 6.09 },
  { name: '26-And', ra: 0.311712, dec: 43.791141, vmag: 6.09 },
  { name: '39-Ser', ra: 15.886694, dec: 13.196623, vmag: 6.09 },
  { name: 'γ-Ind', ra: 21.437622, dec: -54.660459, vmag: 6.09 },
  { name: 'κ-Her', ra: 16.13471, dec: 17.054382, vmag: 6.09 },
  { name: '27-Cet', ra: 1.093579, dec: -9.979323, vmag: 6.09 },
  { name: '14-Pup', ra: 8.078172, dec: -19.728148, vmag: 6.09 },
  { name: '34-Vir', ra: 12.787123, dec: 11.958088, vmag: 6.1 },
  { name: 'BM Cam', ra: 5.103372, dec: 59.02134, vmag: 6.1 },
  { name: '8-Cam', ra: 4.996204, dec: 53.155451, vmag: 6.1 },
  { name: '110-Tau', ra: 5.393807, dec: 16.699298, vmag: 6.1 },
  { name: '96-Tau', ra: 4.828912, dec: 15.904221, vmag: 6.1 },
  { name: 'ζ-Psc', ra: 1.22924, dec: 7.578261, vmag: 6.1 },
  { name: '38-Vir', ra: 12.886433, dec: -3.553098, vmag: 6.1 },
  { name: 'KW Hya', ra: 9.207234, dec: -7.109827, vmag: 6.1 },
  { name: 'ψ-Crt', ra: 11.208437, dec: -18.499862, vmag: 6.1 },
  { name: '11-Tau', ra: 3.67953, dec: 25.329492, vmag: 6.1 },
  { name: '7-PsA', ra: 21.613553, dec: -33.047896, vmag: 6.11 },
  { name: '72-Vir', ra: 13.507146, dec: -6.470265, vmag: 6.11 },
  { name: 'ω-Phe', ra: 1.033838, dec: -57.002389, vmag: 6.11 },
  { name: 'OX Aur', ra: 6.883725, dec: 38.869157, vmag: 6.11 },
  { name: 'D²-Cnc', ra: 8.430523, dec: 17.046267, vmag: 6.11 },
  { name: '1-Psc', ra: 22.916524, dec: 1.064904, vmag: 6.11 },
  { name: 'XX Psc', ra: 0.787118, dec: 19.578702, vmag: 6.11 },
  { name: 'UW Ari', ra: 3.123798, dec: 17.879995, vmag: 6.11 },
  { name: 'λ¹-Scl', ra: 0.711914, dec: -38.463483, vmag: 6.11 },
  { name: '8-Ser', ra: 15.395475, dec: -1.022384, vmag: 6.11 },
  { name: '68-Aql', ra: 20.473585, dec: -3.357794, vmag: 6.11 },
  { name: '22-Pup', ra: 8.37968, dec: -13.054793, vmag: 6.12 },
  { name: 'θ-Tuc', ra: 0.556463, dec: -71.266246, vmag: 6.12 },
  { name: '18-Sge', ra: 20.272163, dec: 21.5987, vmag: 6.12 },
  { name: 'τ³-Ser', ra: 15.592565, dec: 17.655555, vmag: 6.12 },
  { name: '61-Oph', ra: 17.742804, dec: 2.579441, vmag: 6.12 },
  { name: '13-LMi', ra: 9.711873, dec: 35.093371, vmag: 6.12 },
  { name: '15-Cam', ra: 5.324404, dec: 58.117365, vmag: 6.12 },
  { name: '4-Lyn', ra: 6.367654, dec: 59.372099, vmag: 6.13 },
  { name: '8-Her', ra: 16.146286, dec: 17.205638, vmag: 6.13 },
  { name: '46-Cnc', ra: 8.755951, dec: 30.697752, vmag: 6.13 },
  { name: '36-Psc', ra: 0.276122, dec: 8.240154, vmag: 6.13 },
  { name: '30-Cam', ra: 5.87146, dec: 58.964088, vmag: 6.13 },
  { name: '10-Hya', ra: 8.750356, dec: 5.680588, vmag: 6.13 },
  { name: '14-Tau', ra: 3.72978, dec: 19.665032, vmag: 6.13 },
  { name: '60-Ari', ra: 3.340437, dec: 25.662739, vmag: 6.13 },
  { name: 'τ^8-Ser', ra: 15.745037, dec: 17.264226, vmag: 6.14 },
  { name: 'UU Ari', ra: 2.510671, dec: 19.855301, vmag: 6.14 },
  { name: 'CV Eri', ra: 3.014133, dec: -2.878618, vmag: 6.14 },
  { name: 'AR Aur', ra: 5.305249, dec: 33.767348, vmag: 6.14 },
  { name: 'V474 Mon', ra: 5.983633, dec: -9.382223, vmag: 6.14 },
  { name: 'ν¹-Col', ra: 5.621251, dec: -27.871362, vmag: 6.15 },
  { name: 'BG Ind', ra: 21.975021, dec: -59.01214, vmag: 6.15 },
  { name: '75-Psc', ra: 1.109341, dec: 12.956039, vmag: 6.15 },
  { name: 'O-Lib', ra: 15.350382, dec: -15.548342, vmag: 6.15 },
  { name: '14-Eri', ra: 3.276602, dec: -9.154676, vmag: 6.15 },
  { name: 'γ¹-For', ra: 2.830824, dec: -24.560311, vmag: 6.15 },
  { name: '18-Cet', ra: 0.757969, dec: -12.88081, vmag: 6.15 },
  { name: '43-LMi', ra: 10.815899, dec: 29.416057, vmag: 6.16 },
  { name: 'σ-Hyi', ra: 1.930642, dec: -78.348548, vmag: 6.16 },
  { name: '58-Gem', ra: 7.39115, dec: 22.945349, vmag: 6.16 },
  { name: '13-Cas', ra: 0.52367, dec: 66.519617, vmag: 6.16 },
  { name: 'π¹-Col', ra: 6.111402, dec: -42.298804, vmag: 6.16 },
  { name: '95-Tau', ra: 4.720488, dec: 24.08892, vmag: 6.16 },
  { name: '42-Leo', ra: 10.363973, dec: 14.975773, vmag: 6.16 },
  { name: '2-Com', ra: 12.071277, dec: 21.459153, vmag: 6.16 },
  { name: 'π¹-Gru', ra: 22.378944, dec: -45.947944, vmag: 6.16 },
  { name: '104-Vir', ra: 14.456774, dec: -6.120332, vmag: 6.16 },
  { name: '66-And', ra: 2.46438, dec: 50.569974, vmag: 6.17 },
  { name: 'κ¹-CrA', ra: 18.556413, dec: -38.720033, vmag: 6.17 },
  { name: '28-Lib', ra: 15.348244, dec: -18.158658, vmag: 6.17 },
  { name: '23-Cam', ra: 5.735682, dec: 61.476536, vmag: 6.17 },
  { name: '21-Cet', ra: 0.904887, dec: -8.740662, vmag: 6.17 },
  { name: 'φ²-Cnc', ra: 8.446408, dec: 26.935489, vmag: 6.17 },
  { name: '26-Lib', ra: 15.242711, dec: -17.768572, vmag: 6.17 },
  { name: '21-Cnc', ra: 8.39867, dec: 10.632063, vmag: 6.17 },
  { name: 'π-Ind', ra: 21.937235, dec: -57.899591, vmag: 6.17 },
  { name: '19-Cam', ra: 5.620852, dec: 64.15469, vmag: 6.18 },
  { name: '85-Vir', ra: 13.759741, dec: -15.767467, vmag: 6.18 },
  { name: '19-PsA', ra: 22.706135, dec: -29.361046, vmag: 6.18 },
  { name: '13-Ori', ra: 5.127309, dec: 9.47178, vmag: 6.18 },
  { name: 'FM Aqr', ra: 22.808391, dec: -10.555478, vmag: 6.19 },
  { name: 'η-Oct', ra: 10.987258, dec: -84.593893, vmag: 6.19 },
  { name: '9-LMi', ra: 9.558433, dec: 36.486949, vmag: 6.19 },
  { name: '78-Aqr', ra: 22.909478, dec: -7.204626, vmag: 6.19 },
  { name: '82-Aqr', ra: 23.042377, dec: -6.574008, vmag: 6.19 },
  { name: '14-Sextans', ra: 10.113174, dec: 5.611493, vmag: 6.19 },
  { name: '60-Peg', ra: 23.197001, dec: 26.847308, vmag: 6.19 },
  { name: '32-Lyn', ra: 8.556042, dec: 36.436429, vmag: 6.19 },
  { name: '48-LMi', ra: 10.911714, dec: 25.490722, vmag: 6.2 },
  { name: 'V620 Her', ra: 17.184212, dec: 24.237694, vmag: 6.2 },
  { name: '1-Del', ra: 20.50499, dec: 10.895924, vmag: 6.2 },
  { name: '10-Cet', ra: 0.443726, dec: -0.049533, vmag: 6.2 },
  { name: '16-Gem', ra: 6.465742, dec: 20.49632, vmag: 6.2 },
  { name: '11-Aqr', ra: 21.0094, dec: -4.730261, vmag: 6.2 },
  { name: 'ι-Pic', ra: 4.849036, dec: -53.459698, vmag: 6.2 },
  { name: '97-Her', ra: 18.041709, dec: 22.92323, vmag: 6.2 },
  { name: '1-Ari', ra: 1.835714, dec: 22.275338, vmag: 6.2 },
  { name: '26-Psc', ra: 23.918831, dec: 7.070972, vmag: 6.21 },
  { name: '39-Gem', ra: 6.979839, dec: 26.081079, vmag: 6.21 },
  { name: '26-Sgr', ra: 18.697674, dec: -23.833423, vmag: 6.21 },
  { name: 'τ²-Ser', ra: 15.536021, dec: 16.056169, vmag: 6.21 },
  { name: '101-Psc', ra: 1.596234, dec: 14.661422, vmag: 6.22 },
  { name: 'AV Cet', ra: 1.400705, dec: -8.007416, vmag: 6.22 },
  { name: '54-Aur', ra: 6.6592, dec: 28.263134, vmag: 6.22 },
  { name: '82-Gem', ra: 7.809344, dec: 23.14098, vmag: 6.22 },
  { name: '7-CVn', ra: 12.500815, dec: 51.535631, vmag: 6.22 },
  { name: 'GG Vir', ra: 12.692887, dec: 10.42627, vmag: 6.22 },
  { name: '2-Lib', ra: 14.390452, dec: -11.714043, vmag: 6.22 },
  { name: '44-Cyg', ra: 20.516453, dec: 36.935839, vmag: 6.22 },
  { name: '113-Tau', ra: 5.434923, dec: 16.700161, vmag: 6.22 },
  { name: '8-Com', ra: 12.321998, dec: 23.034673, vmag: 6.23 },
  { name: '11-Boo', ra: 14.01958, dec: 27.386594, vmag: 6.23 },
  { name: '9-Sge', ra: 19.872712, dec: 18.671875, vmag: 6.23 },
  { name: '33-Peg', ra: 22.39432, dec: 20.84823, vmag: 6.23 },
  { name: '81-Aqr', ra: 23.023234, dec: -7.061153, vmag: 6.23 },
  { name: '78-Psc', ra: 1.133701, dec: 32.01213, vmag: 6.23 },
  { name: 'F-Aqr', ra: 22.442853, dec: -16.742138, vmag: 6.23 },
  { name: '3-Psc', ra: 23.01053, dec: 0.185866, vmag: 6.23 },
  { name: '27-Ari', ra: 2.51511, dec: 17.703856, vmag: 6.23 },
  { name: '5-Tri', ra: 2.190283, dec: 31.526398, vmag: 6.23 },
  { name: 'θ-Pic', ra: 5.412858, dec: -52.316245, vmag: 6.24 },
  { name: 'ψ-Aql', ra: 19.742831, dec: 13.302783, vmag: 6.24 },
  { name: '69-Dra', ra: 19.993522, dec: 76.481392, vmag: 6.24 },
  { name: '22-Com', ra: 12.559506, dec: 24.282984, vmag: 6.25 },
  { name: '100-Aqr', ra: 23.528345, dec: -21.369457, vmag: 6.25 },
  { name: '42-Psc', ra: 0.373745, dec: 13.482488, vmag: 6.25 },
  { name: '61-Cnc', ra: 8.966295, dec: 30.233826, vmag: 6.25 },
  { name: '4-Sextans', ra: 9.841689, dec: 4.34365, vmag: 6.25 },
  { name: '74-Peg', ra: 23.627705, dec: 16.825495, vmag: 6.25 },
  { name: 'AO Cap', ra: 20.993372, dec: -19.035283, vmag: 6.25 },
  { name: '2-Sge', ra: 19.406131, dec: 16.937722, vmag: 6.25 },
  { name: '41-Vir', ra: 12.897142, dec: 12.418416, vmag: 6.25 },
  { name: '11-CVn', ra: 12.811617, dec: 48.466838, vmag: 6.25 },
  { name: '27-Cap', ra: 21.159165, dec: -20.556661, vmag: 6.25 },
  { name: '12-Cnc', ra: 8.145124, dec: 13.640917, vmag: 6.25 },
  { name: '55-Dra', ra: 19.162723, dec: 65.978513, vmag: 6.25 },
  { name: '24-Oph', ra: 16.946677, dec: -23.150346, vmag: 6.26 },
  { name: '13-Leo', ra: 9.694024, dec: 25.912876, vmag: 6.26 },
  { name: '33-Sextans', ra: 10.690052, dec: -1.741491, vmag: 6.26 },
  { name: '25-Lyn', ra: 7.90813, dec: 47.385982, vmag: 6.26 },
  { name: 'τ-Pav', ra: 19.274612, dec: -69.190825, vmag: 6.26 },
  { name: '65-Peg', ra: 23.37792, dec: 20.828716, vmag: 6.26 },
  { name: '54-Ari', ra: 3.139197, dec: 18.795053, vmag: 6.26 },
  { name: 'ε-Cnc', ra: 8.67417, dec: 19.544808, vmag: 6.27 },
  { name: '65-Dra', ra: 20.03894, dec: 64.634419, vmag: 6.27 },
  { name: '10-Per', ra: 2.421119, dec: 56.609823, vmag: 6.27 },
  { name: '15-CVn', ra: 13.161676, dec: 38.533885, vmag: 6.27 },
  { name: '9-Psc', ra: 23.454109, dec: 1.122609, vmag: 6.27 },
  { name: 'FP Ser', ra: 15.911188, dec: 8.580337, vmag: 6.27 },
  { name: '108-Tau', ra: 5.257682, dec: 22.284858, vmag: 6.27 },
  { name: '61-Her', ra: 17.058392, dec: 35.414049, vmag: 6.27 },
  { name: '88-Leo', ra: 11.529153, dec: 14.364505, vmag: 6.27 },
  { name: '45-Peg', ra: 22.757827, dec: 19.366561, vmag: 6.28 },
  { name: '57-Her', ra: 16.958624, dec: 25.352841, vmag: 6.28 },
  { name: '36-Sextans', ra: 10.752627, dec: 2.48797, vmag: 6.28 },
  { name: '7-Ser', ra: 15.373122, dec: 12.567521, vmag: 6.28 },
  { name: '25-Psc', ra: 23.884655, dec: 2.090625, vmag: 6.28 },
  { name: 'σ¹-Gru', ra: 22.608139, dec: -40.582689, vmag: 6.28 },
  { name: '1-Cet', ra: 23.972562, dec: -15.847484, vmag: 6.28 },
  { name: '24-Com', ra: 12.5851, dec: 18.377065, vmag: 6.29 },
  { name: 'I-Psc', ra: 0.831433, dec: 27.710286, vmag: 6.29 },
  { name: '20-Vir', ra: 12.5508, dec: 10.295671, vmag: 6.29 },
  { name: '30-Sgr', ra: 18.847359, dec: -22.16219, vmag: 6.29 },
  { name: '109-Psc', ra: 1.748841, dec: 20.083149, vmag: 6.29 },
  { name: '9-Gem', ra: 6.282974, dec: 23.740909, vmag: 6.29 },
  { name: '6-Sgr', ra: 18.023089, dec: -17.156868, vmag: 6.29 },
  { name: 'μ-Tel', ra: 19.50961, dec: -55.110053, vmag: 6.29 },
  { name: '35-LMi', ra: 10.605949, dec: 36.326927, vmag: 6.3 },
  { name: 'ω²-Cnc', ra: 8.028822, dec: 25.089465, vmag: 6.3 },
  { name: '3-Cap', ra: 20.273001, dec: -12.337119, vmag: 6.3 },
  { name: '48-Cyg', ra: 20.625494, dec: 31.57254, vmag: 6.3 },
  { name: 'BO Cnc', ra: 8.874608, dec: 28.259159, vmag: 6.3 },
  { name: '29-Oph', ra: 17.030904, dec: -18.885538, vmag: 6.3 },
  { name: '7-Leo', ra: 9.598024, dec: 14.379588, vmag: 6.3 },
  { name: '8-Lac', ra: 22.597804, dec: 39.628146, vmag: 6.3 },
  { name: '48-Tau', ra: 4.262856, dec: 15.400695, vmag: 6.31 },
  { name: '21-Pup', ra: 8.289759, dec: -16.285111, vmag: 6.31 },
  { name: '35-UMa', ra: 10.498453, dec: 65.626233, vmag: 6.32 },
  { name: '46-Aql', ra: 19.703559, dec: 12.193261, vmag: 6.32 },
  { name: '14-Del', ra: 20.830072, dec: 7.864185, vmag: 6.32 },
  { name: '7-Vul', ra: 19.489138, dec: 20.279737, vmag: 6.32 },
  { name: '53-Sgr', ra: 19.663739, dec: -23.4277, vmag: 6.32 },
  { name: '32-Com', ra: 12.870071, dec: 17.073943, vmag: 6.32 },
  { name: 'X Cae', ra: 5.073931, dec: -35.705109, vmag: 6.32 },
  { name: '41-Peg', ra: 22.663059, dec: 19.681125, vmag: 6.32 },
  { name: '35-Cas', ra: 1.35145, dec: 64.658131, vmag: 6.33 },
  { name: 'F-Aqr', ra: 22.442972, dec: -16.742424, vmag: 6.33 },
  { name: '43-Aur', ra: 6.304684, dec: 46.360443, vmag: 6.33 },
  { name: '31-Psc', ra: 0.040046, dec: 8.956824, vmag: 6.33 },
  { name: '71-Cet', ra: 2.416219, dec: -2.780031, vmag: 6.33 },
  { name: '28-Lyn', ra: 8.119429, dec: 43.260365, vmag: 6.34 },
  { name: '60-Aur', ra: 6.887054, dec: 38.438013, vmag: 6.34 },
  { name: '68-UMa', ra: 12.195806, dec: 57.054408, vmag: 6.34 },
  { name: '62-Tau', ra: 4.399934, dec: 24.300992, vmag: 6.34 },
  { name: '56-Aqr', ra: 22.504819, dec: -14.585734, vmag: 6.34 },
  { name: '37-Hya', ra: 9.66317, dec: -10.570271, vmag: 6.34 },
  { name: 'υ²-Cnc', ra: 8.55003, dec: 24.08479, vmag: 6.35 },
  { name: '57-Aql', ra: 19.910573, dec: -8.237048, vmag: 6.35 },
  { name: 'Kurhah', ra: 22.063135, dec: 64.627971, vmag: 6.35 },
  { name: '20-UMi', ra: 16.208936, dec: 75.210681, vmag: 6.35 },
  { name: '5-Lib', ra: 14.766044, dec: -15.459541, vmag: 6.35 },
  { name: 'ζ-Cae', ra: 4.797104, dec: -30.020372, vmag: 6.35 },
  { name: 'λ-UMi', ra: 17.282569, dec: 89.037708, vmag: 6.35 },
  { name: '77-Psc', ra: 1.097008, dec: 4.908372, vmag: 6.35 },
  { name: '41-UMa', ra: 10.772919, dec: 57.365914, vmag: 6.35 },
  { name: 'ξ¹-Cap', ra: 20.199416, dec: -12.392403, vmag: 6.36 },
  { name: 'τ¹-Hyi', ra: 1.689256, dec: -79.1482, vmag: 6.36 },
  { name: '42-Cet', ra: 1.330082, dec: -0.509029, vmag: 6.36 },
  { name: '4-Aqr', ra: 20.857152, dec: -5.626633, vmag: 6.36 },
  { name: '9-CVn', ra: 12.646189, dec: 40.874662, vmag: 6.36 },
  { name: '50-LMi', ra: 10.942897, dec: 25.500244, vmag: 6.36 },
  { name: '80-Leo', ra: 11.430571, dec: 3.86011, vmag: 6.36 },
  { name: 'BU Gem', ra: 6.205305, dec: 22.908514, vmag: 6.37 },
  { name: '8-Pup', ra: 7.861358, dec: -12.819405, vmag: 6.37 },
  { name: '54-Cnc', ra: 8.850407, dec: 15.350651, vmag: 6.37 },
  { name: '39-Cnc', ra: 8.66845, dec: 20.007788, vmag: 6.37 },
  { name: '47-Cam', ra: 7.37144, dec: 59.901996, vmag: 6.37 },
  { name: '19-Gem', ra: 6.527065, dec: 15.903501, vmag: 6.38 },
  { name: '20-Aqr', ra: 21.414354, dec: -3.398357, vmag: 6.38 },
  { name: '9-Com', ra: 12.324873, dec: 28.156916, vmag: 6.39 },
  { name: 'χ¹-For', ra: 3.432177, dec: -35.920885, vmag: 6.39 },
  { name: '34-Hya', ra: 9.630974, dec: -9.424446, vmag: 6.39 },
  { name: '3-Com', ra: 12.175453, dec: 16.809271, vmag: 6.39 },
  { name: 'BE Cet', ra: 0.381051, dec: -12.209438, vmag: 6.39 },
  { name: '40-Gem', ra: 6.991092, dec: 25.914171, vmag: 6.39 },
  { name: '58-Aqr', ra: 22.528144, dec: -10.905561, vmag: 6.39 },
  { name: '13-Psc', ra: 23.532657, dec: -1.085885, vmag: 6.39 },
  { name: '32-Cet', ra: 1.169985, dec: -8.906135, vmag: 6.4 },
  { name: '67-Aqr', ra: 22.720629, dec: -6.962937, vmag: 6.4 },
  { name: '36-Ari', ra: 2.738642, dec: 17.763928, vmag: 6.4 },
  { name: '26-Vul', ra: 20.602316, dec: 25.882648, vmag: 6.41 },
  { name: '24-Aql', ra: 19.314151, dec: 0.339024, vmag: 6.41 },
  { name: '5-Per', ra: 2.191443, dec: 57.645543, vmag: 6.41 },
  { name: '22-Tau', ra: 3.767472, dec: 24.527898, vmag: 6.42 },
  { name: '17-Dra', ra: 16.603812, dec: 52.924422, vmag: 6.42 },
  { name: '24-Mon', ra: 7.255391, dec: -0.161283, vmag: 6.43 },
  { name: '3-UMi', ra: 14.115681, dec: 74.593781, vmag: 6.43 },
  { name: '34-Her', ra: 16.501681, dec: 48.96109, vmag: 6.43 },
  { name: '39-Peg', ra: 22.543187, dec: 20.230019, vmag: 6.43 },
  { name: '25-Gem', ra: 6.689138, dec: 28.196638, vmag: 6.43 },
  { name: '34-Leo', ra: 10.193947, dec: 13.355114, vmag: 6.44 },
  { name: 'ζ-PsA', ra: 22.514936, dec: -26.073752, vmag: 6.44 },
  { name: '13-Sextans', ra: 10.069009, dec: 3.201055, vmag: 6.44 },
  { name: '22-Aur', ra: 5.389686, dec: 28.936761, vmag: 6.44 },
  { name: 'ψ^8-Aur', ra: 6.899187, dec: 38.505018, vmag: 6.44 },
  { name: '28-Peg', ra: 22.175051, dec: 20.977984, vmag: 6.44 },
  { name: '70-Tau', ra: 4.427032, dec: 15.94101, vmag: 6.44 },
  { name: '14-Mon', ra: 6.579533, dec: 7.572482, vmag: 6.45 },
  { name: 'μ²-Oct', ra: 20.695508, dec: -75.350803, vmag: 6.45 },
  { name: '35-Vir', ra: 12.797614, dec: 3.572716, vmag: 6.45 },
  { name: '19-Leo', ra: 9.790546, dec: 11.568165, vmag: 6.45 },
  { name: '28-Com', ra: 12.803982, dec: 13.553018, vmag: 6.46 },
  { name: '23-Leo', ra: 9.850551, dec: 13.066239, vmag: 6.46 },
  { name: '18-Cam', ra: 5.542707, dec: 57.221071, vmag: 6.46 },
  { name: '30-Ari', ra: 2.61681, dec: 24.647222, vmag: 6.46 },
  { name: 'BC Cam', ra: 7.774289, dec: 62.830522, vmag: 6.47 },
  { name: '7-Lyn', ra: 6.575777, dec: 55.353042, vmag: 6.47 },
  { name: '96-Vir', ra: 14.150165, dec: -10.334546, vmag: 6.47 },
  { name: '16-Cas', ra: 0.573583, dec: 66.750351, vmag: 6.47 },
  { name: '83-Leo', ra: 11.445923, dec: 3.013102, vmag: 6.47 },
  { name: '23-Lib', ra: 15.224637, dec: -25.309347, vmag: 6.47 },
  { name: '13-PsA', ra: 22.073288, dec: -29.91653, vmag: 6.47 },
  { name: '6-Aur', ra: 5.006449, dec: 39.654653, vmag: 6.47 },
  { name: '34-Cnc', ra: 8.544409, dec: 10.066008, vmag: 6.47 },
  { name: '32-Gem', ra: 6.765055, dec: 12.693561, vmag: 6.47 },
  { name: '24-LMi', ra: 10.274469, dec: 28.682479, vmag: 6.47 },
  { name: '64-Leo', ra: 11.127696, dec: 23.323762, vmag: 6.47 },
  { name: '22-LMi', ra: 10.251762, dec: 31.468066, vmag: 6.48 },
  { name: '17-Vir', ra: 12.375566, dec: 5.305444, vmag: 6.48 },
  { name: 'V2125 Oph', ra: 17.588472, dec: -22.043822, vmag: 6.48 },
  { name: '14-Cam', ra: 5.225353, dec: 62.691132, vmag: 6.48 },
  { name: 'V823 Her', ra: 16.868014, dec: 14.974215, vmag: 6.49 },
  { name: 'π¹-Cnc', ra: 9.204878, dec: 14.996037, vmag: 6.49 },
  { name: '18-Aur', ra: 5.323261, dec: 33.985421, vmag: 6.5 },
  { name: 'θ-Phe', ra: 23.657761, dec: -46.637799, vmag: 6.5 },
  { name: '61-Peg', ra: 23.262858, dec: 28.247898, vmag: 6.51 },
  { name: '43-Cet', ra: 1.376342, dec: -0.449673, vmag: 6.51 },
  { name: '14-Ser', ra: 15.609364, dec: -0.561531, vmag: 6.51 },
  { name: '5-PsA', ra: 21.484372, dec: -31.238559, vmag: 6.51 },
  { name: 'η¹-For', ra: 2.79271, dec: -35.550621, vmag: 6.51 },
  { name: '61-Psc', ra: 0.798562, dec: 20.925346, vmag: 6.52 },
  { name: '79-Gem', ra: 7.752593, dec: 20.316045, vmag: 6.52 },
  { name: 'θ-Sge', ra: 20.165735, dec: 20.915028, vmag: 6.53 },
  { name: '65-Sgr', ra: 20.090649, dec: -12.665163, vmag: 6.53 },
  { name: '37-Cnc', ra: 8.63477, dec: 9.57461, vmag: 6.53 },
  { name: '29-Cam', ra: 5.842745, dec: 56.918938, vmag: 6.53 },
  { name: '28-UMa', ra: 9.765382, dec: 63.653313, vmag: 6.53 },
  { name: 'χ³-For', ra: 3.469867, dec: -35.853426, vmag: 6.53 },
  { name: '42-Aur', ra: 6.29296, dec: 46.423953, vmag: 6.53 },
  { name: 'λ-Men', ra: 5.796706, dec: -72.70225, vmag: 6.53 },
  { name: 'Mira', ra: 2.322442, dec: -2.977643, vmag: 6.54 },
  { name: '25-Sgr', ra: 18.575767, dec: -24.222393, vmag: 6.55 },
  { name: '35-Cnc', ra: 8.588735, dec: 19.590063, vmag: 6.57 },
  { name: '29-Hya', ra: 9.454067, dec: -9.223712, vmag: 6.57 },
  { name: 'κ¹-Boo', ra: 14.224385, dec: 51.787868, vmag: 6.58 },
  { name: 'O-Oph', ra: 17.300169, dec: -24.284111, vmag: 6.59 },
  { name: '17-Lib', ra: 14.970392, dec: -11.15476, vmag: 6.6 },
  { name: 'ι²-Mus', ra: 13.455154, dec: -74.691755, vmag: 6.61 },
  { name: 'μ²-Cha', ra: 10.068706, dec: -81.565492, vmag: 6.62 },
  { name: 'TZ Tri', ra: 2.206191, dec: 30.303067, vmag: 6.62 },
  { name: '39-Boo', ra: 14.828143, dec: 48.720804, vmag: 6.63 },
  { name: 'RS Sextans', ra: 10.350557, dec: 2.289724, vmag: 6.64 },
  { name: 'ε-Dra', ra: 19.80285, dec: 70.26793, vmag: 6.64 },
  { name: 'λ¹-Tuc', ra: 0.873477, dec: -69.503764, vmag: 6.65 },
  { name: 'σ-CrB', ra: 16.244599, dec: 33.856722, vmag: 6.66 },
  { name: 'O-Cap', ra: 20.497941, dec: -18.586378, vmag: 6.66 },
  { name: '70-Cnc', ra: 9.069408, dec: 27.898304, vmag: 6.66 },
  { name: 'PV Pup', ra: 7.757981, dec: -14.686167, vmag: 6.7 },
  { name: '12-Sextans', ra: 9.995301, dec: 3.384792, vmag: 6.7 },
  { name: '59-And', ra: 2.181575, dec: 39.043286, vmag: 6.71 },
  { name: 'θ¹-Ori', ra: 5.588111, dec: -5.38768, vmag: 6.71 },
  { name: '19-Lyn', ra: 7.38079, dec: 55.28432, vmag: 6.71 },
  { name: '48-Vir', ra: 13.065117, dec: -3.663143, vmag: 6.71 },
  { name: '25-Sco', ra: 16.780929, dec: -25.52857, vmag: 6.73 },
  { name: 'DW Eri', ra: 4.726318, dec: -8.794317, vmag: 6.74 },
  { name: 'π-Aql', ra: 19.811683, dec: 11.815896, vmag: 6.75 },
  { name: '6-Mon', ra: 6.29309, dec: -10.724988, vmag: 6.76 },
  { name: 'V744 Her', ra: 17.834259, dec: 48.394152, vmag: 6.76 },
  { name: '54-Vir', ra: 13.224121, dec: -18.826406, vmag: 6.78 },
  { name: '1-Cam', ra: 4.533845, dec: 53.91083, vmag: 6.81 },
  { name: '24-Cnc', ra: 8.444387, dec: 24.534166, vmag: 6.9 },
  { name: '36-Her', ra: 16.676431, dec: 4.207203, vmag: 6.9 },
  { name: 'ζ¹-Ant', ra: 9.512804, dec: -31.889222, vmag: 6.92 },
  { name: '65-UMa', ra: 11.919813, dec: 46.469782, vmag: 6.97 },
  { name: '30-Ari', ra: 2.616037, dec: 24.648063, vmag: 6.97 },
  { name: '41-Aqr', ra: 22.238342, dec: -21.074566, vmag: 7 },
  { name: '35-Sextans', ra: 10.722478, dec: 4.747669, vmag: 7.02 },
  { name: '12-Lyn', ra: 6.770595, dec: 59.44167, vmag: 7.03 },
  { name: 'μ²-Boo', ra: 15.40858, dec: 37.3473, vmag: 7.03 },
  { name: '20-Dra', ra: 16.94036, dec: 65.039124, vmag: 7.04 },
  { name: '40-Sextans', ra: 10.821465, dec: -4.02393, vmag: 7.04 },
  { name: 'σ-Cas', ra: 23.983482, dec: 55.754928, vmag: 7.05 },
  { name: '31-Cap', ra: 21.30435, dec: -17.462266, vmag: 7.06 },
  { name: 'DX Aqr', ra: 22.040625, dec: -16.964836, vmag: 7.12 },
  { name: 'λ-Oct', ra: 21.848413, dec: -82.718904, vmag: 7.13 },
  { name: '77-Psc', ra: 1.097622, dec: 4.90941, vmag: 7.21 },
  { name: '90-Leo', ra: 11.57847, dec: 16.796915, vmag: 7.33 },
  { name: '3-Peg', ra: 21.628643, dec: 6.629052, vmag: 7.47 },
  { name: '12-Aqr', ra: 21.067979, dec: -5.823066, vmag: 7.48 },
  { name: 'χ-Cyg', ra: 19.842757, dec: 32.914058, vmag: 7.99 },
  { name: 'DN UMa', ra: 11.918263, dec: 46.476846, vmag: 8.31 },
  { name: 'π-Cap', ra: 20.455336, dec: -18.211721, vmag: 8.53 },
];
